export default {
  authenticatedUser: null,
  token: null,
  error: null,
  permissions: [],
  language: localStorage.getItem("language") || "en",
  translations: {
    en: {
      cultivableArea: "Total farmable area (ha)",
      other: "Other",
      confirmation_wihout_qr:
        "Are you sure you want to finish without a QR code? Subsamples will not be considered; only the issues will be recorded.",
      finish_sampling_without_qr: "Finish without QR",
      advice_not_project:
        "It is necessary to create a project to access the territory",
      created_project: "Created",
      no_project: "No project",
      click_map_add_item: "Click on the map to add an item",
      add_problems: "Add issues",
      no_problem_info_defined: "No issue information has been defined",
      define_problem: "Define issue",
      edit_problem: "Edit issue",
      not_defined: "Not defined",
      problem: "Issue",
      avocado_plague_list: {
        unknown: "Unknown",
        oligonychus_yothersi: "Toasting mite (Oligonychus yothersi)",
        oligonychus_perseae: "Crystalline spider mite (Oligonychus perseae)",
        oligonychus_punicae: "Avocado red spider mite (Oligonychus punicae)",
        oligonychus_mexicanus:
          "Mexican red spider mite (Oligonychus mexicanus)",
        copturus_aguacatae: "Branch borer (Copturus aguacatae)",
        heilipus_lauri: "Large seed borer (Heilipus lauri)",
        conotrachelus_aguacatae: "Small seed borer (Conotrachelus aguacatae)",
        idona_minuenda: "Avocado leafhopper (Idona minuenda)",
        empoasca_abrupta: "Green leafhopper (Empoasca abrupta)",
        hemiberlesia_lataniae: "Latania scale (Hemiberlesia lataniae)",
        pyrrhopyge_chalybea: "Confetti worm (Pyrrhopyge chalybea)",
        gonodonta_pyrgo: "Leaf/fruit worm (Gonodonta pyrgo)",
        sabulodes_aegrotata: "False measuring worm (Sabulodes aegrotata)",
        copaxa_multifenestrata: "Burning worm (Copaxa multifenestrata)",
        amorbia_cuneana: "Webworm (Amorbia cuneana)",
        gracillaria_spp: "Leaf miner (Gracillaria spp.)",
        aleurodes_sp: "Common whitefly (Aleurodes sp.)",
        tetraleurodes_perseae: "Red-banded whitefly (Tetraleurodes perseae)",
        aleurodicus_dugesii: "Giant whitefly (Aleurodicus dugesii)",
        bemisia_argentifolii: "Silverleaf whitefly (Bemisia argentifolii)",
        paraleyrodes_perseae: "Powdery whitefly (Paraleyrodes perseae)",
        aethalion_quadratum: "Avocado green fly (Aethalion quadratum)",
        stenoma_catenifer: "Seed borer moth (Stenoma catenifer)",
        metcalfiella_monograma: "Avocado parakeet (Metcalfiella monograma)",
        trioza_anceps: "Gall psyllid (Trioza anceps)",
        neohydatothrips_signifer: "Striped thrips (Neohydatothrips signifer)",
        pseudophilothrips_perseae: "Gall thrips (Pseudophilothrips perseae)",
        heliothrips_haemorrhoidalis:
          "Greenhouse thrips (Heliothrips haemorrhoidalis)",
        scirtothrips_perseae: "Avocado thrips (Scirtothrips perseae)",
        frankliniella_bruneri: "Black thrips (Frankliniella bruneri)",
        frankliniella_occidentalis:
          "Western flower thrips (Frankliniella occidentalis)",
        tetranychus_urticae: "Red spider mite (Tetranychus urticae)",
        liriomyza_sp: "Leaf miner (Liriomyza sp.)",
        tuta_absoluta: "Tomato leaf miner / Tomato moth (Tuta absoluta)",
        aphis_sp_green: "Green aphid (Aphis sp.)",
        diaphorina_citri: "Asian citrus psyllid (Diaphorina citri)",
        spodoptera_frugiperda: "Fall armyworm (Spodoptera frugiperda)",
        keiferia_lycopersicella: "Tomato pinworm (Keiferia lycopersicella)",
        helicoverpa_zea: "Corn earworm / Tomato fruitworm (Helicoverpa zea)",
        heliothis_virescens: "Tobacco budworm (Heliothis virescens)",
        trichoplusia_ni: "Cabbage looper (Trichoplusia ni)",
        manduca_quinquemaculata: "Tomato hornworm (Manduca quinquemaculata)",
        spodoptera_exigua: "Beet armyworm (Spodoptera exigua)",
        liriomyza_spp: "Leafminer fly (Liriomyza spp)",
        cydia_pomonella: "Codling moth (Cydia pomonella)",
        phthorimaea_operculella: "Potato tuber moth (Phthorimaea operculella)",
        heliothis_zea: "Corn earworm (Heliothis zea)",
        pectinophora_gossypiella: "Pink bollworm (Pectinophora gossypiella)",
        bucculatrix_thurberiella:
          "Cotton leaf perforator (Buccolatrix thurberiella)",
        estigmene_acrea: "Saltmarsh caterpillar (Estigmene acrea)",
        copitarsia_consueta: "Cabbage heartworm (Copitarsia consueta)",
        plutella_xylostella: "Diamondback moth (Plutella xylostella)",
        liriomyza_munda: "Leaf miner (Liriomyza munda)",
        manduca_sexta: "Tobacco hornworm (Manduca sexta)",
        diatraea_grandiosella:
          "Southwestern corn borer (Diatraea grandiosella)",
        carpocapsa_pomonella: "Apple moth (Carpocapsa pomonella)",
        aeneolamia_contigua: "Spittlebug (Aeneolamia contigua)",
        other: "Other",
      },
      avocado_disease_list: {
        unknown: "Unknown",
        damping_off: "Damping-off (Pythium sp.)",
        anthracnose_classic:
          "Classic anthracnose (Colletotrichum gloeosporioides)",
        anthracnose_boninense:
          "Boninense complex anthracnose (Colletotrichum boninense)",
        bacterial_canker: "Bacterial canker (Xanthomonas sp.)",
        sooty_mold: "Sooty mold (Capnodium sp.)",
        angular_leaf_spot: "Angular leaf spot (Cercospora purpurea)",
        tar_spot: "Tar spot (Phyllachora gratissima)",
        leaf_spot_septoria: "Leaf spot (Septoria sp.)",
        black_spot: "Black spot (Diplocarpon rosae)",
        fusarium_wilt: "Fusarium wilt (Fusarium sp.)",
        root_rot_rhizoctonia: "Root rot (Rhizoctonia solani)",
        fruit_rot_diplodia: "Fruit rot, Diplodia (Diplodia sp.)",
        fruit_rot_dothiorella: "Fruit rot, Dothiorella (Dothiorella sp.)",
        scab: "Avocado scab (Sphaceloma perseae)",
        avocado_root_rot:
          "Avocado root rot / Avocado decline (Phytophthora cinnamomi)",
        botrytis_cinerea: "Moho Gris / Botritis (Botrytis cinerea)",
        cladosporium_fulvum: "Moho de la hoja del tomate (Cladosporium fulvum)",
        colletotrichum_acutatum: "Antracnosis (Colletotrichum acutatum)",
        glomerella_cingulata: "Antracnosis (Glomerella cingulata)",
        monilia_spp: "Pudrición del fruto, Monilia spp. (Monilia spp.)",
        mycosphaerella_fragariae: "Mancha Púrpura (Mycosphaerella fragariae)",
        peronospora_rubi: "Mildiú Velloso de la Zarzamora (Peronospora rubi)",
        other: "Other",
      },
      avocado_weeds_list: {
        chenopodium_album: "Lamb's quarters (Chenopodium album)",
        equisetum_spp: "Horsetail (Equisetum spp.)",
        eleusine_indica: "Goosegrass (Eleusine indica)",
        convolvulus_arvensis: "Field bindweed (Convolvulus arvensis)",
        euphorbia_prostrata: "Prostrate spurge (Euphorbia prostrata)",
        rumex_crispus: "Curly dock (Rumex crispus)",
        sorghum_halepense: "Johnson grass (Sorghum halepense)",
        setaria_verticillata: "Bristly foxtail (Setaria verticillata)",
        cyperus_rotundus: "Purple nutsedge (Cyperus rotundus)",
        other: "Other",
      },
      avocado_nutrition: {
        nitrogen: "Nitrogen (N)",
        zinc: "Zinc (Zn)",
        iron: "Iron (Fe)",
        potassium: "Potassium (K)",
        boro: "Boro (B)",
        other: "Other",
      },
      plague: "Plague",
      disease: "Disease",
      weed: "Weed",
      nutrition: "Nutritional Deficiencies",
      specific_problem: "Specific issue",
      problem_type: "Issue type",
      problem_info: "Issue information",
      soil: "Soil",
      longitudeRange: "Longitude must be between -180 and 180",
      latitudeRange: "Latitude must be between -90 and 90",
      bothFieldsRequired: "Both fields (latitude and longitude) are required",
      additionalDetails: "Additional details",
      descriptionSaved: "Description saved",
      projectEndDate: "Project end date",
      tentativeFieldSamplingDate: "Tentative field sampling date",
      commercialStartDate: "Commercial launch date",
      importantDates: "Important dates",
      noCrop: "No crop",
      targetCrops: "Target crop(s)",
      agriculturalDetails: "Farm details",
      responsible: "Project Manager",
      notSpecified: "Not specified",
      projectType: "Project type",
      generalInformation: "General information",
      enterCoordinates:
        "Enter the image coordinates or locate the point by clicking on the map",
      selectImage: "Select image(s)",
      addMultipleSubsamples: "Add multiple subsamples",
      imagePreview: "Image preview",
      deleteSubsample: "Delete subsample",
      centerSubsample: "Center subsample",
      relocate: "Relocate",
      images_without_metadata: "Images without metadata (will not be uploaded)",
      subsample_outside_polygon: "Subsample outside the polygon",
      image_load_error: "Something went wrong while loading the image",
      add_multiple_subsamples: "Add multiple subsamples",
      sampling_date: "Sampling date",
      updated_information: "Updated information",
      current_package: "Current package",
      select_sampling_type: "Select sampling type",
      update_sample_data: "Update sample data",
      label_new_farm: "New farm/company",
      general_description: "Overview",
      request_guide_dialog_content:
        "The guide request was sent, your guide will be sent to your email.",
      request_guide_dialog_title: "Guide request",
      request_guide_label: "Request return guide",
      label_total_samples: "Total samples in kit",
      origin_zip_code_label: "Origin zip code",
      selectKitType: "Select the type of kit",
      kitType: "Kit type",
      send_label: "Send",
      request_guide_title: "Request guide",
      selectIrrigationSystem: "Select the irrigation system",
      label_longitude: "Longitude",
      label_latitude: "Latitude",
      label_no_evidence: "No evidence",
      label_evidence: "Evidence",
      label_actions: "Actions",
      label_image: "Image",
      label_sampling_date: "Sampling Date",
      label_coordinates: "Coordinates",
      label_center: "Center",
      label_select_image: "Select image",
      label_add_image: "Add image",
      label_add_version: "Add version",
      label_name_or_code_profitability: "Name or Code of profits",
      label_no_profitability: "No profits",
      label_sample: "Sample",
      label_origin_postal_code: "Origin postal code",
      label_add_sample: "Add sample",
      label_clear_list: "Clear list",
      label_use: "Use",
      label_active_ingredient: "Active ingredient",
      label_product_name_brand: "Product name (brand)",
      label_at_least_one_sample: "There must be at least one sample",
      label_compost_type: "Type of compost",
      label_analysis_type: "Type of analysis",
      label_without_crop: "Without crop",
      label_with_crop: "With crop",
      label_relogin: "Please log in again",
      label_session_expired: "Session expired",
      label_new_sample: "New sample",
      label_phone: "Phone",
      label_last_name: "Last name",
      label_basic_information: "Basic information",
      label_profile: "Profile",
      label_application_removed: "Application removed",
      label_add_application: "Add application",
      label_applications: "Applications",
      label_product: "Product",
      label_sample_without_advisor: "Sample without advisor",
      label_substrate_sample: "Substrate sample",
      label_product_sample: "Product sample",
      label_compost_sample: "Compost sample",
      label_plant_sample_without_reference: "Plant sample without reference",
      label_soil_sample: "Soil sample",
      label_genomic_plant_sample: "Genomic plant sample",
      label_genomic_sample: "Genomic sample",
      label_project_detail: "Project detail",
      label_project_created: "Project created",
      label_project_updated: "Project updated",
      label_add_at_least_one_item: "Add at least 1 item",
      label_add_product: "Add product",
      label_objective: "Target",
      label_active_ingredient: "Active ingredient",
      label_add_application: "Add application",
      label_application_added: "Application added",
      label_dose: "Dose",
      label_add_product: "Add product",
      label_add_phenological_stage: "Add phenological stage",
      label_select_irrigation_unit: "Select sampling zone(s)",
      label_contrast_a: "Contrast A",
      label_contrast_b: "Contrast B",
      label_select_variant: "Select variant",
      label_select_project_type: "Select project type",
      label_agricultural_units: "Sampling zones",
      label_project_information: "Project information",
      label_create_project: "Create project",
      label_update_project: "Update project",
      label_no_projects: "No projects",
      label_add_producer_company: "Add Farms/Companies",
      label_search_folio: "Search folio",
      label_no_results: "No results",
      label_projects: "Projects",
      label_download_sampling_app: "Download sampling app",
      label_no_georeference: "No georeference",
      label_profitability: "Profits",
      label_fungi: "Fungi",
      label_bacteria: "Bacteria",
      label_cellulolytic_activity: "Cellulolytic activity",
      label_siderophores: "Siderophores",
      label_potassium_solubilization: "Potassium (K) solubilization",
      label_phosphorus_solubilization: "Phosphorus (P) solubilization",
      label_negative_control: "Negative control",
      label_nutrition: "Nutrition",
      label_control: "Control",
      label_soil_disease_control: "Soil disease control",
      label_no_not_detected: "No non-detected",
      label_beneficial: "Beneficial",
      label_pathogen: "Pathogen",
      label_type: "Type",
      label_not_detected: "Not detected",
      label_no_pathogens: "No pathogens",
      label_soil_pathogen_detection: "Soil pathogen detection",
      label_no_beneficials: "No beneficials",
      label_concentration: "Concentration",
      label_taxonomic_identification: "Taxonomic identification",
      label_microorganism: "Microorganism",
      label_soil_beneficials_of_interest: "Beneficials of interest in soil",
      label_biological_capital_measurement: "Biological capital measurement",
      label_soil_texture: "Soil texture",
      label_carbon_capture_pox: "Carbon capture (POX)",
      label_organic_matter: "Organic matter",
      label_soil_health_parameters: "Soil health parameters",
      label_irrigation_unit: "Sampling zone",
      label_analysis_detail: "Analysis detail",
      label_analysis_in_progress: "Analysis in progress",
      label_not_available: "Not available",
      label_next_result_date: "Next result date",
      label_analysis_results: "Analysis results",
      label_close: "Close",
      label_subsample_photos: "Subsample photos",
      label_polygon_not_available: "Polygon not available",
      label_sample_detail: "Sample detail",
      label_measurement: "Measurement",
      label_valuation: "Valuation",
      label_valuated: "Valuated",
      label_valuating: "Valuating",
      label_measured: "Measured",
      label_measuring: "Measuring",
      label_sent: "Sent",
      label_received: "Received",
      label_sampling_finished: "Sampling finished",
      label_detail: "Detail",
      label_analysis_folio: "Analysis folio",
      label_status: "Status",
      label_apply: "Apply",
      label_advanced_filters: "Advanced filters",
      label_no_samples: "No samples",
      label_samples_list: "Samples list",
      label_at_least_one_sample_required: "At least one sample must exist",
      label_sample_already_completed: "The sample was already completed",
      label_enter_a_valid_folio: "Enter a valid folio",
      label_enter_an_unregistered_folio: "Enter an unregistered folio",
      label_sample_successfully_registered: "Sample successfully registered",
      label_browser_lacks_features: "The browser seems to lack features",
      label_requested_front_camera_although_none_available:
        "Did you request the front camera even though there is none available?",
      label_camera_may_be_in_use: "The camera may already be in use",
      label_page_not_served_over_https_or_localhost:
        "The page is not served over HTTPS (or localhost)",
      label_no_suitable_camera_device_installed:
        "No suitable camera device installed",
      label_user_denied_camera_access_permission:
        "User denied camera access permission",
      label_finish_sampling: "Finish sampling",
      label_finish_with_scanner: "Finish with scanner",
      label_search_qr: "Search QR...",
      label_qr_not_found: "QR not found",
      label_sick_plot: "Sick plot",
      label_sample_description: "Sample description",
      label_plant_sample_type: "Plant sample type",
      label_sampling_type: "Sampling type",
      label_select_package: "Select package",
      label_sample_type: "Sample type",
      label_phonological_stage: "Phenological stage",
      label_number_of_subsamples: "Number of subsamples",
      label_delete_subsamples: "Delete subsamples",
      label_add_subsamples: "Add subsamples",
      label_finish_sampling: "Finish sampling",
      label_not_applicable: "Not applicable",
      label_no_areas: "No areas",
      label_no_agronomic_management: "No agronomic management",
      label_territory_list: "Territory list",
      label_at_least_one_item_required: "At least one item must be selected",
      label_agronomic_management_saved: "Agronomic management saved",
      label_crop_cycle_ended:
        "The crop cycle has ended. Do you want to enter a new one?",
      label_new_crop_cycle: "New crop cycle",
      label_add_area_with_highest_problem_severity:
        "Add area with highest problem severity",
      label_previous_cycle: "Previous cycle",
      label_problems_detected: "Problems detected",
      label_select_tonnage_unit: "Select tonnage unit",
      label_tonnage: "Tonnage",
      label_average_yield_per_hectare_acre:
        "What is the average yield per hectare/acre?",
      label_list_of_inputs_applied_during_crop_cycle:
        "List of inputs applied during the crop cycle",
      label_cycle_end: "Cycle end",
      label_cycle_start: "Cycle start",
      label_variety_optional: "Variety (optional)",
      label_select_crop: "Select a crop",
      label_crop_cycle: "Crop cycle",
      label_description: "Description",
      label_crop_success_definition: "Definition of crop success",
      label_what_is_your_agricultural_management_practice:
        "What is your agricultural management practice?",
      label_select_shadow_type: "Select shadow type",
      label_confirm_delete_area: "Are you sure you want to delete this area?",
      label_delete_area: "Delete area",
      label_area_deleted: "Area deleted",
      label_cannot_delete_area_with_samples:
        "Cannot delete an area with samples",
      label_days: "Days",
      label_on_hold: "On pause",
      label_soil_of: "Soil of",
      label_crop_of: "Crop of",
      label_sterile: "Sterile",
      label_redraw: "Redraw",
      label_qr_invalid: "QR invalid",
      label_qr_registered: "QR registered",
      label_sampling_in_progress: "Sampling in progress",
      label_sampling_not_started: "Sampling not started",
      label_add_crop: "Add crop",
      label_name: "Name",
      label_enter_agronomic_management_before_sampling:
        "Enter agronomic management before sampling (Required)",
      label_rename: "Rename",
      label_add_area: "Add area",
      label_cultivation_area_name: "Crop zone name",
      label_confirm_edit_agronomic_management:
        "Are you sure you want to edit the agronomic management of the area?",
      label_agronomic_management: "Agronomic management",
      label_management: "Management",
      label_take_sample: "Take sample",
      label_results: "Results",
      label_draw: "Draw",
      label_repeat: "Repeat",
      label_back: "Back",
      label_territory: "Territory",
      label_prospect_created: "Prospect created",
      label_prospect_updated: "Prospect updated",
      label_new_prospect: "New prospect",
      label_update_prospect: "Update prospect",
      label_update_prospect: "Update prospect",
      label_no_zone_assigned_prospect:
        "No zone assigned to the prospect, do you want to continue?",
      label_contact_last_name: "Contact last name",
      label_removed_from_favorites: "Removed from favorites",
      label_added_to_favorites: "Added to favorites",
      label_make_client: "Make client",
      label_distributor_change_successful: "Distributor change successful",
      label_client_created: "Farm/Company created",
      label_client_updated: "Farm/Company updated",
      label_no_zone_assigned:
        "No zone assigned to the prospect, do you want to continue?",
      label_logout_confirmation: "Are you sure you want to log out?",
      label_confirmation: "Confirmation",
      label_state: "State",
      label_city: "City",
      label_country: "Country",
      label_neighborhood: "Neighborhood",
      label_interior_number: "Interior number",
      label_exterior_number: "Exterior number",
      label_postal_code: "Postal code",
      label_street: "Street",
      label_update_client: "Update farm/company",
      label_address: "Address",
      label_rfc: "Tax ID",
      label_phone: "Phone",
      label_contact_name: "Contact name",
      label_zone: "Zone",
      label_contact_information: "Contact information",
      label_company_name: "Company name",
      label_client_created: "Farm/Company created",
      advice_error: "Something went wrong, please try again",
      label_update: "Update",
      advice_not_prospects: "Not yet",
      advice_no_clients: "Not yet",
      label_clients: "Farms/Companies",
      label_prospects: "Draft",
      valid_email_required: "You must enter a valid email",
      select_distributor: "Select distributor",
      search: "Search...",
      field_required: "The field is required",
      email_label: "email",
      label_continue: "Continue",
      enter_email: "Enter your email address",
      forget_password_title: "Forgot your password",
      send_email_password:
        "An email has been sent to your email address to change your password",
      error_changing_password: "Error trying to change password",
      login_error_check_info: "Error logging in, please check your information",
      label_download_pdf: "Download PDF",
      label_client_accept: "Accepted by the client",
      download_sampling_app: "Download sampling app",
      home_menu_label_change_dis: "Change distributor",
      change_language: "Change language",
      download_app: "Download Solena Explore Sampling App",
      forgot_your_password: "Forgot your password?",
      app_name: "Solena Explore",
      navigation_drawer_open: "Navigation Drawer Open",
      navigation_drawer_close: "Close Navigation Drawer",
      nav_header_title: "Android Studio",
      nav_header_desc: "Navigation Header",
      action_samples: "Samples",
      menu_territory: "Territory",
      menu_samples: "Samples",
      menu_log_out: "Log Out",
      app_name_splash: "Solena (Beta) 1.3.6",
      description_logo: "Solena Logo",
      prompt_email: "User",
      prompt_password: "Password",
      action_sign_in: "Sign In",
      action_sign_in_short: "Sign In",
      welcome: "Welcome",
      invalid_username: "Invalid email",
      invalid_password: "Incorrect password",
      login_failed: "Login failed",
      fill_fields: "Fill both fields",
      user_not_saved: "User not saved on device",
      user_wrong: "Try accessing from the Solena Explore Web app",
      sample_photo_activity_title: "Sample Photo",
      detail_sample_activity_title: "Soil Sampling",
      image_capture_failed: "Image capture failed",
      error_to_upload_photo: "Error uploading photo, try again",
      area_update_failure: "Area update failed",
      area_update_db_failure: "Failed to save photo, try again",
      captured_image: "Subsample",
      location_wrong: "Loading location, please wait",
      folio_wrong: "Error saving sample",
      wrong_folio_length: "Folio must be 14 digits",
      detecting_QR: "Finish Sampling",
      area_name: "Area Name",
      area_length: "Area: 100 ha",
      perimeter: "Perimeter: 3,544.91 m",
      repeat: "Repeat",
      accept: "Accept",
      photo_needed: "No samples to register",
      connection_needed: "No internet connection",
      address_needed: "Complete your profile and address information.",
      area_updated_fail: "Area update failed",
      failed_sync: "Area sync failed:",
      area_server_update_fail: "Area changes upload failed",
      samples_taken: "Sampling complete, you can finish now",
      areas_update_async_successful: "Data synchronized successfully",
      areas_update_async_successful_errors: "Data synchronized with errors",
      local_area_failure: "Area update on device failed",
      NOT_ASSIGNED: "NOT ASSIGNED",
      NOT_STARTED: "Ready to sample",
      COMPLETED: "COMPLETED",
      IN_PROGRESS: "Sampling in progress",
      INACCESSIBLE: "INACCESSIBLE",
      NOT_VALID: "NOT VALID",
      VALIDATED: "VALIDATED",
      VALIDATION_PENDING: "VALIDATION PENDING",
      area: "Area",
      perimeter_: "Perimeter:",
      started_sample: "Sampling start",
      enter_area: "Can you enter the sampling area?",
      not: "No",
      yes: "Yes",
      suggested_points: "TARGET POINTS",
      sample_taken: "Samples:",
      elapsed_time: "Sampling time:",
      waiting_map: "Fixing position...",
      photo_error: "Error uploading image, try again",
      api_error: "Server error:",
      conecction_error:
        "Connection error, waiting for connection to update areas",
      shipment_label: "Soil sample shipment",
      shipment_question: "Generate guide for sample shipment?",
      input_folio: "Enter sample Folio",
      folio: "Folio",
      cancel: "Cancel",
      delete: "Delete",
      finish: "Finish",
      title_dialog_finish: "Send sample",
      warning_qr: "Invalid QR, enter manually",
      not_permissions_qr: "No camera permissions",
      qr_foto_error: "Error finishing sampling, try again",
      offline: "No internet, offline mode",
      online: "Internet connection restored",
      syncing_area: "Synchronizing data, please wait...",
      no_internet: "Ensure you are connected to the internet",
      connection_lost: "Internet connection lost",
      acept: "Accept",
      porcentage_photo: "/100",
      areas: "Areas: ",
      photoCountAsync: "Photos:",
      landUse: "Land Use",
      landUse_list: {
        sterile: "Sterile",
        cropLand: "Crop Land",
      },
      irrigations_list: {
        drip: "Drip",
        pivot: "Pivot",
        wheeled: "Flood",
        microspray: "Micro-Spray",
        "without irrigation": "Without Irrigation",
      },
      shadow_type: {
        "Shade cloth": "Shade cloth",
        Greenhouse: "Greenhouse",
        "Open field": "Open field",
        Macrotunnel: "Macrotunnel",
      },
      management_practices: {
        TILLAGE: "Reduced tillage",
        CROP_ROTATION: "Crop Rotation",
        COMPOST_APPLY: "Compost Application",
        CROP_COVER: "Cover Crops",
        PEST_MANAGEMENT: "Integrated Pest Management",
        OTHER: "Other",
        NONE: "None",
      },
      propagation_method: {
        graft: "Graft",
        frank: "Seedling",
      },
      agroinputs: {
        inputWeed: "Weed Control",
        inputPest: "Pest Control (insects)",
        inputPhytopathogen: "Phytopathogen Control",
        inputConditioner: "Soil Conditioner",
        inputFungi: "Fungal Inoculants",
        inputBacteria: "Bacterial Inoculants",
        inputAlgae: "Algae-based Inoculants",
      },
      agroinputs_descriptions: {
        inputWeed: "Weed Control - Product Name (optional)",
        inputPest: "Pest Control (insects) - Product Name (optional)",
        inputPhytopathogen: "Phytopathogen Control - Product Name (optional)",
        inputConditioner:
          "Soil Conditioner - e.g., fulvic acids, humic acids, agricultural lime, etc.",
        inputFungi: "Fungal Inoculants - e.g., Trichoderma, etc.",
        inputBacteria: "Bacterial Inoculants - e.g., Pseudomonas, etc.",
        inputAlgae: "Algae-based Inoculants - e.g., Ascophyllum, etc.",
      },
      tonnageUnits: {
        HECTARE: "Hectare",
        ACRE: "Acre",
      },
      issueList: {
        salinity: "Salinity",
        soilCompaction: "Soil Compaction",
        alkalinity: "Alkaline Soil (pH > 7.0)",
        acidity: "Acidic Soil (pH < 6)",
        heavyMetals: "Heavy Metals in Soil",
        recurrentDiseases: "Recurrent Diseases",
        percentageOrganicMatter: "Low Organic Matter in Soil (< 1 %)",
        other: "Other",
      },
      phenologicalStages: {
        Transplanting: "Transplanting",
        "Vegetative growth": "Vegetative Growth",
        Bloom: "Bloom",
        Harvest: "Harvest",
        "Pre-planting": "Pre-planting",
        Sowing: "Sowing",
        Sprout: "Sprout",
        Tuberization: "Tuberization",
        "Tuber filling": "Tuber Filling",
        "Foliage development": "Foliage Development",
        "Foliar expansion": "Foliar Expansion",
        "First leaf": "First Leaf",
        "Third leaf": "Third Leaf",
        "Fifth leaf": "Fifth Leaf",
        "Start of bulbing": "Start of Bulbing",
        "Bulb growth": "Bulb Growth",
        "Fruit maturity": "Fruit Maturity",
        Sprouting: "Sprouting",
      },
      analysisTypes: {
        INITIAL: "Initial",
        MONITORING: "Monitoring",
      },
      samplingType: {
        CLASSIC: "Soil Sampling",
        MAS_VEGETABLE: "Vegetal Sampling",
      },
      kitTypes: {
        CLASSIC: "Traditional",
        HYBRID: "Hybrid",
        QPCR: "QPCR",
      },
      vegetalSampleTypes: {
        Seedling: "Seedling",
        Root: "Root",
        Seed: "Seed",
        Stem: "Stem",
        Leaf: "Leaf",
        Fruit: "Fruit",
        Flower: "Flower",
      },
      status_samples: {
        ALL: "All",
        IN_PROGRESS: "In Progress",
        VALIDATED: "Validated",
        RECEIVED: "Received",
        MEASURING: "Measuring",
        MEASURED: "Measured",
        VALUATING: "Valuating",
        VALUATED: "Valuated",
      },
      symp: {
        Clorosis: "Chlorosis",
        "Leaf spots": "Leaf spots",
        Necrosis: "Necrosis",
        Wilting: "Wilting",
        Dwarfism: "Dwarfism",
        "Early wilting": "Early wilting",
        "Root rot": "Root rot",
        "Performance reduction": "Performance reduction",
        "Plant Chlorosis": "Plant Chlorosis",
        "Plant with spots on the leaves": "Plant with spots on the leaves",
        "Plant with necrosis": "Plant with necrosis",
        "Healthy plant": "Healthy plant",
        "Leaf top with chlorosis": "Leaf top with chlorosis",
        "Leaf top with spots": "Leaf top with spots",
        "Leaf top with necrosis": "Leaf top with necrosis",
        "Leaf top with wilting": "Leaf top with wilting",
        "Leaf top healthy": "Leaf top healthy",
        "Leaf middle with chlorosis": "Leaf middle with chlorosis",
        "Leaf middle with spots": "Leaf middle with spots",
        "Leaf middle with necrosis": "Leaf middle with necrosis",
        "Leaf middle with wilting": "Leaf middle with wilting",
        "Leaf middle healthy": "Leaf middle healthy",
        "Leaf lower with chlorosis": "Leaf lower with chlorosis",
        "Leaf lower with spots": "Leaf lower with spots",
        "Leaf lower with necrosis": "Leaf lower with necrosis",
        "Leaf lower with wilting": "Leaf lower with wilting",
        "Leaf lower healthy": "Leaf lower healthy",
        "Stem with dwarfism": "Stem with dwarfism",
        "Early wilting stem": "Early wilting stem",
        "Stem with necrosis": "Stem with necrosis",
        "Healthy stem": "Healthy stem",
        "Root rot": "Root rot",
        "Root with necrosis": "Root with necrosis",
        "Healthy root": "Healthy root",
        "Fruit with reduced yield": "Fruit with reduced yield",
        "Fruit with necrosis": "Fruit with necrosis",
        "Healthy fruit": "Healthy fruit",
      },
      symp_avocado: {
        "Regressive death": "Regressive death",
        Defoliation: "Defoliation",
        Cancer: "Cancer",
        Chlorosis: "Chlorosis",
        "Limb drying": "Limb drying",
        "Sooty mold": "Sooty mold",
        "Drying with attached leaves": "Drying with attached leaves",
        Galling: "Galling",
        "Leaf Spots": "Leaf Spots",
        "Trunk Canker": "Trunk Canker",
        "Peduncle Ringing (Fruit)": "Peduncle Ringing (Fruit)",
        "Root Rot": "Root Rot",
        Healthy: "Healthy",
      },
      symp_blackberry_raspberry: {
        Chlorosis: "Chlorosis",
        Wilting: "Wilting",
        "Leaf spots": "Leaf spots",
        "Stem streaking": "Stem streaking",
        Defoliation: "Defoliation",
        Blight: "Blight",
        Galling: "Galling",
        "Growth delay": "Growth delay",
        "Base Stem Girdling": "Base Stem Girdling",
        "Root Rot": "Root Rot",
        Healthy: "Healthy",
      },
      symp_strawberry: {
        Wilting: "Wilting",
        "Leaf spots": "Leaf spots",
        "Crown rot": "Crown rot",
        Defoliation: "Defoliation",
        Chlorosis: "Chlorosis",
        "Growth delay": "Growth delay",
        "Base Stem Girdling": "Base Stem Girdling",
        "Reddish Spots on Leaf Edges": "Reddish Spots on Leaf Edges",
        "Root Rot": "Root Rot",
        Healthy: "Healthy",
      },
      symp_blueberry: {
        Wilting: "Wilting",
        "Basal rot": "Basal rot",
        "Leaf spots": "Leaf spots",
        Blight: "Blight",
        Chlorosis: "Chlorosis",
        "Growth delay": "Growth delay",
        "Crown Gall or Tumor": "Crown Gall or Tumor",
        "Base Stem Girdling": "Base Stem Girdling",
        "Root Rot": "Root Rot",
        Healthy: "Healthy",
      },
      symp_orange: {
        "Chlorosis (Yellowing)": "Chlorosis (Yellowing)",
        "Dieback (Downward)": "Dieback (Downward)",
        "Defoliation (Premature leaf drop)":
          "Defoliation (Premature leaf drop)",
        "Root Rot": "Root Rot",
        Healthy: "Healthy",
      },
      symp_chili_peppers_cucumber_tomato: {
        "Chlorosis (Yellowing)": "Chlorosis (Yellowing)",
        "Leaf Spots": "Leaf Spots",
        "Dieback (Downward)": "Dieback (Downward)",
        "Wilting / Stem or Leaf Flaccidity":
          "Wilting / Stem or Leaf Flaccidity",
        "Root Gall (Nematodes)": "Root Gall (Nematodes)",
        "Base Stem Girdling": "Base Stem Girdling",
        "Blight (Chlorosis and/or Shoot Drying)":
          "Blight (Chlorosis and/or Shoot Drying)",
        "Growth Retardation": "Growth Retardation",
        "Root Rot": "Root Rot",
        "Stem Spots": "Stem Spots",
        Healthy: "Healthy",
      },
      symp_potato: {
        "Chlorosis (Yellowing)": "Chlorosis (Yellowing)",
        "Leaf Spots": "Leaf Spots",
        "Wilting / Stem or Leaf Flaccidity":
          "Wilting / Stem or Leaf Flaccidity",
        "Root Gall (Nematodes)": "Root Gall (Nematodes)",
        "Base Stem Girdling": "Base Stem Girdling",
        "Blight (Chlorosis and/or Shoot Drying)":
          "Blight (Chlorosis and/or Shoot Drying)",
        "Growth Retardation": "Growth Retardation",
        "Root Rot": "Root Rot",
        "Tuber Necrosis / Rot": "Tuber Necrosis / Rot",
        "Scab / Tuber Scab": "Scab / Tuber Scab",
        "Black Scab Tuber": "Black Scab Tuber",
        "Stem Spots": "Stem Spots",
        Healthy: "Healthy",
      },
      symp_asparagus: {
        "Chlorosis (Yellowing)": "Chlorosis (Yellowing)",
        "Dieback (Downward)": "Dieback (Downward)",
        "Root Gall (Nematodes)": "Root Gall (Nematodes)",
        "Blight (Chlorosis and/or Shoot Drying)":
          "Blight (Chlorosis and/or Shoot Drying)",
        "Growth Retardation": "Growth Retardation",
        "Crown Rot": "Crown Rot",
        "Root Rot": "Root Rot",
        "Stem Spots": "Stem Spots",
        "Bud Scaling": "Bud Scaling",
        "Purple/Pink Spear Discoloration": "Purple/Pink Spear Discoloration",
        Healthy: "Healthy",
      },
      moTypes: {
        bacteria: "Bacteria",
        fungi: "Fungi",
        nematode: "Nematode",
      },
      status_projects: {
        NEW: "New",
        PROCESSING: "Processing",
        IN_REVIEW: "In Review",
        IN_PROGRESS: "In Progress",
        FINISHED: "Completed",
        ACCEPTED: "Accepted",
      },
      miss_test_variants: {
        CONTRAST: "Contrast",
        UNCONTRASTED: "Uncontrasted",
        RASTER: "Raster",
      },
      miss_test_variants_setup: {
        CONTRAST: "Control",
        UNCONTRASTED: "No control",
      },
      compotition_types: {
        LIQUID: "Liquid",
        SOLID: "Solid",
      },
      sampleTypeNotGeo: {
        COMPOST: "Compost",
        PRODUCT: "Product",
        SUBSTRATUM: "Substratum",
        VEGETABLE: "Vegetable without georeference",
      },
      sampleTypeNotGeoAll: {
        COMPOST: "Compost",
        PRODUCT: "Product",
        SUBSTRATUM: "Substratum",
        VEGETABLE: "Vegetable without georeference",
        SOLENA_NO_ADVISOR: "Client without advisor",
      },
      status_profits: {
        ALL: "All",
        NEW: "New",
        PROPOSAL: "Proposal",
        ACCEPTED: "Accepted",
        FINISHED: "Finished",
      },
      agronomic_managment_title: "Agronomic Management",
      crop_name: "Crop Name",
      start_cycle: "Start Cycle",
      end_cycle: "End Cycle",
      is_organic: "Organic Management",
      seed_brand: "Seed Brand",
      save: "Save",
      hint_date: "Date",
      crop_name_list: {
        olive: "Olive",
        chard: "Chard",
        achiote: "Achiote",
        agave: "Agave",
        avocado: "Avocado",
        garlic: "Garlic",
        sesame: "Sesame",
        basil: "Basil",
        artichoke: "Artichoke",
        alcatraz: "Alcatraz",
        shrunkenAlfalfa: "Shrunken Alfalfa",
        greenAlfalfa: "Green Alfalfa",
        cotton: "Cotton",
        almond: "Almond",
        birdseed: "Birdseed",
        amaranth: "Amaranth",
        anise: "Anise",
        celery: "Celery",
        blueberry: "Blueberry",
        myrtle: "Myrtle",
        rice: "Rice",
        greenForageOats: "Green Forage Oats",
        oatGrain: "Oat Grain",
        bamboo: "Bamboo",
        eggplant: "Eggplant",
        beetroot: "Beetroot",
        broccoli: "Broccoli",
        peanut: "Peanut",
        cocoa: "Cocoa",
        cherryCoffee: "Cherry Coffee",
        pumpkin: "Pumpkin",
        sweetPotato: "Sweet Potato",
        sugarCane: "Sugar Cane",
        canola: "Canola",
        carambolo: "Carambola",
        safflower: "Safflower",
        barley: "Barley",
        greenForageBarley: "Green Forage Barley",
        onion: "Onion",
        chives: "Chives",
        ryeGrain: "Rye Grain",
        cherry: "Cherry",
        chabacano: "Apricot",
        pea: "Pea",
        squash: "Squash",
        chia: "Chia",
        chilacayote: "Chilacayote",
        chillyPepper: "Chili / Pepper",
        custardApple: "Custard Apple",
        coriander: "Coriander",
        plum: "Plum",
        coconutFruit: "Coconut Fruit",
        cabbage: "Cabbage",
        brusselsSprouts: "Brussels Sprouts",
        cauliflower: "Cauliflower",
        cumin: "Cumin",
        chrysanthemum: "Chrysanthemum",
        peach: "Peach",
        date: "Date",
        greenBean: "Green Bean",
        cornCob: "Corn Cob",
        dill: "Dill",
        epazote: "Epazote",
        asparagus: "Asparagus",
        spicesAndMedicinals: "Spices and Medicinals",
        spinach: "Spinach",
        raspberry: "Raspberry",
        strawberry: "Strawberry",
        bean: "Bean",
        chickpea: "Chickpea",
        sunflower: "Sunflower",
        pomegranate: "Pomegranate",
        soursop: "Soursop",
        guava: "Guava",
        henequen: "Henequen",
        peppermint: "Peppermint",
        aromaticHerbs: "Aromatic Herbs",
        fig: "Fig",
        jamaica: "Hibiscus",
        ginger: "Ginger",
        jicama: "Jicama",
        lettuce: "Lettuce",
        lentil: "Lentil",
        lime: "Lime",
        lemon: "Lemon",
        linseed: "Linseed",
        litchi: "Lychee",
        corn: "Corn",
        macadamia: "Macadamia",
        maguey: "Maguey",
        mamey: "Mamey",
        tangerine: "Tangerine",
        mango: "Mango",
        mangosteen: "Mangosteen",
        chamomile: "Chamomile",
        appleTree: "Apple Tree",
        passionFruit: "Passion Fruit",
        daisyFlower: "Daisy",
        marjoram: "Marjoram",
        melon: "Melon",
        quince: "Quince",
        mint: "Mint",
        moringa: "Moringa",
        turnip: "Turnip",
        nanche: "Nanche",
        napa: "Napa",
        orange: "Orange",
        medlar: "Medlar",
        nochebuena: "Christmas Eve Plant",
        walnut: "Walnut",
        noni: "Noni",
        nopal: "Nopal",
        oregano: "Oregano",
        ornamental: "Ornamental",
        orchid: "Orchid",
        oilPalm: "Oil Palm",
        potato: "Potato",
        papaya: "Papaya",
        grasslands: "Grasslands",
        matGrass: "Mat Grass",
        pasturesAndMeadows: "Pastures and Meadows",
        cucumber: "Cucumber",
        pearTree: "Pear Tree",
        parsley: "Parsley",
        peron: "Peron",
        persimony: "Persimony",
        pepper: "Pepper",
        pineapple: "Pineapple",
        pinion: "Pine Nut",
        pistache: "Pistachio",
        pitaya: "Pitaya",
        banana: "Banana",
        pore: "Pore",
        radish: "Radish",
        rambutan: "Rambutan",
        romerito: "Romero",
        rosemary: "Rosemary",
        aloe: "Aloe",
        watermelon: "Watermelon",
        sorghum: "Sorghum",
        soy: "Soy",
        stevia: "Stevia",
        tobacco: "Tobacco",
        tamarind: "Tamarind",
        tejocote: "Tejocote",
        tomato: "Red Tomato",
        greenTomato: "Green Tomato",
        thyme: "Thyme",
        grapefruit: "Grapefruit",
        clover: "Clover",
        wheat: "Wheat",
        dutchTulip: "Dutch Tulip",
        tuna: "Prickly Pear",
        grape: "Grape",
        vanilla: "Vanilla",
        purslane: "Purslane",
        vine: "Vine",
        cassavaFood: "Cassava",
        carrot: "Carrot",
        sapodilla: "Sapodilla",
        blackberry: "Blackberry",
        zempoalxochitl: "Zempoalxochitl",
        fallow: "Fallow",
        "pecan nut": "Pecan Nut",
        roses: "Roses",
        "faba bean": "Faba Bean",
        chestnut: "Chestnut",
        other: "Other",
      },
      select_land_use: "Select a land use",
      select_irrigation_system: "Select an irrigation system",
      fill_up_fields: "Fill all fields",
      agronomic_managment_edit:
        "Are you sure you want to edit Agronomic Management?",
      feacture_no_offline: "This feature is not available offline",
      select_landuse: "Select land use",
      select_crop_name: "Select crop name",
      search: "Search...",
      irrigation_system_label: "Irrigation System",
      management_label: "Management",
      organic_label: "Organic",
      conventional_label: "Conventional",
      crop_cycle_label: "Crop Cycle",
      variety_label: "Variety",
      land_use_title_main: "Land use:",
      crop_name_title_main: "Crop name:",
      sampler_title: "Samplers",
      profile_title: "Profile",
      reviews_title: "Technical visit",
      title_territory_cordinators: "Territory:",
      info_table_areas_sampler: "Information of each assigned area",
      header_table_area: "Area",
      header_table_status_area: "Status",
      header_table_city: "City",
      not_technical_visit: "No technical visits",
      detail_technical_visit: "Technical visit detail",
      areas_pendings_label: "Pending",
      areas_completed_label: "Completed",
      assign_areas_completed_label: "Completed",
      not_areas_pending: "No areas pending",
      areas_completed: "Completed",
      areas_pending: "Pending",
      update_areas: "Update areas",
      label_not_technical_visits: "No technical visits to show",
      label_last_update: "Last update",
      date_not_update: "Not updated",
      date_not_completed: "No date",
      detail_area_assign: "Area Assignment Detail",
      nav_subtitle_area: "All information of assigned areas",
      title_dialog_area_status: "Area Status",
      upload_photo_pending: "You have pending photos to upload",
      detail_technical_visits: "Detail of technical visits",
      success_sync_areas: "Areas synchronized successfully",
      error_sync_areas: "Error synchronizing areas",
      user_not_found: "User not found",
      label_pending_visits: "Pending visits",
      areas_information: "Information",
      areas_completed_user: "User completed areas",
      error_area_upload: "Error uploading area information",
      error_area_connection: "Connection error, try again",
      sampling_label: "Sampling",
      assign_label: "Assignment",
      users_label: "Users",
      nav_completed_visits: "Completed Visits",
      nav_assign_areas: "Assign Areas",
      areas_assign: "Assigned Areas",
      total_areas: "Total Areas",
      completed_assignments: "Completed",
      pendings_assignments: "Pendings",
      assigned: "Assigned",
      not_assigned: "Not assigned",
      sampling_list: "Sampling List",
      upload_list: "Upload List",
      uploading: "Uploading",
      offline_mode: "Offline Mode",
      online_mode: "Online Mode",
      error_upload_area: "Error uploading area information",
      error_connection: "Connection error, try again",
      sync_completed: "Sync Completed",
      sync_error: "Sync Error",
      uploading_data: "Uploading data...",
      updating_data: "Updating data...",
      success_upload: "Upload Successful",
      success_update: "Update Successful",
      error_upload: "Upload Error",
      error_update: "Update Error",
      no_pending_photos: "No pending photos",
      pending_photos: "Pending photos",
      no_upload_errors: "No upload errors",
      upload_errors: "Upload Errors",
      no_pending_areas: "No pending areas",
      pending_areas: "Pending areas",
      areas_to_sync: "Areas to sync",
      sync_areas: "Sync Areas",
      areas_synced: "Areas Synced",
      no_sync_errors: "No sync errors",
      sync_errors: "Sync Errors",
      not_assigned_areas: "Not assigned areas",
      assigned_areas: "Assigned areas",
      assigned_areas_list: "Assigned areas list",
      assigned_area_detail: "Assigned area detail",
      area_assignments: "Area Assignments",
      assign_areas_title: "Assign Areas",
      nav_sync_areas: "Sync Areas",
      area_assignments_list: "Area Assignments List",
      area_assignment_detail: "Area Assignment Detail",
      nav_profile: "Profile",
      profile_information: "Profile Information",
      profile_details: "Profile Details",
      profile_update: "Profile Update",
      nav_logout: "Logout",
      logout_message: "Are you sure you want to logout?",
      logout: "Logout",
      cancel: "Cancel",
      nav_assign_areas: "Assign Areas",
      nav_completed_visits: "Completed Visits",
      nav_area_assignments: "Area Assignments",
      sync_area_title: "Sync Area",
      no_sync_area: "No area to sync",
      sync_area: "Sync Area",
      sync_area_detail: "Sync Area Detail",
      sync_area_list: "Sync Area List",
      nav_sync: "Sync",
      nav_completed_assignments: "Completed Assignments",
      nav_pending_assignments: "Pending Assignments",
      nav_total_assignments: "Total Assignments",
      nav_assignments: "Assignments",
      nav_sync_areas: "Sync Areas",
      sync_area_list: "Sync Area List",
      sync_area_detail: "Sync Area Detail",
      nav_profile_information: "Profile Information",
      profile_details: "Profile Details",
      profile_update: "Profile Update",
      profile_edit: "Edit Profile",
      profile_save: "Save Profile",
      profile_cancel: "Cancel",
      profile_success: "Profile Updated Successfully",
      profile_error: "Error Updating Profile",
      nav_logout: "Logout",
      logout_message: "Are you sure you want to logout?",
      logout: "Logout",
      cancel: "Cancel",
    },
    es: {
      cultivableArea: "Superficie cultibable total (ha)",
      other: "Otro",
      confirmation_wihout_qr:
        "¿Está seguro de que desea finalizar sin un código QR? Las submuestras no se tendrán en cuenta; solo se registrarán los problemas.",
      finish_sampling_without_qr: "Finalizar sin QR",
      advice_not_project:
        "Es necesario crear un proyecto para acceder a territorio",
      created_project: "Creado",
      no_project: "Sin proyecto",
      click_map_add_item: "Da click en el mapa para agregar un item",
      add_problems: "Añadir problemas",
      no_problem_info_defined: "No se ha definido información del problema",
      define_problem: "Definir problema",
      edit_problem: "Editar problema",
      not_defined: "No definido",
      problem: "Problema",
      avocado_plague_list: {
        unknown: "Desconocido",
        oligonychus_yothersi: "Ácaro tostador (Oligonychus yothersi)",
        oligonychus_perseae: "Araña cristalina (Oligonychus perseae)",
        oligonychus_punicae: "Araña roja, del aguacate (Oligonychus punicae)",
        oligonychus_mexicanus: "Araña roja, mexicana (Oligonychus mexicanus)",
        copturus_aguacatae: "Barrenador de ramas (Copturus aguacatae)",
        heilipus_lauri: "Barrenador grande del hueso (Heilipus lauri)",
        conotrachelus_aguacatae:
          "Barrenador pequeño del hueso (Conotrachelus aguacatae)",
        idona_minuenda: "Chicharrita, del aguacate (Idona minuenda)",
        empoasca_abrupta: "Chicharrita, verde (Empoasca abrupta)",
        hemiberlesia_lataniae: "Escama, latania (Hemiberlesia lataniae)",
        pyrrhopyge_chalybea: "Gusano confeti (Pyrrhopyge chalybea)",
        gonodonta_pyrgo: "Gusano de la hoja/fruto (Gonodonta pyrgo)",
        sabulodes_aegrotata: "Gusano falso medidor (Sabulodes aegrotata)",
        copaxa_multifenestrata: "Gusano quemador (Copaxa multifenestrata)",
        amorbia_cuneana: "Gusano telarañero (Amorbia cuneana)",
        gracillaria_spp: "Minador de la hoja (Gracillaria spp.)",
        aleurodes_sp: "Mosca blanca, común (Aleurodes sp.)",
        tetraleurodes_perseae:
          "Mosca blanca, de bandas rojas (Tetraleurodes perseae)",
        aleurodicus_dugesii: "Mosca blanca, gigante (Aleurodicus dugesii)",
        bemisia_argentifolii:
          "Mosca blanca, hoja plateada (Bemisia argentifolii)",
        paraleyrodes_perseae:
          "Mosca blanca, polvorienta (Paraleyrodes perseae)",
        aethalion_quadratum: "Mosca verde del aguacate (Aethalion quadratum)",
        stenoma_catenifer:
          "Palomilla barrenadora del hueso (Stenoma catenifer)",
        metcalfiella_monograma:
          "Periquito del aguacate (Metcalfiella monograma)",
        trioza_anceps: "Psílido de las agallas (Trioza anceps)",
        neohydatothrips_signifer:
          "Trips, de franjas (Neohydatothrips signifer)",
        pseudophilothrips_perseae:
          "Trips, de las agallas (Pseudophilothrips perseae)",
        heliothrips_haemorrhoidalis:
          "Trips, de los invernaderos (Heliothrips haemorrhoidalis)",
        scirtothrips_perseae: "Trips, del aguacate (Scirtothrips perseae)",
        frankliniella_bruneri: "Trips, negro (Frankliniella bruneri)",
        frankliniella_occidentalis:
          "Trips, occidental de las flores (Frankliniella occidentalis)",
        tetranychus_urticae: "Araña roja (Tetranychus urticae)",
        liriomyza_sp: "Minador de la hoja (Liriomyza sp.)",
        tuta_absoluta: "Polilla del tomate (Tuta absoluta)",
        aphis_sp_green: "Pulgón verde (Aphis sp.)",
        diaphorina_citri: "Chicharrita de los cítricos (Diaphorina citri)",
        spodoptera_frugiperda: "Gusano Cogollero (Spodoptera frugiperda)",
        keiferia_lycopersicella:
          "Gusano alfiler del tomate (Keiferia lycopersicella)",
        helicoverpa_zea: "Gusano elotero del maíz (Helicoverpa zea)",
        heliothis_virescens:
          "Gusano del Cogollo del Tabaco (Heliothis virescens)",
        trichoplusia_ni: "Gusano falso medidor (Trichoplusia ni)",
        manduca_quinquemaculata:
          "Gusano cuerno del tomate (Manduca quinquemaculata)",
        spodoptera_exigua: "Gusano soldado (Spodoptera exigua)",
        liriomyza_spp: "Mosca minadora (Liriomyza spp)",
        cydia_pomonella: "Gusano de la Manzana (Cydia pomonella)",
        phthorimaea_operculella:
          "Polilla de la patata (Phthorimaea operculella)",
        heliothis_zea: "Gusano elotero del maíz (Heliothis zea)",
        pectinophora_gossypiella: "Gusano Rosado (Pectinophora gossypiella)",
        bucculatrix_thurberiella:
          "Gusano perforador de la hoja del algodón (Buccolatrix thurberiella)",
        estigmene_acrea: "Gusano peludo (Estigmene acrea)",
        copitarsia_consueta:
          "Gusano del corazón de la col (Copitarsia consueta)",
        plutella_xylostella:
          "Palomilla dorso de diamante (Plutella xylostella)",
        liriomyza_munda: "Minador de la hoja (Liriomyza munda)",
        manduca_sexta: "Gusano Cuerno del Tabaco (Manduca sexta)",
        diatraea_grandiosella:
          "Barrenador del tallo del maíz (Diatraea grandiosella)",
        carpocapsa_pomonella: "Polilla del manzano (Carpocapsa pomonella)",
        aeneolamia_contigua: "Mosca pinta (Aeneolamia contigua)",
        other: "Otro",
      },
      avocado_disease_list: {
        unknown: "Desconocido",
        damping_off: "Ahogamiento / Damping-off (Pythium sp.)",
        anthracnose_classic:
          "Antracnosis, clásica (Colletotrichum gloeosporioides)",
        anthracnose_boninense:
          "Antracnosis, complejo boninense (Colletotrichum boninense)",
        bacterial_canker: "Cancro bacteriano (Xanthomonas sp.)",
        sooty_mold: "Fumagina / Negrilla (Capnodium sp.)",
        angular_leaf_spot: "Mancha angular de la hoja (Cercospora purpurea)",
        tar_spot: "Mancha de chapopote / Varicela (Phyllachora gratissima)",
        leaf_spot_septoria: "Mancha foliar por Septoria (Septoria sp.)",
        black_spot: "Mancha negra (Diplocarpon rosae)",
        fusarium_wilt: "Marchitez / Fusariosis (Fusarium sp.)",
        root_rot_rhizoctonia: "Pudrición de raíz (Rhizoctonia solani)",
        fruit_rot_diplodia: "Pudrición del fruto, Diplodia (Diplodia sp.)",
        fruit_rot_dothiorella:
          "Pudrición del fruto, Dothiorella (Dothiorella sp.)",
        scab: "Roña del aguacate (Sphaceloma perseae)",
        avocado_root_rot: "Tristeza del aguacatero (Phytophthora cinnamomi)",
        botrytis_cinerea: "Moho Gris / Botritis (Botrytis cinerea)",
        cladosporium_fulvum: "Moho de la hoja del tomate (Cladosporium fulvum)",
        colletotrichum_acutatum: "Antracnosis (Colletotrichum acutatum)",
        glomerella_cingulata: "Antracnosis (Glomerella cingulata)",
        monilia_spp: "Pudrición del fruto, Monilia spp. (Monilia spp.)",
        mycosphaerella_fragariae: "Mancha Púrpura (Mycosphaerella fragariae)",
        peronospora_rubi: "Mildiú Velloso de la Zarzamora (Peronospora rubi)",
        other: "Otra",
      },
      avocado_weeds_list: {
        chenopodium_album: "Quelite cenizo (Chenopodium album)",
        equisetum_spp: "Muela de caballo (Equisetum spp.)",
        eleusine_indica: "Pata de gallo (Eleusine indica)",
        convolvulus_arvensis: "Chayotillo o Correhuela (Convolvulus arvensis)",
        euphorbia_prostrata: "Golondrina (Euphorbia prostrata)",
        rumex_crispus: "Lengua de vaca (Rumex crispus)",
        sorghum_halepense: "Sacate Jhonson (Sorghum halepense)",
        setaria_verticillata: "Cola de zorra (Setaria verticillata)",
        cyperus_rotundus: "Coquillo (Cyperus rotundus)",
        other: "Otra",
      },
      avocado_nutrition: {
        nitrogen: "Nitrógeno (N)",
        zinc: "Zinc (Zn)",
        iron: "Hierro (Fe)",
        potassium: "Potasio (K)",
        boro: "Boro (B)",
        other: "Otro",
      },
      plague: "Plaga",
      disease: "Enfermedad",
      weed: "Maleza",
      nutrition: "Deficiencias nutricionales",
      specific_problem: "Problema específico",
      problem_type: "Tipo de problema",
      problem_info: "Información del problema",
      soil: "Suelo",
      longitudeRange: "Longitud debe estar entre -180 y 180",
      latitudeRange: "Latitud debe estar entre -90 y 90",
      bothFieldsRequired: "Ambos campos (latitud y longitud) son requeridos",
      additionalDetails: "Detalles complementarios",
      descriptionSaved: "Descripción guardada",
      projectEndDate: "Fecha fin de proyecto",
      tentativeFieldSamplingDate: "Fecha tentativa de muestreo en campo",
      commercialStartDate: "Fecha de arranque comercial",
      importantDates: "Fechas importantes",
      noCrop: "Sin cultivo",
      targetCrops: "Cultivo(s) objetivo",
      agriculturalDetails: "Detalles agrícola",
      responsible: "Responsable",
      notSpecified: "No especificado",
      projectType: "Tipo de proyecto",
      generalInformation: "Información general",
      enterCoordinates:
        "Ingresa las coordenadas de la imagen o ubica el punto dando click en el mapa",
      selectImage: "Selecciona imagen(es)",
      addMultipleSubsamples: "Agregar múltiples submuestras",
      imagePreview: "Vista previa de la imagen",
      deleteSubsample: "Eliminar submuestra",
      centerSubsample: "Centrar submuestra",
      relocate: "Reubicarse",
      images_without_metadata: "Imágenes sin metadatos (no se subirán)",
      subsample_outside_polygon: "Submuestra fuera del polígono",
      image_load_error: "Algo salió mal al cargar la imagen",
      add_multiple_subsamples: "Agregar múltiples submuestras",
      sampling_date: "Fecha de muestreo",
      updated_information: "Información actualizada",
      current_package: "Paquete actual",
      select_sampling_type: "Seleccione el tipo de muestreo",
      update_sample_data: "Actualizar datos de muestra",
      label_new_farm: "Nueva productora/empresa",
      general_description: "Descripción general",
      request_guide_dialog_content:
        "La solicitud de guia fue enviada, tu guia sera enviado a tu correo electronico.",
      request_guide_dialog_title: "Solicitud de guía",
      request_guide_label: "Solicitar guía de retorno",
      label_total_samples: "Total de muestras en kit",
      origin_zip_code_label: "Código postal de orígen",
      selectKitType: "Selecciona el tipo de kit",
      kitType: "Tipo de kit",
      send_label: "Enviar",
      request_guide_title: "Solicitar guía",
      selectIrrigationSystem: "Seleccione el sistema de riego",
      label_longitude: "Longitud",
      label_latitude: "Latitud",
      label_no_evidence: "Sin evidencia",
      label_evidence: "Evidencia",
      label_actions: "Acciones",
      label_image: "Imagen",
      label_sampling_date: "Fecha muestreo",
      label_coordinates: "Coordenadas",
      label_center: "Centrar",
      label_select_image: "Selecciona imagen",
      label_add_image: "Agregar imagen",
      label_add_version: "Agregar versión",
      label_name_or_code_profitability: "Nombre o Código rentabilización",
      label_no_profitability: "No hay rentabilizaciones",
      label_sample: "Muestra",
      label_origin_postal_code: "Código postal de origen",
      label_add_sample: "Agregar muestra",
      label_clear_list: "Limpiar lista",
      label_use: "Uso",
      label_active_ingredient: "Ingrediente activo",
      label_product_name_brand: "Nombre del producto (marca)",
      label_at_least_one_sample: "Debe de existir por lo menos una muestra",
      label_compost_type: "Tipo de composta",
      label_analysis_type: "Tipo de análisis",
      label_without_crop: "Sin cultivo",
      label_with_crop: "Con cultivo",
      label_relogin: "Vuelve a iniciar sesión",
      label_session_expired: "Sesión expirada",
      label_new_sample: "Nueva muestra",
      label_phone: "Teléfono",
      label_last_name: "Apellido",
      label_basic_information: "Información básica",
      label_profile: "Perfil",
      label_application_removed: "Aplicación removida",
      label_add_application: "Añadir aplicación",
      label_applications: "Aplicaciones",
      label_product: "Producto",
      label_sample_without_advisor: "Muestra sin asesor",
      label_substrate_sample: "Muestra de sustrato",
      label_product_sample: "Muestra de producto",
      label_compost_sample: "Muestra de composta",
      label_plant_sample_without_reference: "Muestra vegetal sin referencia",
      label_soil_sample: "Muestra de suelo",
      label_genomic_plant_sample: "Muestra vegetal genómica",
      label_genomic_sample: "Muestra genómica",
      label_project_detail: "Detalle proyecto",
      label_project_created: "Proyecto creado",
      label_project_updated: "Proyecto actualizado",
      label_add_at_least_one_item: "Agrega por lo menos 1 elemento",
      label_add_product: "Añadir producto",
      label_objective: "Objetivo",
      label_active_ingredient: "Ingrediente activo",
      label_add_application: "Añadir aplicación",
      label_application_added: "Aplicación añadida",
      label_dose: "Dósis",
      label_add_product: "Añadir producto",
      label_add_phenological_stage: "Añade etapa fenológica",
      label_select_irrigation_unit: "Seleccione zona(s) de muestreo",
      label_contrast_b: "Contraste B",
      label_contrast_a: "Contraste A",
      label_select_variant: "Selecciona variante",
      label_select_project_type: "Selecciona tipo de proyecto",
      label_agricultural_units: "Zonas de muestreo",
      label_project_information: "Información del proyecto",
      label_create_project: "Crear proyecto",
      label_update_project: "Actualizar proyecto",
      label_no_projects: "No hay proyectos",
      label_add_producer_company: "Añadir productora/empresa",
      label_search_folio: "Buscar folio",
      label_no_results: "No hay resultados",
      label_projects: "Proyectos",
      label_download_sampling_app: "Descarga app muestreo",
      label_no_georeference: "Sin georeferencia",
      label_profitability: "Rentabilización",
      label_fungi: "Hongos",
      label_bacteria: "Bacterias",
      label_cellulolytic_activity: "Actividad celulolítica",
      label_siderophores: "Sideróforos",
      label_potassium_solubilization: "Solubilización de potasio (K)",
      label_phosphorus_solubilization: "Solubilización de fósforo (P)",
      label_negative_control: "Control negativo",
      label_nutrition: "Nutrición",
      label_control: "Control",
      label_soil_disease_control: "Control de enfermedades de suelo",
      label_no_not_detected: "No hay no detectados",
      label_beneficial: "Benéfico",
      label_pathogen: "Patógeno",
      label_type: "Tipo",
      label_not_detected: "No detectados",
      label_no_pathogens: "No hay patógenos",
      label_soil_pathogen_detection: "Detección de patógenos en suelo",
      label_no_beneficials: "O hay benéficos",
      label_concentration: "Concentración",
      label_taxonomic_identification: "Identificación taxonómica",
      label_microorganism: "Microorganismo",
      label_soil_beneficials_of_interest: "Benéficos de interés en suelo",
      label_biological_capital_measurement: "Medición de Capital Biológico",
      label_soil_texture: "Textura de suelo",
      label_carbon_capture_pox: "Captura de carbono (POX)",
      label_organic_matter: "Materia orgánica",
      label_soil_health_parameters: "Parámetros de salud de suelo",
      label_irrigation_unit: "Zona de muestreo",
      label_analysis_detail: "Detalle de análisis",
      label_analysis_in_progress: "Análisis en progreso",
      label_not_available: "No disponible",
      label_next_result_date: "Fecha próximo resultado",
      label_analysis_results: "Resultados de análisis",
      label_close: "Cerrar",
      label_subsample_photos: "Fotos de submuestras",
      label_polygon_not_available: "Polígono no disponible",
      label_sample_detail: "Detalle de muestra",
      label_measurement: "Medición",
      label_valuation: "Valuación",
      label_valuated: "Valuado",
      label_valuating: "Valuando",
      label_measured: "Medido",
      label_measuring: "Midiendo",
      label_sent: "Enviado",
      label_received: "Recibido",
      label_sampling_finished: "Muestreo finalizado",
      label_detail: "Detalle",
      label_analysis_folio: "Folio análisis",
      label_status: "Estatus",
      label_apply: "Aplicar",
      label_advanced_filters: "Filtros avanzados",
      label_no_samples: "No hay muestras",
      label_samples_list: "Lista de muestras",
      label_at_least_one_sample_required:
        "Debe de existir por lo menos una muestra",
      label_sample_already_completed: "La muestra ya estaba finalizada",
      label_enter_a_valid_folio: "Ingrese un folio válido",
      label_enter_an_unregistered_folio: "Ingrese un folio sin registrar",
      label_sample_successfully_registered: "Muestra registrada exitosamente",
      label_browser_lacks_features: "El navegador parece carecer de funciones",
      label_requested_front_camera_although_none_available:
        "¿Pediste la cámara frontal aunque no hay ninguna?",
      label_camera_may_be_in_use: "Tal vez la cámara ya está en uso",
      label_page_not_served_over_https_or_localhost:
        "La página no se sirve a través de HTTPS (o localhost)",
      label_no_suitable_camera_device_installed:
        "No hay ningún dispositivo de cámara adecuado instalado",
      label_user_denied_camera_access_permission:
        "Usuario denegado permiso de acceso a la cámara",
      label_finish_sampling: "Finalizar muestreo",
      label_finish_with_scanner: "Finalizar con scanner",
      label_qr_not_found: "QR no encontrado",
      label_search_qr: "Buscar QR...",
      label_sick_plot: "Parcela enferma",
      label_sample_description: "Descripción de muestra",
      label_plant_sample_type: "Tipo de muestra vegetal",
      label_sampling_type: "Tipo de muestreo",
      label_select_package: "Selecciona paquete",
      label_sample_type: "Tipo de muestra",
      label_phonological_stage: "Etapa fenológica",
      label_number_of_subsamples: "Número de sub-muestras",
      label_delete_subsamples: "Eliminar sub-muestras",
      label_add_subsamples: "Agregar submuestras",
      label_finish_sampling: "Finalizar muestreo",
      label_not_applicable: "No aplica",
      label_no_areas: "No hay áreas",
      label_no_agronomic_management: "Sin manejo agronómico",
      label_territory_list: "Lista territorio",
      label_at_least_one_item_required:
        "Se debe de seleccionar al menos un elemento",
      label_agronomic_management_saved: "Manejo agronómico guardado",
      label_crop_cycle_ended:
        "El ciclo de cultivo ha terminado, ¿Quieres ingresar uno nuevo?",
      label_new_crop_cycle: "Nuevo ciclo de cultivo",
      label_add_area_with_highest_problem_severity:
        "Agregar área con mayor severidad de problemas",
      label_previous_cycle: "Ciclo anterior",
      label_problems_detected: "Problemas detectados",
      label_select_tonnage_unit: "Selecciona unidad de tonelaje",
      label_tonnage: "Tonelaje",
      label_average_yield_per_hectare_acre:
        "¿Cuál es el rendimiento promedio por hectárea/acre?",
      label_list_of_inputs_applied_during_crop_cycle:
        "Lista de insumos aplicados durante el ciclo del cultivo",
      label_cycle_end: "Fin de ciclo",
      label_cycle_start: "Inicio de ciclo",
      label_variety_optional: "Variedad (opcional)",
      label_select_crop: "Seleccione un cultivo",
      label_crop_cycle: "Ciclo de cultivo",
      label_description: "Descripción",
      label_crop_success_definition: "Definición de éxito del cultivo",
      label_what_is_your_agricultural_management_practice:
        "¿Cuál es su práctica de manejo agrícola?",
      label_select_shadow_type: "Seleccione tipo de sombra",
      label_confirm_delete_area: "¿Seguro que desea eliminar esta área?",
      label_delete_area: "Eliminar área",
      label_area_deleted: "Área eliminada",
      label_cannot_delete_area_with_samples:
        "No se puede eliminar una área con muestras",
      label_days: "Días",
      label_on_hold: "En pausa",
      label_soil_of: "Tierra de",
      label_crop_of: "Cultivo de",
      label_sterile: "Estéril",
      label_redraw: "Redibujar",
      label_qr_invalid: "QR no válido",
      label_qr_registered: "QR registrado",
      label_sampling_in_progress: "Muestreo en curso",
      label_sampling_not_started: "Muestreo no iniciado",
      label_add_crop: "Añadir cultivo",
      label_name: "Nombre",
      label_enter_agronomic_management_before_sampling:
        "Ingrese manejo agronómico antes de muestrear (Obligatorio)",
      label_rename: "Renombrar",
      label_add_area: "Agregar área",
      label_cultivation_area_name: "Nombre del área de cultivo",
      label_confirm_edit_agronomic_management:
        "¿Estás seguro que desea editar el Manejo agronómico del área?",
      label_agronomic_management: "Manejo agronómico",
      label_management: "Manejo",
      label_take_sample: "Tomar muestra",
      label_results: "Resultados",
      label_draw: "Dibujar",
      label_repeat: "Repetir",
      label_back: "Atrás",
      label_territory: "Territorio",
      label_prospect_created: "Prospecto creado",
      label_prospect_updated: "Prospecto actualizado",
      label_new_prospect: "Nuevo prospecto",
      label_update_prospect: "Actualizar prospecto",
      label_update_prospect: "Actualizar prospecto",
      label_no_zone_assigned_prospect:
        "No se asignó zona al prospecto, ¿quieres continuar?",
      label_contact_last_name: "Apellido contacto",
      label_removed_from_favorites: "Removido de favoritos",
      label_added_to_favorites: "Agregado a favoritos",
      label_make_client: "Hacer cliente",
      label_distributor_change_successful: "Cambio de distribuidor exitoso",
      label_client_created: "Productora/Empresa creada",
      label_client_updated: "Productora/Empresa actualizado",
      label_no_zone_assigned:
        "No se asignó zona al prospecto, ¿quieres continuar?",
      label_logout_confirmation: "¿Seguro que quiere cerrar sesión?",
      label_confirmation: "Confirmación",
      label_state: "Estado",
      label_city: "Ciudad",
      label_country: "País",
      label_neighborhood: "Colonia",
      label_interior_number: "Número interior",
      label_exterior_number: "Número exterior",
      label_postal_code: "Código postal",
      label_street: "Calle",
      label_update_client: "Actualizar Productor/Empresa",
      label_address: "Domicilio",
      label_rfc: "RFC",
      label_phone: "Teléfono",
      label_contact_name: "Nombre contacto",
      label_zone: "Zona",
      label_contact_information: "Información del contacto",
      label_company_name: "Razón social",
      label_client_created: "Productora/Empresa creada",
      advice_error: "Algo salio mal, intente de nuevo",
      label_update: "Actualizar",
      advice_not_prospects: "No hay prospectos",
      advice_no_clients: "No hay agricolas",
      label_clients: "Productora/Empresa",
      label_prospects: "Prospectos",
      valid_email_required: "Debes ingresar un correo electrónico válido",
      select_distributor: "Selecciona distribuidor",
      field_required: "El campo es obligatorio",
      email_label: "correo",
      label_continue: "Continuar",
      enter_email: "Ingrese su dirección de correo electrónico",
      forget_password_title: "Se te olvidó tu contraseña",
      send_email_password:
        "Se ha enviado un email a tu correo para cambiar tu contraseña",
      error_changing_password: "Error al intentar cambiar contraseña",
      login_error_check_info:
        "Error al iniciar sesión, verifica tu información",
      label_download_pdf: "Descargar PDF",
      label_client_accept: "Aceptado por el cliente",
      download_sampling_app: "Descargar app muestreo",
      home_menu_label_change_dis: "Cambiar distribuidor",
      change_language: "Cambiar idioma",
      download_app: "Descargar app muestreo solena explore",
      forgot_your_password: "¿No recuerdas tu contraseña?",
      app_name: "Solena Explore",
      navigation_drawer_open: "Menú de Navegación Abierto",
      navigation_drawer_close: "Cerrar Menú de Navegación",
      nav_header_title: "Android Studio",
      nav_header_desc: "Encabezado de Navegación",
      action_samples: "Muestras",
      menu_territory: "Territorio",
      menu_samples: "Muestras",
      menu_log_out: "Cerrar Sesión",
      app_name_splash: "Solena (Beta) 1.3.6",
      description_logo: "Logo de Solena",
      prompt_email: "Usuario",
      prompt_password: "Contraseña",
      action_sign_in: "Iniciar Sesión",
      action_sign_in_short: "Iniciar Sesión",
      welcome: "Bienvenido",
      invalid_username: "Correo electrónico inválido",
      invalid_password: "Contraseña incorrecta",
      login_failed: "Inicio de sesión fallido",
      fill_fields: "Llene ambos campos",
      user_not_saved: "Usuario no guardado en el dispositivo",
      user_wrong: "Intente acceder desde la aplicación web de Solena Explore",
      sample_photo_activity_title: "Foto de Muestra",
      detail_sample_activity_title: "Muestreo de Suelo",
      image_capture_failed: "Captura de imagen fallida",
      error_to_upload_photo: "Error al subir la foto, intente nuevamente",
      area_update_failure: "Actualización de área fallida",
      area_update_db_failure: "Error al guardar la foto, intente nuevamente",
      captured_image: "Submuestra",
      location_wrong: "Cargando ubicación, por favor espere",
      folio_wrong: "Error al guardar la muestra",
      wrong_folio_length: "El folio debe tener 14 dígitos",
      detecting_QR: "Finalizar Muestreo",
      area_name: "Nombre del Área",
      area_length: "Área: 100 ha",
      perimeter: "Perímetro: 3,544.91 m",
      repeat: "Repetir",
      accept: "Aceptar",
      photo_needed: "No hay muestras para registrar",
      connection_needed: "No hay conexión a internet",
      address_needed: "Complete su perfil e información de dirección.",
      area_updated_fail: "Actualización de área fallida",
      failed_sync: "Sincronización de área fallida:",
      area_server_update_fail: "Error al subir cambios del área",
      samples_taken: "Muestreo completo, puede finalizar ahora",
      areas_update_async_successful: "Datos sincronizados exitosamente",
      areas_update_async_successful_errors: "Datos sincronizados con errores",
      local_area_failure: "Error de actualización de área en el dispositivo",
      NOT_ASSIGNED: "NO ASIGNADO",
      NOT_STARTED: "Listo para muestrear",
      COMPLETED: "COMPLETADO",
      IN_PROGRESS: "Muestreo en progreso",
      INACCESSIBLE: "INACCESIBLE",
      NOT_VALID: "NO VÁLIDO",
      VALIDATED: "VALIDADO",
      VALIDATION_PENDING: "VALIDACIÓN PENDIENTE",
      area: "Área",
      perimeter_: "Perímetro:",
      started_sample: "Inicio de muestreo",
      enter_area: "¿Puede ingresar al área de muestreo?",
      not: "No",
      yes: "Sí",
      suggested_points: "PUNTOS DE DESTINO",
      sample_taken: "Muestras:",
      elapsed_time: "Tiempo de muestreo:",
      waiting_map: "Fijando posición...",
      photo_error: "Error al subir imagen, intente nuevamente",
      api_error: "Error del servidor:",
      conecction_error:
        "Error de conexión, esperando conexión para actualizar áreas",
      shipment_label: "Envío de muestra de suelo",
      shipment_question: "¿Generar guía para envío de muestra?",
      input_folio: "Ingrese el Folio de la muestra",
      folio: "Folio",
      cancel: "Cancelar",
      delete: "Eliminar",
      finish: "Finalizar",
      title_dialog_finish: "Enviar muestra",
      warning_qr: "QR inválido, ingrese manualmente",
      not_permissions_qr: "No hay permisos de cámara",
      qr_foto_error: "Error al finalizar el muestreo, intente nuevamente",
      offline: "Sin internet, modo fuera de línea",
      online: "Conexión a internet restaurada",
      syncing_area: "Sincronizando datos, por favor espere...",
      no_internet: "Asegúrese de estar conectado a internet",
      connection_lost: "Conexión a internet perdida",
      acept: "Aceptar",
      porcentage_photo: "/100",
      areas: "Áreas: ",
      photoCountAsync: "Fotos:",
      landUse: "Uso de Suelo",
      landUse_list: {
        sterile: "Estéril",
        cropLand: "Terreno Agrícola",
      },
      irrigations_list: {
        drip: "Goteo",
        pivot: "Pivote",
        wheeled: "Inundación",
        microspray: "Microaspersión",
        "without irrigation": "Sin riego",
      },
      shadow_type: {
        "Shade cloth": "Malla sombra",
        Greenhouse: "Invernadero",
        "Open field": "Campo abierto",
        Macrotunnel: "Macrotúnel",
      },
      management_practices: {
        TILLAGE: "Labranza reducida",
        CROP_ROTATION: "Rotación de cultivo",
        COMPOST_APPLY: "Aplicación de compostas",
        CROP_COVER: "Cultivos de cobertura",
        PEST_MANAGEMENT: "Manejo integrado de plagas",
        OTHER: "Otro",
        NONE: "Ninguna",
      },
      propagation_method: {
        graft: "Injerto",
        frank: "Franco",
      },
      agroinputs: {
        inputWeed: "Control de malezas",
        inputPest: "Control de plagas (insectos)",
        inputPhytopathogen: "Control de Fitopatógenos",
        inputConditioner: "Mejorador de suelo",
        inputFungi: "Inoculantes fungicos",
        inputBacteria: "Inoculantes bacterianos",
        inputAlgae: "Inoculantes basados en algas",
      },
      agroinputs_descriptions: {
        inputWeed: "Control de malezas - Nombre del producto (opcional)",
        inputPest:
          "Control de plagas (insectos) - Nombre del producto (opcional)",
        inputPhytopathogen:
          "Control de Fitopatógenos - Nombre del producto (opcional)",
        inputConditioner:
          "Mejorador de suelo ejemplo: ácidos fulvicos humicos, cal agricola etc",
        inputFungi: "Inoculantes fungicos - ejemplo: Trichoderma, etc.",
        inputBacteria: "Inoculantes bacterianos - ejemplo: Pseudomonas, etc.",
        inputAlgae: "Inoculantes basados en algas - ejemplo: Ascophyllum, etc.",
      },
      tonnageUnits: {
        HECTARE: "Hectárea",
        ACRE: "Acre",
      },
      issueList: {
        salinity: "Salinidad",
        soilCompaction: "Compactación del suelo",
        alkalinity: "Suelo alcalino (pH > 7.0)",
        acidity: "Suelo ácido (pH < 6)",
        heavyMetals: "Metales pesados en suelo",
        recurrentDiseases: "Enfermedades recurrentes",
        percentageOrganicMatter: "Baja materia orgánica en suelo ( < 1 %)",
        other: "Otro",
      },
      phenologicalStages: {
        Transplanting: "Trasplante",
        "Vegetative growth": "Desarrollo Vegetativo",
        Bloom: "Floración",
        Harvest: "Cosecha",
        "Pre-planting": "Presiembra",
        Sowing: "Siembra",
        Sprout: "Emergencia",
        Tuberization: "Tuberización",
        "Tuber filling": "Llenado de tuberculos",
        "Foliage development": "Desarrollo foliar",
        "Foliar expansion": "Expansión foliar",
        "First leaf": "Primera hoja",
        "Third leaf": "Tercer hoja",
        "Fifth leaf": "Quinta hoja",
        "Start of bulbing": "Inicio de bulbificación",
        "Bulb growth": "Desarrollo del bulbo",
        "Fruit maturity": "Maduración de fruto",
        Sprouting: "Brotación",
      },
      analysisTypes: {
        INITIAL: "Inicial",
        MONITORING: "Seguimiento",
      },
      samplingType: {
        CLASSIC: "Muestreo de suelo",
        MAS_VEGETABLE: "Muestreo vegetal",
      },
      kitTypes: {
        CLASSIC: "Tradicional",
        HYBRID: "Híbrido",
        QPCR: "QPCR",
      },
      vegetalSampleTypes: {
        Seedling: "Plántula",
        Root: "Raíz",
        Seed: "Semilla",
        Stem: "Tallo",
        Leaf: "Hoja",
        Fruit: "Fruto",
        Flower: "Flor",
      },
      status_samples: {
        ALL: "Todos",
        IN_PROGRESS: "En progreso",
        VALIDATED: "Finalizado",
        RECEIVED: "Recibido",
        MEASURING: "Midiendo",
        MEASURED: "Medido",
        VALUATING: "Valuando",
        VALUATED: "Valuado",
      },
      symp: {
        Clorosis: "Chlorosis",
        "Leaf spots": "Manchas en las hojas",
        Necrosis: "Necrosis",
        Wilting: "Marchitamiento",
        Dwarfism: "Enanismo",
        "Early wilting": "Marchitamiento precoz",
        "Root rot": "Pudrición de raíz",
        "Performance reduction": "Reducción del rendimiento",
        "Plant Chlorosis": "Planta clorosis",
        "Plant with spots on the leaves": "Planta con manchas en las hojas",
        "Plant with necrosis": "Planta con necrosis",
        "Healthy plant": "Planta sana",
        "Leaf top with chlorosis": "Hoja parte alta con clorosis",
        "Leaf top with spots": "Hoja parte alta con manchas",
        "Leaf top with necrosis": "Hoja parte alta con necrosis",
        "Leaf top with wilting": "Hoja parte alta con marchitamiento",
        "Leaf top healthy": "Hoja parte alta sana",
        "Leaf middle with chlorosis": "Hoja parte media con clorosis",
        "Leaf middle with spots": "Hoja parte media con manchas",
        "Leaf middle with necrosis": "Hoja parte media con necrosis",
        "Leaf middle with wilting": "Hoja parte media con marchitamiento",
        "Leaf middle healthy": "Hoja parte media sana",
        "Leaf lower with chlorosis": "Hoja parte baja con clorosis",
        "Leaf lower with spots": "Hoja parte baja con manchas",
        "Leaf lower with necrosis": "Hoja parte baja con necrosis",
        "Leaf lower with wilting": "Hoja parte baja con marchitamiento",
        "Leaf lower healthy": "Hoja parte baja sana",
        "Stem with dwarfism": "Tallo con enanismo",
        "Early wilting stem": "Tallo con marchitamiento precoz",
        "Stem with necrosis": "Tallo con necrosis",
        "Healthy stem": "Tallo sano",
        "Root rot": "Raíz con pudrición",
        "Root with necrosis": "Raíz con necrosis",
        "Healthy root": "Raíz sana",
        "Fruit with reduced yield": "Fruta con reducción del rendimiento",
        "Fruit with necrosis": "Fruta con necrosis",
        "Healthy fruit": "Fruta sana",
      },
      symp_avocado: {
        "Regressive death": "Muerte regresiva (Descendente)",
        Defoliation: "Defoliacion (Caida prematura de hojas)",
        Cancer: "Cáncer",
        Chlorosis: "Clorosis (amarillamiento)",
        "Limb drying": "Secado de extremidades (ramas)",
        "Sooty mold": "Fumagina",
        "Drying with attached leaves": "Secado con hojas adheridas",
        Galling: "Agallamiento (tumoraciones)",
        "Leaf Spots": "Manchas foliares",
        "Trunk Canker": "Cancro de tronco",
        "Peduncle Ringing (Fruit)": "Anillamiento de pedunculo (Fruto)",
        "Root Rot": "Pudricion radicular",
        Healthy: "Sana",
      },
      symp_blackberry_raspberry: {
        Chlorosis: "Clorosis (amarillamiento)",
        Wilting: "Marchitez / flacides de tallo u hojas",
        "Leaf spots": "Manchas foliares",
        "Stem streaking": "Rayado de tallo",
        Defoliation: "Defoliacion (Caida prematura de hojas)",
        Blight: "Tizon (Clorosis y/o secado de brotes)",
        Galling: "Agalla o tumor de cuello",
        "Growth delay": "Retraso de crecimiento",
        "Base Stem Girdling": "Ahorcamiento de base del tallo",
        "Root Rot": "Pudricion radicular",
        Healthy: "Sana",
      },
      symp_strawberry: {
        Wilting: "Marchitez / flacides de tallo u hojas",
        "Leaf spots": "Manchas foliares",
        "Crown rot": "Pudricion de corona",
        Defoliation: "Defoliacion (Caida prematura de hojas)",
        Chlorosis: "Clorosis (amarillamiento)",
        "Growth delay": "Retraso de crecimiento",
        "Base Stem Girdling": "Ahorcamiento de base del tallo",
        "Reddish Spots on Leaf Edges":
          "Manchas avermelhadas nas bordas de las hojas",
        "Root Rot": "Pudricion radicular",
        Healthy: "Sana",
      },
      symp_blueberry: {
        Wilting: "Marchitez / flacides de tallo u hojas",
        "Basal rot": "Pudrición basal",
        "Leaf spots": "Manchas foliares",
        Blight: "Tizon (Clorosis y/o secado de brotes)",
        Chlorosis: "Clorosis (amarillamiento)",
        "Growth delay": "Retraso de crecimiento",
        "Crown Gall or Tumor": "Agalla o tumor de cuello",
        "Base Stem Girdling": "Ahorcamiento de base del tallo",
        "Root Rot": "Pudricion radicular",
        Healthy: "Sana",
      },
      symp_orange: {
        "Chlorosis (Yellowing)": "Clorosis (Amarillamiento)",
        "Dieback (Downward)": "Muerte regresiva (Descendente)",
        "Defoliation (Premature leaf drop)":
          "Defoliacion (Caida prematura de hojas)",
        "Root Rot": "Pudricion radicular",
        Healthy: "Sana",
      },
      symp_chili_peppers_cucumber_tomato: {
        "Chlorosis (Yellowing)": "Clorosis (Amarillamiento)",
        "Leaf Spots": "Manchas foliares",
        "Dieback (Downward)": "Muerte regresiva (Descendente)",
        "Wilting / Stem or Leaf Flaccidity":
          "Marchitez / flacides de tallo u hojas",
        "Root Gall (Nematodes)": "Raiz con agallas (Nemátodos)",
        "Base Stem Girdling": "Ahorcamiento de base del tallo",
        "Blight (Chlorosis and/or Shoot Drying)":
          "Tizon (Clorosis y/o secado de brotes)",
        "Growth Retardation": "Retraso de Crecimiento",
        "Root Rot": "Pudricion radicular",
        "Stem Spots": "Manchas en el tallo",
        Healthy: "Sana",
      },
      symp_potato: {
        "Chlorosis (Yellowing)": "Clorosis (Amarillamiento)",
        "Leaf Spots": "Manchas foliares",
        "Wilting / Stem or Leaf Flaccidity":
          "Marchitez / flacides de tallo u hojas",
        "Root Gall (Nematodes)": "Raiz con agallas (Nemátodos)",
        "Base Stem Girdling": "Ahorcamiento de base del tallo",
        "Blight (Chlorosis and/or Shoot Drying)":
          "Tizon (Clorosis y/o secado de brotes)",
        "Growth Retardation": "Retraso de Crecimiento",
        "Root Rot": "Pudricion radicular",
        "Tuber Necrosis / Rot": "Necrocis / Pudricion de tuberculo",
        "Scab / Tuber Scab": "Roña / Sarna Tuberculo",
        "Black Scab Tuber": "Costra Negra tuberculo",
        "Stem Spots": "Manchas en el tallo",
        Healthy: "Sana",
      },
      symp_asparagus: {
        "Chlorosis (Yellowing)": "Clorosis (Amarillamiento)",
        "Dieback (Downward)": "Muerte regresiva (Descendente)",
        "Root Gall (Nematodes)": "Raiz con agallas (Nemátodos)",
        "Blight (Chlorosis and/or Shoot Drying)":
          "Tizon (Clorosis y/o secado de brotes)",
        "Growth Retardation": "Retraso de Crecimiento",
        "Crown Rot": "Pudricion de Corona",
        "Root Rot": "Pudricion radicular",
        "Stem Spots": "Manchas en el tallo",
        "Bud Scaling": "Escamacion de yemas",
        "Purple/Pink Spear Discoloration":
          "Turiones con coloracion morada/rosas",
        Healthy: "Sana",
      },
      moTypes: {
        bacteria: "Bacteria",
        fungi: "Hongo",
        nematode: "Nematodo",
      },
      status_projects: {
        NEW: "Nuevo",
        PROCESSING: "En proceso",
        IN_REVIEW: "En revisión",
        IN_PROGRESS: "En progreso",
        FINISHED: "Finalizado",
        ACCEPTED: "Aceptado",
      },
      miss_test_variants: {
        CONTRAST: "Contraste",
        UNCONTRASTED: "Sin contraste",
        RASTER: "Raster",
      },
      miss_test_variants_setup: {
        CONTRAST: "Control",
        UNCONTRASTED: "Sin control",
      },
      compotition_types: {
        LIQUID: "Líquido",
        SOLID: "Sólido",
      },
      sampleTypeNotGeo: {
        COMPOST: "Composta",
        PRODUCT: "Producto",
        SUBSTRATUM: "Sustrato",
        VEGETABLE: "Vegetal sin georeferencia",
      },
      sampleTypeNotGeoAll: {
        COMPOST: "Composta",
        PRODUCT: "Producto",
        SUBSTRATUM: "Sustrato",
        VEGETABLE: "Vegetal sin georeferencia",
        SOLENA_NO_ADVISOR: "Cliente sin asesor",
      },
      status_profits: {
        ALL: "Todos",
        NEW: "Nuevo",
        PROPOSAL: "Propuesta",
        ACCEPTED: "Aprobada",
        FINISHED: "Finalizada",
      },
      agronomic_managment_title: "Manejo Agronómico",
      crop_name: "Nombre del Cultivo",
      start_cycle: "Inicio del Ciclo",
      end_cycle: "Fin del Ciclo",
      is_organic: "Manejo Orgánico",
      seed_brand: "Marca de la Semilla",
      save: "Guardar",
      hint_date: "Fecha",
      crop_name_list: {
        olive: "Aceituna",
        chard: "Acelga",
        achiote: "Achiote",
        agave: "Agave",
        avocado: "Aguacate",
        garlic: "Ajo",
        sesame: "Ajonjolí",
        basil: "Albahaca",
        artichoke: "Alcachofa",
        alcatraz: "Alcatraz",
        shrunkenAlfalfa: "Alfalfa achicalada",
        greenAlfalfa: "Alfalfa verde",
        cotton: "Algodón",
        almond: "Almendro",
        birdseed: "Alpiste",
        amaranth: "Amaranto",
        anise: "Anís",
        celery: "Apio",
        blueberry: "Arándano",
        myrtle: "Arrayán",
        rice: "Arroz",
        greenForageOats: "Avena forrajera en verde",
        oatGrain: "Avena grano",
        bamboo: "Bambú",
        eggplant: "Berenjena",
        beetroot: "Betabel",
        broccoli: "Brocoli",
        peanut: "Cacahuate",
        cocoa: "Cacao",
        cherryCoffee: "Café cereza",
        pumpkin: "Calabaza",
        sweetPotato: "Camote",
        sugarCane: "Caña de azúcar",
        canola: "Canola",
        carambolo: "Carambolo",
        safflower: "Cártamo",
        barley: "Cebada",
        greenForageBarley: "Cebada forrajera en verde",
        onion: "Cebolla",
        chives: "Cebollín",
        ryeGrain: "Centeno grano",
        cherry: "Cereza",
        chabacano: "Chabacano",
        pea: "Chícharo",
        squash: "Chayote",
        chia: "Chía",
        chilacayote: "Chilacayote",
        chillyPepper: "Chile / Pimiento",
        custardApple: "Chirimoya",
        coriander: "Cilantro",
        plum: "Ciruela",
        coconutFruit: "Coco fruta",
        cabbage: "Col (repollo)",
        brusselsSprouts: "Col de Bruselas",
        cauliflower: "Coliflor",
        cumin: "Comino",
        chrysanthemum: "Crisantemo (planta)",
        peach: "Durazno",
        date: "Dátil",
        greenBean: "Ejote",
        cornCob: "Elote",
        dill: "Eneldo",
        epazote: "Epazote",
        asparagus: "Espárrago",
        spicesAndMedicinals: "Especias y medicinales",
        spinach: "Espinaca",
        raspberry: "Frambuesa",
        strawberry: "Fresa",
        bean: "Frijol",
        chickpea: "Garbanzo",
        sunflower: "Girasol",
        pomegranate: "Granada",
        soursop: "Guanábana",
        guava: "Guayaba",
        henequen: "Henequén",
        peppermint: "Hierbabuena",
        aromaticHerbs: "Hierbas aromáticas",
        fig: "Higo",
        jamaica: "Jamaica",
        ginger: "Jenjibre",
        jicama: "Jícama",
        lettuce: "Lechuga",
        lentil: "Lenteja",
        lime: "Lima",
        lemon: "Limón",
        linseed: "Linaza",
        litchi: "Litchi",
        corn: "Maíz",
        macadamia: "Macadamia",
        maguey: "Maguey",
        mamey: "Mamey",
        tangerine: "Mandarina",
        mango: "Mango",
        mangosteen: "Mangostán",
        chamomile: "Manzanilla",
        appleTree: "Manzano",
        passionFruit: "Maracuyá",
        daisyFlower: "Margarita",
        marjoram: "Mejorana",
        melon: "Melón",
        quince: "Membrillo",
        mint: "Menta",
        moringa: "Moringa",
        turnip: "Nabo",
        nanche: "Nanche",
        napa: "Napa",
        orange: "Naranja",
        medlar: "Níspero",
        nochebuena: "Nochebuena (planta)",
        walnut: "Nogal",
        noni: "Noni",
        nopal: "Nopal",
        oregano: "Orégano",
        ornamental: "Ornamentales",
        orchid: "Orquídea (planta)",
        oilPalm: "Palma africana o de aceite",
        potato: "Papa",
        papaya: "Papaya",
        grasslands: "Pastizales",
        matGrass: "Pasto tapete (m2)",
        pasturesAndMeadows: "Pastos y praderas",
        cucumber: "Pepino",
        pearTree: "Peral",
        parsley: "Perejil",
        peron: "Perón",
        persimony: "Persimonio",
        pepper: "Pimienta",
        pineapple: "Piña",
        pinion: "Piñón",
        pistache: "Pistache",
        pitaya: "Pitaya",
        banana: "Plátano",
        pore: "Poro",
        radish: "Rábano",
        rambutan: "Rambután",
        romerito: "Romerito",
        rosemary: "Romero",
        aloe: "Sábila",
        watermelon: "Sandía",
        sorghum: "Sorgo",
        soy: "Soya",
        stevia: "Stevia",
        tobacco: "Tabaco",
        tamarind: "Tamarindo",
        tejocote: "Tejocote",
        tomato: "Tomate Rojo (jitomate)",
        greenTomato: "Tomate Verde",
        thyme: "Tomillo",
        grapefruit: "Toronja (pomelo)",
        clover: "Trébol",
        wheat: "Trigo",
        dutchTulip: "Tulipán holandés",
        tuna: "Tuna",
        grape: "Uva",
        vanilla: "Vainilla",
        purslane: "Verdolaga",
        vine: "Vid",
        cassavaFood: "Yuca alimenticia",
        carrot: "Zanahoria",
        sapodilla: "Zapote",
        blackberry: "Zarzamora",
        zempoalxochitl: "Zempoalxochitl",
        fallow: "Barbecho",
        "pecan nut": "Nuez pecana",
        roses: "Rosas",
        "faba bean": "Haba",
        chestnut: "Castaña",
        other: "Otro",
      },
      select_land_use: "Seleccione un uso de suelo",
      select_irrigation_system: "Seleccione un sistema de riego",
      fill_up_fields: "Llene todos los campos",
      agronomic_managment_edit:
        "¿Está seguro de que desea editar el Manejo Agronómico?",
      feacture_no_offline:
        "Esta característica no está disponible sin conexión",
      select_landuse: "Seleccione el uso de suelo",
      select_crop_name: "Seleccione el nombre del cultivo",
      search: "Buscar...",
      irrigation_system_label: "Sistema de Riego",
      management_label: "Manejo",
      organic_label: "Orgánico",
      conventional_label: "Convencional",
      crop_cycle_label: "Ciclo del Cultivo",
      variety_label: "Variedad",
      land_use_title_main: "Uso de suelo:",
      crop_name_title_main: "Nombre del cultivo:",
      sampler_title: "Muestreadores",
      profile_title: "Perfil",
      reviews_title: "Visita técnica",
      title_territory_cordinators: "Territorio:",
      info_table_areas_sampler: "Información de cada área asignada",
      header_table_area: "Área",
      header_table_status_area: "Estado",
      header_table_city: "Ciudad",
      not_technical_visit: "No hay visitas técnicas",
      detail_technical_visit: "Detalle de visita técnica",
      areas_pendings_label: "Pendientes",
      areas_completed_label: "Completadas",
      assign_areas_completed_label: "Completadas",
      not_areas_pending: "No hay áreas pendientes",
      areas_completed: "Completadas",
      areas_pending: "Pendientes",
      update_areas: "Actualizar áreas",
      label_not_technical_visits: "No hay visitas técnicas para mostrar",
      label_last_update: "Última actualización",
      date_not_update: "No actualizado",
      date_not_completed: "Sin fecha",
      detail_area_assign: "Detalle de asignación de área",
      nav_subtitle_area: "Toda la información de las áreas asignadas",
      title_dialog_area_status: "Estado del Área",
      upload_photo_pending: "Tiene fotos pendientes por subir",
      detail_technical_visits: "Detalle de visitas técnicas",
      success_sync_areas: "Áreas sincronizadas exitosamente",
      error_sync_areas: "Error al sincronizar áreas",
      user_not_found: "Usuario no encontrado",
      label_pending_visits: "Visitas pendientes",
      areas_information: "Información",
      areas_completed_user: "Áreas completadas por usuario",
      error_area_upload: "Error al subir información del área",
      error_area_connection: "Error de conexión, intente nuevamente",
      sampling_label: "Muestreo",
      assign_label: "Asignación",
      users_label: "Usuarios",
      nav_completed_visits: "Visitas Completadas",
      nav_assign_areas: "Asignar Áreas",
      areas_assign: "Áreas Asignadas",
      total_areas: "Total de Áreas",
      completed_assignments: "Completadas",
      pendings_assignments: "Pendientes",
      assigned: "Asignado",
      not_assigned: "No Asignado",
      sampling_list: "Lista de Muestreo",
      upload_list: "Lista de Subida",
      uploading: "Subiendo",
      offline_mode: "Modo Sin Conexión",
      online_mode: "Modo Conexión",
      error_upload_area: "Error al subir información del área",
      error_connection: "Error de conexión, intente nuevamente",
      sync_completed: "Sincronización Completada",
      sync_error: "Error de Sincronización",
      uploading_data: "Subiendo datos...",
      updating_data: "Actualizando datos...",
      success_upload: "Subida Exitosa",
      success_update: "Actualización Exitosa",
      error_upload: "Error de Subida",
      error_update: "Error de Actualización",
      no_pending_photos: "No hay fotos pendientes",
      pending_photos: "Fotos pendientes",
      no_upload_errors: "No hay errores de subida",
      upload_errors: "Errores de Subida",
      no_pending_areas: "No hay áreas pendientes",
      pending_areas: "Áreas pendientes",
      areas_to_sync: "Áreas para sincronizar",
      sync_areas: "Sincronizar Áreas",
      areas_synced: "Áreas Sincronizadas",
      no_sync_errors: "No hay errores de sincronización",
      sync_errors: "Errores de Sincronización",
      not_assigned_areas: "Áreas no asignadas",
      assigned_areas: "Áreas asignadas",
      assigned_areas_list: "Lista de áreas asignadas",
      assigned_area_detail: "Detalle del área asignada",
      area_assignments: "Asignaciones de Áreas",
      assign_areas_title: "Asignar Áreas",
      nav_sync_areas: "Sincronizar Áreas",
      area_assignments_list: "Lista de Asignaciones de Áreas",
      area_assignment_detail: "Detalle de Asignación de Área",
      nav_profile: "Perfil",
      profile_information: "Información del Perfil",
      profile_details: "Detalles del Perfil",
      profile_update: "Actualizar Perfil",
      nav_logout: "Cerrar Sesión",
      logout_message: "¿Está seguro que desea cerrar sesión?",
      logout: "Cerrar Sesión",
      cancel: "Cancelar",
      nav_assign_areas: "Asignar Áreas",
      nav_completed_visits: "Visitas Completadas",
      nav_area_assignments: "Asignaciones de Áreas",
      sync_area_title: "Sincronizar Área",
      no_sync_area: "No hay área para sincronizar",
      sync_area: "Sincronizar Área",
      sync_area_detail: "Detalle de Área Sincronizada",
      sync_area_list: "Lista de Áreas Sincronizadas",
      nav_sync: "Sincronizar",
      nav_completed_assignments: "Asignaciones Completadas",
      nav_pending_assignments: "Asignaciones Pendientes",
      nav_total_assignments: "Total de Asignaciones",
      nav_assignments: "Asignaciones",
      nav_sync_areas: "Sincronizar Áreas",
      sync_area_list: "Lista de Áreas Sincronizadas",
      sync_area_detail: "Detalle de Área Sincronizada",
      nav_profile_information: "Información del Perfil",
      profile_details: "Detalles del Perfil",
      profile_update: "Actualizar Perfil",
      profile_edit: "Editar Perfil",
      profile_save: "Guardar Perfil",
      profile_cancel: "Cancelar",
      profile_success: "Perfil Actualizado Exitosamente",
      profile_error: "Error al Actualizar Perfil",
      nav_logout: "Cerrar Sesión",
      logout_message: "¿Está seguro que desea cerrar sesión?",
      logout: "Cerrar Sesión",
      cancel: "Cancelar",
    },
    pt: {
      cultivableArea: "Superficie cultibable total (ha)",
      other: "Outro",
      confirmation_wihout_qr:
        "Tem a certeza de que pretende finalizar sem um código QR? As subamostras não serão consideradas; apenas os problemas serão registados.",
      finish_sampling_without_qr: "Finalizar sem QR",
      advice_not_project:
        "É necessário criar um projeto de acesso ao território",
      created_project: "Criado",
      no_project: "Nenhum projeto",
      click_map_add_item: "Clique no mapa para adicionar um item",
      add_problems: "Adicionar problemas",
      no_problem_info_defined: "Não foi definida informação do problema",
      define_problem: "Definir problema",
      edit_problem: "Editar problema",
      not_defined: "Não definido",
      problem: "Problema",
      avocado_plague_list: {
        unknown: "Desconhecido",
        oligonychus_yothersi: "Ácaro tostador (Oligonychus yothersi)",
        oligonychus_perseae: "Ácaro branco cristalino (Oligonychus perseae)",
        oligonychus_punicae: "Ácaro vermelho do abacate (Oligonychus punicae)",
        oligonychus_mexicanus:
          "Ácaro vermelho mexicano (Oligonychus mexicanus)",
        copturus_aguacatae: "Broca de ramos (Copturus aguacatae)",
        heilipus_lauri: "Broca grande do caroço (Heilipus lauri)",
        conotrachelus_aguacatae:
          "Broca pequena do caroço (Conotrachelus aguacatae)",
        idona_minuenda: "Cigarrinha do abacate (Idona minuenda)",
        empoasca_abrupta: "Cigarrinha verde (Empoasca abrupta)",
        hemiberlesia_lataniae: "Escama latânia (Hemiberlesia lataniae)",
        pyrrhopyge_chalybea: "Lagarta confete (Pyrrhopyge chalybea)",
        gonodonta_pyrgo: "Lagarta da folha/fruto (Gonodonta pyrgo)",
        sabulodes_aegrotata: "Lagarta falsa medidora (Sabulodes aegrotata)",
        copaxa_multifenestrata: "Lagarta queimadora (Copaxa multifenestrata)",
        amorbia_cuneana: "Lagarta tecedora (Amorbia cuneana)",
        gracillaria_spp: "Minador da folha (Gracillaria spp.)",
        aleurodes_sp: "Mosca-branca comum (Aleurodes sp.)",
        tetraleurodes_perseae:
          "Mosca-branca de faixas vermelhas (Tetraleurodes perseae)",
        aleurodicus_dugesii: "Mosca-branca gigante (Aleurodicus dugesii)",
        bemisia_argentifolii: "Mosca-branca da prata (Bemisia argentifolii)",
        paraleyrodes_perseae:
          "Mosca-branca pulverulenta (Paraleyrodes perseae)",
        aethalion_quadratum: "Mosca verde do abacate (Aethalion quadratum)",
        stenoma_catenifer: "Mariposa broqueadora do caroço (Stenoma catenifer)",
        metcalfiella_monograma: "Periquito do abacate (Metcalfiella monograma)",
        trioza_anceps: "Psilídeo das galhas (Trioza anceps)",
        neohydatothrips_signifer: "Tripes de faixas (Neohydatothrips signifer)",
        pseudophilothrips_perseae:
          "Tripes das galhas (Pseudophilothrips perseae)",
        heliothrips_haemorrhoidalis:
          "Tripes de estufa (Heliothrips haemorrhoidalis)",
        scirtothrips_perseae: "Tripes do abacate (Scirtothrips perseae)",
        frankliniella_bruneri: "Tripes negro (Frankliniella bruneri)",
        frankliniella_occidentalis:
          "Tripes ocidental das flores (Frankliniella occidentalis)",
        tetranychus_urticae:
          "Ácaro-rajado / Ácaro vermelho (Tetranychus urticae)",
        liriomyza_sp: "Minador da folha (Liriomyza sp.)",
        tuta_absoluta: "Traça-do-tomateiro / Broca-do-tomate (Tuta absoluta)",
        aphis_sp_green: "Pulgão verde (Aphis sp.)",
        diaphorina_citri: "Psilídeo dos citros (Diaphorina citri)",
        spodoptera_frugiperda:
          "Lagarta-do-cartucho / Lagarta-militar (Spodoptera frugiperda)",
        keiferia_lycopersicella:
          "Broca-pequena-do-tomate (Keiferia lycopersicella)",
        helicoverpa_zea:
          "Lagarta-da-espiga / Lagarta-do-tomate (Helicoverpa zea)",
        heliothis_virescens:
          "Lagarta-das-maçãs do tabaco (Heliothis virescens)",
        trichoplusia_ni: "Lagarta-falsa-medideira (Trichoplusia ni)",
        manduca_quinquemaculata:
          "Lagarta-corno-do-tomate (Manduca quinquemaculata)",
        spodoptera_exigua: "Lagarta-militar-pequena (Spodoptera exigua)",
        liriomyza_spp: "Mosca-minadora (Liriomyza spp)",
        cydia_pomonella: "Traça-da-maçã (Cydia pomonella)",
        phthorimaea_operculella: "Traça-da-batata (Phthorimaea operculella)",
        heliothis_zea: "Lagarta-da-espiga (Heliothis zea)",
        pectinophora_gossypiella: "Lagarta-rosada (Pectinophora gossypiella)",
        bucculatrix_thurberiella:
          "Perfurador-da-folha do algodão (Buccolatrix thurberiella)",
        estigmene_acrea: "Lagarta-peluda (Estigmene acrea)",
        copitarsia_consueta:
          "Lagarta-do-coração do repolho (Copitarsia consueta)",
        plutella_xylostella: "Traça-das-crucíferas (Plutella xylostella)",
        liriomyza_munda: "Minador da folha (Liriomyza munda)",
        manduca_sexta: "Lagarta-corno-do-tabaco (Manduca sexta)",
        diatraea_grandiosella:
          "Broca-da-cana / Broca-do-colmo (Diatraea grandiosella)",
        carpocapsa_pomonella: "Traça-da-maçã (Carpocapsa pomonella)",
        aeneolamia_contigua: "Cigarrinha-das-pastagens (Aeneolamia contigua)",
        other: "Outro",
      },
      avocado_disease_list: {
        unknown: "Desconhecido",
        damping_off: "Tombamento / Damping-off (Pythium sp.)",
        anthracnose_classic:
          "Antracnose clássica (Colletotrichum gloeosporioides)",
        anthracnose_boninense:
          "Antracnose complexo boninense (Colletotrichum boninense)",
        bacterial_canker: "Cancro bacteriano (Xanthomonas sp.)",
        sooty_mold: "Fumagina (Capnodium sp.)",
        angular_leaf_spot: "Mancha angular da folha (Cercospora purpurea)",
        tar_spot: "Mancha de alcatrão / Varicela (Phyllachora gratissima)",
        leaf_spot_septoria: "Mancha foliar por Septoria (Septoria sp.)",
        black_spot: "Mancha negra (Diplocarpon rosae)",
        fusarium_wilt: "Murcha / Fusariose (Fusarium sp.)",
        root_rot_rhizoctonia: "Podridão da raiz (Rhizoctonia solani)",
        fruit_rot_diplodia: "Podridão do fruto, Diplodia (Diplodia sp.)",
        fruit_rot_dothiorella:
          "Podridão do fruto, Dothiorella (Dothiorella sp.)",
        scab: "Sarna do abacate (Sphaceloma perseae)",
        avocado_root_rot: "Tristeza do abacateiro (Phytophthora cinnamomi)",
        botrytis_cinerea: "Mofo cinzento / Botrite (Botrytis cinerea)",
        cladosporium_fulvum: "Mofo da folha do tomate (Cladosporium fulvum)",
        colletotrichum_acutatum: "Antracnose (Colletotrichum acutatum)",
        glomerella_cingulata: "Antracnose (Glomerella cingulata)",
        monilia_spp: "Podridão do fruto, Monilia spp. (Monilia spp.)",
        mycosphaerella_fragariae: "Mancha púrpura (Mycosphaerella fragariae)",
        peronospora_rubi: "Míldio da amoreira (Peronospora rubi)",
        other: "Outra",
      },
      avocado_weeds_list: {
        chenopodium_album: "Quelite-salso (Chenopodium album)",
        equisetum_spp: "Cavalinha (Equisetum spp.)",
        eleusine_indica: "Pé-de-galinha (Eleusine indica)",
        convolvulus_arvensis: "Corriola (Convolvulus arvensis)",
        euphorbia_prostrata: "Leiteiro-rasteiro (Euphorbia prostrata)",
        rumex_crispus: "Língua-de-vaca (Rumex crispus)",
        sorghum_halepense: "Capim-massambará (Sorghum halepense)",
        setaria_verticillata: "Capim-rabo-de-raposa (Setaria verticillata)",
        cyperus_rotundus: "Tiririca (Cyperus rotundus)",
        other: "Outra",
      },
      avocado_nutrition: {
        nitrogen: "Azoto (N)",
        zinc: "Zinco (Zn)",
        iron: "Ferro (Fe)",
        potassium: "Potássio (K)",
        boro: "Boro (B)",
        other: "Outra",
      },
      plague: "Praga",
      disease: "Doença",
      weed: "Mato",
      nutrition: "Deficiências nutricionais",
      specific_problem: "Problema específico",
      problem_type: "Tipo de problema",
      problem_info: "Informação do problema",
      soil: "Solo",
      longitudeRange: "A longitude deve estar entre -180 e 180",
      latitudeRange: "A latitude deve estar entre -90 e 90",
      bothFieldsRequired:
        "Ambos campos (latitude e longitude) são obrigatórios",
      additionalDetails: "Detalhes complementares",
      descriptionSaved: "Descrição salva",
      projectEndDate: "Data de término do projeto",
      tentativeFieldSamplingDate: "Data de amostragem em campo (provisória)",
      commercialStartDate: "Data de início comercial",
      importantDates: "Fechas importantes",
      noCrop: "Sem cultivo",
      targetCrops: "Cultivo(s) alvo",
      agriculturalDetails: "Detalhes agrícolas",
      responsible: "Responsável",
      notSpecified: "Não especificado",
      projectType: "Tipo de projeto",
      generalInformation: "Informações gerais",
      enterCoordinates:
        "Digite as coordenadas da imagem ou localize o ponto clicando no mapa",
      selectImage: "Selecione imagem(ns)",
      addMultipleSubsamples: "Adicionar múltiplas subamostras",
      imagePreview: "Pré-visualização da imagem",
      deleteSubsample: "Excluir subamostra",
      centerSubsample: "Centralizar subamostra",
      relocate: "Reubicar-se",
      images_without_metadata: "Imagens sem metadados (não serão enviadas)",
      subsample_outside_polygon: "Subamostra fora do polígono",
      image_load_error: "Algo deu errado ao carregar a imagem",
      add_multiple_subsamples: "Adicionar várias subamostras",
      sampling_date: "Data da amostragem",
      updated_information: "Informação atualizada",
      current_package: "Pacote atual",
      select_sampling_type: "Selecione o tipo de amostragem",
      update_sample_data: "Atualizar dados da amostra",
      label_new_farm: "Nova produtora/empresa",
      general_description: "Visão geral",
      request_guide_dialog_content:
        "A solicitação de guia foi enviada, seu guia será enviado para o seu email",
      request_guide_dialog_title: "Solicitação de guia",
      request_guide_label: "Solicitar guia de retorno",
      label_total_samples: "Total de amostras no kit",
      origin_zip_code_label: "Código postal de origem",
      selectKitType: "Selecione o tipo de kit",
      kitType: "Tipo de kit",
      send_label: "Enviar",
      request_guide_title: "Solicitar guía",
      selectIrrigationSystem: "Selecione o sistema de irrigação",
      label_longitude: "Longitude",
      label_latitude: "Latitude",
      label_no_evidence: "Sem evidência",
      label_evidence: "Evidência",
      label_actions: "Ações",
      label_image: "Imagem",
      label_sampling_date: "Data de amostragem",
      label_coordinates: "Coordenadas",
      label_center: "Centralizar",
      label_select_image: "Selecionar imagem",
      label_add_image: "Adicionar imagem",
      label_add_version: "Adicionar versão",
      label_name_or_code_profitability: "Nome ou Código de rentabilidade",
      label_no_profitability: "Sem rentabilidade",
      label_sample: "Amostra",
      label_origin_postal_code: "Código postal de origem",
      label_add_sample: "Adicionar amostra",
      label_clear_list: "Limpar lista",
      label_use: "Uso",
      label_active_ingredient: "Ingrediente ativo",
      label_product_name_brand: "Nome do produto (marca)",
      label_at_least_one_sample: "Deve haver pelo menos uma amostra",
      label_compost_type: "Tipo de composto",
      label_analysis_type: "Tipo de análise",
      label_without_crop: "Sem cultivo",
      label_with_crop: "Com cultivo",
      label_relogin: "Faça o login novamente",
      label_session_expired: "Sessão expirada",
      label_new_sample: "Nova amostra",
      label_phone: "Telefone",
      label_last_name: "Sobrenome",
      label_basic_information: "Informações básicas",
      label_profile: "Perfil",
      label_application_removed: "Aplicação removida",
      label_add_application: "Adicionar aplicação",
      label_applications: "Aplicações",
      label_product: "Produto",
      label_sample_without_advisor: "Amostra sem assessor",
      label_substrate_sample: "Amostra de substrato",
      label_product_sample: "Amostra de produto",
      label_compost_sample: "Amostra de composto",
      label_plant_sample_without_reference: "Amostra vegetal sem referência",
      label_soil_sample: "Amostra de solo",
      label_genomic_plant_sample: "Amostra vegetal genômica",
      label_genomic_sample: "Amostra genômica",
      label_project_detail: "Detalhe do projeto",
      label_project_created: "Projeto criado",
      label_project_updated: "Projeto atualizado",
      label_add_at_least_one_item: "Adicione pelo menos 1 item",
      label_add_product: "Adicionar produto",
      label_objective: "Objetivo",
      label_active_ingredient: "Ingrediente ativo",
      label_add_application: "Adicionar aplicação",
      label_application_added: "Aplicação adicionada",
      label_dose: "Dose",
      label_add_product: "Adicionar produto",
      label_add_phenological_stage: "Adicionar estágio fenológico",
      label_select_irrigation_unit: "Selecione zona(s) de amostragem",
      label_contrast_b: "Contraste B",
      label_contrast_a: "Contraste A",
      label_select_variant: "Selecione a variante",
      label_select_project_type: "Selecione o tipo de projeto",
      label_agricultural_units: "Zonas de amostragem",
      label_project_information: "Informações do projeto",
      label_create_project: "Criar projeto",
      label_update_project: "Atualizar projeto",
      label_no_projects: "Sem projetos",
      label_add_producer_company: "Adicionar produtora/empresa",
      label_search_folio: "Buscar folio",
      label_no_results: "Sem resultados",
      label_projects: "Projetos",
      label_download_sampling_app: "Baixar app de amostragem",
      label_no_georeference: "Sem georreferência",
      label_profitability: "Rentabilidade",
      label_fungi: "Fungos",
      label_bacteria: "Bactérias",
      label_cellulolytic_activity: "Atividade celulolítica",
      label_siderophores: "Sideróforos",
      label_potassium_solubilization: "Solubilização de potássio (K)",
      label_phosphorus_solubilization: "Solubilização de fósforo (P)",
      label_negative_control: "Controle negativo",
      label_nutrition: "Nutrição",
      label_control: "Controle",
      label_soil_disease_control: "Controle de doenças do solo",
      label_no_not_detected: "Não há não detectados",
      label_beneficial: "Benéfico",
      label_pathogen: "Patógeno",
      label_type: "Tipo",
      label_not_detected: "Não detectados",
      label_no_pathogens: "Não há patógenos",
      label_soil_pathogen_detection: "Detecção de patógenos no solo",
      label_no_beneficials: "Ou não há benéficos",
      label_concentration: "Concentração",
      label_taxonomic_identification: "Identificação taxonômica",
      label_microorganism: "Micro-organismo",
      label_soil_beneficials_of_interest: "Beneficiais de interesse no solo",
      label_biological_capital_measurement: "Medição do Capital Biológico",
      label_soil_texture: "Textura do solo",
      label_carbon_capture_pox: "Captura de carbono (POX)",
      label_organic_matter: "Matéria orgânica",
      label_soil_health_parameters: "Parâmetros de saúde do solo",
      label_irrigation_unit: "Zona de amostragem",
      label_analysis_detail: "Detalhe da análise",
      label_analysis_in_progress: "Análise em progresso",
      label_not_available: "Não disponível",
      label_next_result_date: "Data do próximo resultado",
      label_analysis_results: "Resultados da análise",
      label_close: "Fechar",
      label_subsample_photos: "Fotos das subamostras",
      label_polygon_not_available: "Polígono não disponível",
      label_sample_detail: "Detalhe da amostra",
      label_measurement: "Medição",
      label_valuation: "Valuação",
      label_valuated: "Valuado",
      label_valuating: "Valuando",
      label_measured: "Medido",
      label_measuring: "Medindo",
      label_sent: "Enviado",
      label_received: "Recebido",
      label_sampling_finished: "Amostragem finalizada",
      label_detail: "Detalhe",
      label_analysis_folio: "Fólio de análise",
      label_status: "Status",
      label_apply: "Aplicar",
      label_advanced_filters: "Filtros avançados",
      label_no_samples: "Não há amostras",
      label_samples_list: "Lista de amostras",
      label_at_least_one_sample_required: "Deve existir pelo menos uma amostra",
      label_sample_already_completed: "A amostra já estava finalizada",
      label_enter_a_valid_folio: "Digite um folheto válido",
      label_enter_an_unregistered_folio: "Digite um folio não registrado",
      label_sample_successfully_registered: "Amostra registrada com sucesso",
      label_browser_lacks_features: "O navegador parece faltar recursos",
      label_requested_front_camera_although_none_available:
        "Você solicitou a câmera frontal mesmo não havendo nenhuma disponível?",
      label_camera_may_be_in_use: "A câmera pode já estar em uso",
      label_page_not_served_over_https_or_localhost:
        "A página não está sendo servida por HTTPS (ou localhost)",
      label_no_suitable_camera_device_installed:
        "Nenhum dispositivo de câmera adequado instalado",
      label_user_denied_camera_access_permission:
        "Usuário negou permissão de acesso à câmera",
      label_finish_sampling: "Finalizar amostragem",
      label_finish_with_scanner: "Finalizar com scanner",
      label_qr_not_found: "QR não encontrado",
      label_search_qr: "Buscar QR...",
      label_sick_plot: "Área doente",
      label_sample_description: "Descrição da amostra",
      label_plant_sample_type: "Tipo de amostra vegetal",
      label_sampling_type: "Tipo de amostragem",
      label_select_package: "Selecione o pacote",
      label_sample_type: "Tipo de amostra",
      label_phonological_stage: "Estágio fenológico",
      label_number_of_subsamples: "Número de subamostras",
      label_delete_subsamples: "Excluir subamostras",
      label_add_subsamples: "Adicionar subamostras",
      label_finish_sampling: "Finalizar amostragem",
      label_not_applicable: "Não se aplica",
      label_no_areas: "Não há áreas",
      label_no_agronomic_management: "Sem manejo agronômico",
      label_territory_list: "Lista de territórios",
      label_at_least_one_item_required:
        "É necessário selecionar pelo menos um item",
      label_agronomic_management_saved: "Manejo agronômico salvo",
      label_crop_cycle_ended:
        "O ciclo da cultura terminou. Deseja inserir um novo?",
      label_new_crop_cycle: "Novo ciclo de cultivo",
      label_add_area_with_highest_problem_severity:
        "Adicionar área com maior gravidade de problemas",
      label_previous_cycle: "Ciclo anterior",
      label_problems_detected: "Problemas detectados",
      label_select_tonnage_unit: "Selecione a unidade de tonelagem",
      label_tonnage: "Tonelagem",
      label_average_yield_per_hectare_acre:
        "Qual é o rendimento médio por hectare/acres?",
      label_list_of_inputs_applied_during_crop_cycle:
        "Lista de insumos aplicados durante o ciclo da cultura",
      label_cycle_end: "Fim do ciclo",
      label_cycle_start: "Início do ciclo",
      label_variety_optional: "Variedade (opcional)",
      label_select_crop: "Selecione uma cultura",
      label_crop_cycle: "Ciclo de cultivo",
      label_description: "Descrição",
      label_crop_success_definition: "Definição de sucesso da cultura",
      label_what_is_your_agricultural_management_practice:
        "Qual é a sua prática de manejo agrícola?",
      label_select_shadow_type: "Selecione o tipo de sombra",
      label_confirm_delete_area: "Tem certeza de que deseja excluir esta área?",
      label_delete_area: "Excluir área",
      label_area_deleted: "Área excluída",
      label_cannot_delete_area_with_samples:
        "Não é possível excluir uma área com amostras",
      label_days: "Dias",
      label_on_hold: "Em pausa",
      label_soil_of: "Terra de",
      label_crop_of: "Cultivo de",
      label_sterile: "Estéril",
      label_redraw: "Redesenhar",
      label_qr_invalid: "QR inválido",
      label_qr_registered: "QR registrado",
      label_sampling_in_progress: "Amostragem em andamento",
      label_sampling_not_started: "Amostragem não iniciada",
      label_add_crop: "Adicionar cultivo",
      label_name: "Nome",
      label_enter_agronomic_management_before_sampling:
        "Insira o manejo agronômico antes de amostrar (Obrigatório)",
      label_rename: "Renomear",
      label_add_area: "Adicionar área",
      label_cultivation_area_name: "Nome da área de cultivo",
      label_confirm_edit_agronomic_management:
        "Tem certeza de que deseja editar o manejo agronômico da área?",
      label_agronomic_management: "Manejo agronômico",
      label_management: "Gerenciamento",
      label_take_sample: "Tomar amostra",
      label_results: "Resultados",
      label_draw: "Desenhar",
      label_repeat: "Repetir",
      label_back: "Voltar",
      label_territory: "Território",
      label_prospect_created: "Prospecto criado",
      label_prospect_updated: "Prospecto atualizado",
      label_new_prospect: "Novo prospecto",
      label_update_prospect: "Atualizar prospecto",
      label_update_prospect: "Atualizar prospecto",
      label_no_zone_assigned_prospect:
        "Nenhuma zona atribuída ao prospecto, deseja continuar?",
      label_contact_last_name: "Sobrenome do contato",
      label_removed_from_favorites: "Removido dos favoritos",
      label_added_to_favorites: "Adicionado aos favoritos",
      label_make_client: "Fazer cliente",
      label_distributor_change_successful:
        "Mudança de distribuidor bem-sucedida",
      label_client_created: "Produtor/Empresa criada",
      label_client_updated: "Produtor/Empresa atualizado",
      label_no_zone_assigned:
        "Nenhuma zona atribuída ao prospecto, deseja continuar?",
      label_logout_confirmation: "Tem certeza de que deseja sair?",
      label_confirmation: "Confirmação",
      label_state: "Estado",
      label_city: "Cidade",
      label_country: "País",
      label_neighborhood: "Bairro",
      label_interior_number: "Número interior",
      label_exterior_number: "Número exterior",
      label_postal_code: "Código postal",
      label_street: "Rua",
      label_update_client: "Atualizar Produtor/Empresa",
      label_address: "Endereço",
      label_rfc: "RFC",
      label_phone: "Telefone",
      label_contact_name: "Nome do contato",
      label_zone: "Zona",
      label_contact_information: "Informações de contato",
      label_company_name: "Razão social",
      label_client_created: "Produtor/Empresa criada",
      advice_error: "Algo deu errado, tente novamente",
      label_update: "Atualizar",
      advice_not_prospects: "Não há prospectos",
      advice_no_clients: "Não há agrícola",
      label_clients: "Produtor/Empresa",
      label_prospects: "Prospectos",
      valid_email_required: "Você deve inserir um email válido",
      select_distributor: "Selecione distribuidor",
      field_required: "O campo é obrigatório",
      email_label: "email",
      label_continue: "Continuar",
      enter_email: "Digite seu endereço de email",
      forget_password_title: "Esqueceu sua senha",
      send_email_password:
        "Um email foi enviado para seu endereço de email para mudar sua senha",
      error_changing_password: "Erro ao tentar mudar a senha",
      login_error_check_info: "Erro ao fazer login, verifique suas informações",
      label_download_pdf: "Baixar PDF",
      label_client_accept: "Aceito pelo cliente",
      download_sampling_app: "Baixar app de amostragem",
      home_menu_label_change_dis: "Mudar distribuidor",
      change_language: "Mudar idioma",
      download_app: "Baixar app de amostragem Solena Explore",
      forgot_your_password: "Esqueceu sua senha?",
      app_name: "Solena Explore",
      navigation_drawer_open: "Menu de Navegação Aberto",
      navigation_drawer_close: "Fechar Menu de Navegação",
      nav_header_title: "Android Studio",
      nav_header_desc: "Cabeçalho de Navegação",
      action_samples: "Amostras",
      menu_territory: "Território",
      menu_samples: "Amostras",
      menu_log_out: "Sair",
      app_name_splash: "Solena (Beta) 1.3.6",
      description_logo: "Logo da Solena",
      prompt_email: "Usuário",
      prompt_password: "Senha",
      action_sign_in: "Iniciar Sessão",
      action_sign_in_short: "Entrar",
      welcome: "Bem-vindo",
      invalid_username: "E-mail inválido",
      invalid_password: "Senha incorreta",
      login_failed: "Falha ao entrar",
      fill_fields: "Preencha ambos os campos",
      user_not_saved: "Usuário não salvo no dispositivo",
      user_wrong: "Tente acessar do aplicativo web Solena Explore",
      sample_photo_activity_title: "Foto da Amostra",
      detail_sample_activity_title: "Amostragem de Solo",
      image_capture_failed: "Falha na captura de imagem",
      error_to_upload_photo: "Erro ao enviar a foto, tente novamente",
      area_update_failure: "Falha na atualização da área",
      area_update_db_failure: "Erro ao salvar a foto, tente novamente",
      captured_image: "Subamostra",
      location_wrong: "Carregando localização, por favor aguarde",
      folio_wrong: "Erro ao salvar a amostra",
      wrong_folio_length: "O folio deve ter 14 dígitos",
      detecting_QR: "Finalizar Amostragem",
      area_name: "Nome da Área",
      area_length: "Área: 100 ha",
      perimeter: "Perímetro: 3,544.91 m",
      repeat: "Repetir",
      accept: "Aceitar",
      photo_needed: "Não há amostras para registrar",
      connection_needed: "Sem conexão à internet",
      address_needed: "Complete seu perfil e informações de endereço.",
      area_updated_fail: "Falha na atualização da área",
      failed_sync: "Falha na sincronização da área:",
      area_server_update_fail: "Erro ao enviar alterações da área",
      samples_taken: "Amostragem concluída, você pode finalizar agora",
      areas_update_async_successful: "Dados sincronizados com sucesso",
      areas_update_async_successful_errors: "Dados sincronizados com erros",
      local_area_failure: "Erro de atualização da área no dispositivo",
      NOT_ASSIGNED: "NÃO ATRIBUÍDO",
      NOT_STARTED: "Pronto para amostrar",
      COMPLETED: "CONCLUÍDO",
      IN_PROGRESS: "Amostragem em progresso",
      INACCESSIBLE: "INACESSÍVEL",
      NOT_VALID: "NÃO VÁLIDO",
      VALIDATED: "VALIDADO",
      VALIDATION_PENDING: "VALIDAÇÃO PENDENTE",
      area: "Área",
      perimeter_: "Perímetro:",
      started_sample: "Início da amostragem",
      enter_area: "Pode entrar na área de amostragem?",
      not: "Não",
      yes: "Sim",
      suggested_points: "PONTOS DE DESTINO",
      sample_taken: "Amostras:",
      elapsed_time: "Tempo de amostragem:",
      waiting_map: "Aguardando posição...",
      photo_error: "Erro ao enviar imagem, tente novamente",
      api_error: "Erro no servidor:",
      conecction_error:
        "Erro de conexão, aguardando conexão para atualizar áreas",
      shipment_label: "Envio da amostra de solo",
      shipment_question: "Gerar guia para envio da amostra?",
      input_folio: "Digite o Folio da amostra",
      folio: "Folio",
      cancel: "Cancelar",
      delete: "Excluir",
      finish: "Finalizar",
      title_dialog_finish: "Enviar amostra",
      warning_qr: "QR inválido, insira manualmente",
      not_permissions_qr: "Sem permissões da câmera",
      qr_foto_error: "Erro ao finalizar a amostragem, tente novamente",
      offline: "Sem internet, modo offline",
      online: "Conexão à internet restaurada",
      syncing_area: "Sincronizando dados, por favor aguarde...",
      no_internet: "Certifique-se de estar conectado à internet",
      connection_lost: "Conexão à internet perdida",
      acept: "Aceitar",
      porcentage_photo: "/100",
      areas: "Áreas: ",
      photoCountAsync: "Fotos:",
      landUse: "Uso do Solo",
      landUse_list: {
        sterile: "Estéril",
        cropLand: "Terreno Agrícola",
      },
      irrigations_list: {
        drip: "Gotejamento",
        pivot: "Pivotante",
        wheeled: "Inundação",
        microspray: "Microaspersão",
        "without irrigation": "Sem Irrigação",
      },
      shadow_type: {
        "Shade cloth": "Tela de sombra",
        Greenhouse: "Estufa",
        "Open field": "Campo aberto",
        Macrotunnel: "Macrotúnel",
      },
      management_practices: {
        TILLAGE: "Lavoura reduzida",
        CROP_ROTATION: "Rotação de Cultura",
        COMPOST_APPLY: "Aplicação de Compostagem",
        CROP_COVER: "Culturas de Cobertura",
        PEST_MANAGEMENT: "Manejo Integrado de Pragas",
        OTHER: "Outro",
        NONE: "Nenhuma",
      },
      propagation_method: {
        graft: "Enxerto",
        frank: "Franco",
      },
      agroinputs: {
        inputWeed: "Controle de ervas daninhas",
        inputPest: "Controle de pragas (insetos)",
        inputPhytopathogen: "Controle de Fitopatógenos",
        inputConditioner: "Condicionador de solo",
        inputFungi: "Inoculantes fúngicos",
        inputBacteria: "Inoculantes bacterianos",
        inputAlgae: "Inoculantes à base de algas",
      },
      agroinputs_descriptions: {
        inputWeed: "Controle de ervas daninhas - Nome do produto (opcional)",
        inputPest: "Controle de pragas (insetos) - Nome do produto (opcional)",
        inputPhytopathogen:
          "Controle de Fitopatógenos - Nome do produto (opcional)",
        inputConditioner:
          "Condicionador de solo - exemplo: ácidos fúlvicos, húmicos, cal agrícola, etc.",
        inputFungi: "Inoculantes fúngicos - exemplo: Trichoderma, etc.",
        inputBacteria: "Inoculantes bacterianos - exemplo: Pseudomonas, etc.",
        inputAlgae: "Inoculantes à base de algas - exemplo: Ascophyllum, etc.",
      },
      tonnageUnits: {
        HECTARE: "Hectare",
        ACRE: "Acre",
      },
      issueList: {
        salinity: "Salinidade",
        soilCompaction: "Compactação do solo",
        alkalinity: "Solo alcalino (pH > 7.0)",
        acidity: "Solo ácido (pH < 6)",
        heavyMetals: "Metais pesados no solo",
        recurrentDiseases: "Doenças recorrentes",
        percentageOrganicMatter: "Baixa matéria orgânica no solo (< 1 %)",
        other: "Outro",
      },
      phenologicalStages: {
        Transplanting: "Transplante",
        "Vegetative growth": "Crescimento Vegetativo",
        Bloom: "Floração",
        Harvest: "Colheita",
        "Pre-planting": "Pré-semeadura",
        Sowing: "Semeadura",
        Sprout: "Emergência",
        Tuberization: "Tuberação",
        "Tuber filling": "Preenchimento de tubérculos",
        "Foliage development": "Desenvolvimento foliar",
        "Foliar expansion": "Expansão foliar",
        "First leaf": "Primeira folha",
        "Third leaf": "Terceira folha",
        "Fifth leaf": "Quinta folha",
        "Start of bulbing": "Início da bulbilização",
        "Bulb growth": "Crescimento do bulbo",
        "Fruit maturity": "Maturação do fruto",
        Sprouting: "Brotamento",
      },
      analysisTypes: {
        INITIAL: "Inicial",
        MONITORING: "Monitoramento",
      },
      samplingType: {
        CLASSIC: "Amostragem de solo",
        MAS_VEGETABLE: "Amostragem vegetal",
      },
      kitTypes: {
        CLASSIC: "Tradicional",
        HYBRID: "Híbrido",
        QPCR: "QPCR",
      },
      vegetalSampleTypes: {
        Seedling: "Plântula",
        Root: "Raiz",
        Seed: "Semente",
        Stem: "Caule",
        Leaf: "Folha",
        Fruit: "Fruto",
        Flower: "Flor",
      },
      status_samples: {
        ALL: "Todos",
        IN_PROGRESS: "Em Progresso",
        VALIDATED: "Finalizado",
        RECEIVED: "Recebido",
        MEASURING: "Medindo",
        MEASURED: "Medido",
        VALUATING: "Avaliando",
        VALUATED: "Avaliado",
      },
      symp: {
        Clorosis: "Clorose",
        "Leaf spots": "Manchas nas folhas",
        Necrosis: "Necrose",
        Wilting: "Murcha",
        Dwarfism: "Nanismo",
        "Early wilting": "Murcha precoce",
        "Root rot": "Apodrecimento da raiz",
        "Performance reduction": "Redução do rendimento",
        "Plant Chlorosis": "Clorose da planta",
        "Plant with spots on the leaves": "Planta com manchas nas folhas",
        "Plant with necrosis": "Planta com necrose",
        "Healthy plant": "Planta saudável",
        "Leaf top with chlorosis": "Folha superior com clorose",
        "Leaf top with spots": "Folha superior com manchas",
        "Leaf top with necrosis": "Folha superior com necrose",
        "Leaf top with wilting": "Folha superior com murcha",
        "Leaf top healthy": "Folha superior saudável",
        "Leaf middle with chlorosis": "Folha média com clorose",
        "Leaf middle with spots": "Folha média com manchas",
        "Leaf middle with necrosis": "Folha média com necrose",
        "Leaf middle with wilting": "Folha média com murcha",
        "Leaf middle healthy": "Folha média saudável",
        "Leaf lower with chlorosis": "Folha inferior com clorose",
        "Leaf lower with spots": "Folha inferior com manchas",
        "Leaf lower with necrosis": "Folha inferior com necrose",
        "Leaf lower with wilting": "Folha inferior com murcha",
        "Leaf lower healthy": "Folha inferior saudável",
        "Stem with dwarfism": "Caule com nanismo",
        "Early wilting stem": "Caule com murcha precoce",
        "Stem with necrosis": "Caule com necrose",
        "Healthy stem": "Caule saudável",
        "Root rot": "Raiz com apodrecimento",
        "Root with necrosis": "Raiz com necrose",
        "Healthy root": "Raiz saudável",
        "Fruit with reduced yield": "Fruto com redução do rendimento",
        "Fruit with necrosis": "Fruto com necrose",
        "Healthy fruit": "Fruto saudável",
      },
      symp_avocado: {
        "Regressive death": "Morte descendente",
        Defoliation: "Desfolha",
        Cancer: "Câncer",
        Chlorosis: "Clorose (amarelecimento)",
        "Limb drying": "Secagem de extremidades",
        "Sooty mold": "Fumagina",
        "Drying with attached leaves": "Secagem com folhas aderidas",
        Galling: "Galha (tumores)",
        "Leaf Spots": "Manchas foliares",
        "Trunk Canker": "Cancro do tronco",
        "Peduncle Ringing (Fruit)": "Anelamento do pedúnculo (Fruto)",
        "Root Rot": "Podridão radicular",
        Healthy: "Saudável",
      },
      symp_blackberry_raspberry: {
        Chlorosis: "Clorose (amarelecimento)",
        Wilting: "Murcha/Flacidez",
        "Leaf spots": "Manchas foliares",
        "Stem streaking": "Riscado de caule",
        Defoliation: "Desfolha",
        Blight: "Murcha (secagem de brotos)",
        Galling: "Galha (tumores)",
        "Growth delay": "Atraso de crescimento",
        "Base Stem Girdling": "Estrangulamento na base do caule",
        "Root Rot": "Podridão radicular",
        Healthy: "Saudável",
      },
      symp_strawberry: {
        Wilting: "Murcha/Flacidez",
        "Leaf spots": "Manchas foliares",
        "Crown rot": "Podridão da coroa",
        Defoliation: "Desfolha",
        Chlorosis: "Clorose (amarelecimento)",
        "Growth delay": "Atraso de crescimento",
        "Base Stem Girdling": "Estrangulamento na base do caule",
        "Reddish Spots on Leaf Edges":
          "Manchas avermelhadas nas bordas das folhas",
        "Root Rot": "Podridão radicular",
        Healthy: "Saudável",
      },
      symp_blueberry: {
        Wilting: "Murcha/Flacidez",
        "Basal rot": "Podridão basal",
        "Leaf spots": "Manchas foliares",
        Blight: "Murcha (secagem de brotos)",
        Chlorosis: "Clorose (amarelecimento)",
        "Growth delay": "Atraso de crescimento",
        "Crown Gall or Tumor": "Galha ou tumor de coroa",
        "Base Stem Girdling": "Estrangulamento na base do caule",
        "Root Rot": "Podridão radicular",
        Healthy: "Saudável",
      },
      symp_orange: {
        "Chlorosis (Yellowing)": "Clorose (Amarelecimento)",
        "Dieback (Downward)": "Morte regressiva (Descendente)",
        "Defoliation (Premature leaf drop)":
          "Desfoliação (Queda prematura de folhas)",
        "Root Rot": "Podridão radicular",
        Healthy: "Saudável",
      },
      symp_chili_peppers_cucumber_tomato: {
        "Chlorosis (Yellowing)": "Clorose (Amarelecimento)",
        "Leaf Spots": "Manchas foliares",
        "Dieback (Downward)": "Morte regressiva (Descendente)",
        "Wilting / Stem or Leaf Flaccidity":
          "Murcha / Flacidez do caule ou folhas",
        "Root Gall (Nematodes)": "Galhas nas raízes (Nematoides)",
        "Base Stem Girdling": "Estrangulamento na base do caule",
        "Blight (Chlorosis and/or Shoot Drying)":
          "Queima (Clorose e/ou secagem dos brotos)",
        "Growth Retardation": "Atraso no crescimento",
        "Root Rot": "Podridão radicular",
        "Stem Spots": "Manchas no caule",
        Healthy: "Saudável",
      },
      symp_potato: {
        "Chlorosis (Yellowing)": "Clorose (Amarelecimento)",
        "Leaf Spots": "Manchas foliares",
        "Wilting / Stem or Leaf Flaccidity":
          "Murcha / Flacidez do caule ou folhas",
        "Root Gall (Nematodes)": "Galhas nas raízes (Nematoides)",
        "Base Stem Girdling": "Estrangulamento na base do caule",
        "Blight (Chlorosis and/or Shoot Drying)":
          "Queima (Clorose e/ou secagem dos brotos)",
        "Growth Retardation": "Atraso no crescimento",
        "Root Rot": "Podridão radicular",
        "Tuber Necrosis / Rot": "Necrose / Podridão do tubérculo",
        "Scab / Tuber Scab": "Sarna / Sarna de tubérculo",
        "Black Scab Tuber": "Sarna Negra de tubérculo",
        "Stem Spots": "Manchas no caule",
        Healthy: "Saudável",
      },
      symp_asparagus: {
        "Chlorosis (Yellowing)": "Clorose (Amarelecimento)",
        "Dieback (Downward)": "Morte regressiva (Descendente)",
        "Root Gall (Nematodes)": "Galhas nas raízes (Nematoides)",
        "Blight (Chlorosis and/or Shoot Drying)":
          "Queima (Clorose e/ou secagem dos brotos)",
        "Growth Retardation": "Atraso no crescimento",
        "Crown Rot": "Podridão da coroa",
        "Root Rot": "Podridão radicular",
        "Stem Spots": "Manchas no caule",
        "Bud Scaling": "Descamação de gemas",
        "Purple/Pink Spear Discoloration":
          "Descoloração roxa/rosa dos turiones",
        Healthy: "Saudável",
      },
      moTypes: {
        bacteria: "Bactéria",
        fungi: "Fungo",
        nematode: "Nematódeo",
      },
      status_projects: {
        NEW: "Novo",
        PROCESSING: "Processando",
        IN_REVIEW: "Em revisão",
        IN_PROGRESS: "Em progresso",
        FINISHED: "Concluído",
        ACCEPTED: "Aceito",
      },
      miss_test_variants: {
        CONTRAST: "Contraste",
        UNCONTRASTED: "Sem contraste",
        RASTER: "Raster",
      },
      miss_test_variants_setup: {
        CONTRAST: "Controle",
        UNCONTRASTED: "Sem controle",
      },
      compotition_types: {
        LIQUID: "Líquido",
        SOLID: "Sólido",
      },
      sampleTypeNotGeo: {
        COMPOST: "Composto",
        PRODUCT: "Produto",
        SUBSTRATUM: "Substrato",
        VEGETABLE: "Vegetal sem georreferência",
      },
      sampleTypeNotGeoAll: {
        COMPOST: "Composto",
        PRODUCT: "Produto",
        SUBSTRATUM: "Substrato",
        VEGETABLE: "Vegetal sem georreferência",
        SOLENA_NO_ADVISOR: "Cliente sem assessor",
      },
      status_profits: {
        ALL: "Todos",
        NEW: "Novo",
        PROPOSAL: "Proposta",
        ACCEPTED: "Aceito",
        FINISHED: "Finalizado",
      },
      agronomic_managment_title: "Manejo Agronômico",
      crop_name: "Nome da Cultura",
      start_cycle: "Início do Ciclo",
      end_cycle: "Fim do Ciclo",
      is_organic: "Manejo Orgânico",
      seed_brand: "Marca da Semente",
      save: "Salvar",
      hint_date: "Data",
      crop_name_list: {
        olive: "Azeitona",
        chard: "Acelga",
        achiote: "Achiote",
        agave: "Agave",
        avocado: "Abacate",
        garlic: "Alho",
        sesame: "Gergelim",
        basil: "Manjericão",
        artichoke: "Alcachofra",
        alcatraz: "Alcatraz",
        shrunkenAlfalfa: "Alfafa murcha",
        greenAlfalfa: "Alfafa verde",
        cotton: "Algodão",
        almond: "Amêndoa",
        birdseed: "Semente de pássaro",
        amaranth: "Amarantos",
        anise: "Anis",
        celery: "Aipo",
        blueberry: "Mirtilo",
        myrtle: "Myrtles",
        rice: "Arroz",
        greenForageOats: "Aveia forrageira verde",
        oatGrain: "Aveia grão",
        bamboo: "Bambu",
        eggplant: "Berinjela",
        beetroot: "Beterraba",
        broccoli: "Brócolis",
        peanut: "Amendoim",
        cocoa: "Cacau",
        cherryCoffee: "Café cereja",
        pumpkin: "Abóbora",
        sweetPotato: "Batata-doce",
        sugarCane: "Cana-de-açúcar",
        canola: "Canola",
        carambolo: "Carambola",
        safflower: "Cártamo",
        barley: "Cevada",
        greenForageBarley: "Cevada forrageira verde",
        onion: "Cebola",
        chives: "Cebolinha",
        ryeGrain: "Centeio grão",
        cherry: "Cereja",
        chabacano: "Damasco",
        pea: "Ervilha",
        squash: "Chuchu",
        chia: "Chia",
        chilacayote: "Chilacayote",
        chillyPepper: "Pimenta",
        custardApple: "Fruta-do-conde",
        coriander: "Coentro",
        plum: "Ameixa",
        coconutFruit: "Coco",
        cabbage: "Repolho",
        brusselsSprouts: "Couve-de-bruxelas",
        cauliflower: "Couve-flor",
        cumin: "Cominho",
        chrysanthemum: "Crisântemo",
        peach: "Pêssego",
        date: "Tâmara",
        greenBean: "Feijão verde",
        cornCob: "Milho",
        dill: "Endro",
        epazote: "Epazote",
        asparagus: "Aspargo",
        spicesAndMedicinals: "Especiarias e Medicinais",
        spinach: "Espinafre",
        raspberry: "Framboesa",
        strawberry: "Morango",
        bean: "Feijão",
        chickpea: "Grão-de-bico",
        sunflower: "Girassol",
        pomegranate: "Romã",
        soursop: "Graviola",
        guava: "Goiaba",
        henequen: "Henequén",
        peppermint: "Hortelã",
        aromaticHerbs: "Ervas aromáticas",
        fig: "Figo",
        jamaica: "Hibisco",
        ginger: "Gengibre",
        jicama: "Jícama",
        lettuce: "Alface",
        lentil: "Lentilha",
        lime: "Limão",
        lemon: "Limão",
        linseed: "Linhaça",
        litchi: "Lichia",
        corn: "Milho",
        macadamia: "Macadâmia",
        maguey: "Maguey",
        mamey: "Mamey",
        tangerine: "Tangerina",
        mango: "Manga",
        mangosteen: "Mangostão",
        chamomile: "Camomila",
        appleTree: "Macieira",
        passionFruit: "Maracujá",
        daisyFlower: "Margarida",
        marjoram: "Manjerona",
        melon: "Melão",
        quince: "Marmelo",
        mint: "Hortelã",
        moringa: "Moringa",
        turnip: "Nabo",
        nanche: "Nanche",
        napa: "Napa",
        orange: "Laranja",
        medlar: "Nespera",
        nochebuena: "Planta de Natal",
        walnut: "Noz",
        noni: "Noni",
        nopal: "Nopal",
        oregano: "Orégano",
        ornamental: "Ornamental",
        orchid: "Orquídea",
        oilPalm: "Palmeira de óleo",
        potato: "Batata",
        papaya: "Mamão",
        grasslands: "Pastagens",
        matGrass: "Capim tapete",
        pasturesAndMeadows: "Pastos e Pradarias",
        cucumber: "Pepino",
        pearTree: "Pereira",
        parsley: "Salsinha",
        peron: "Peron",
        persimony: "Persimão",
        pepper: "Pimenta",
        pineapple: "Abacaxi",
        pinion: "Pinhão",
        pistache: "Pistache",
        pitaya: "Pitaya",
        banana: "Banana",
        pore: "Poro",
        radish: "Rabanete",
        rambutan: "Rambutan",
        romerito: "Romerito",
        rosemary: "Alecrim",
        aloe: "Aloe",
        watermelon: "Melancia",
        sorghum: "Sorgo",
        soy: "Soja",
        stevia: "Stevia",
        tobacco: "Tabaco",
        tamarind: "Tamarindo",
        tejocote: "Tejocote",
        tomato: "Tomate",
        greenTomato: "Tomate verde",
        thyme: "Tomilho",
        grapefruit: "Toranja",
        clover: "Trevo",
        wheat: "Trigo",
        dutchTulip: "Tulipa Holandesa",
        tuna: "Tuna",
        grape: "Uva",
        vanilla: "Baunilha",
        purslane: "Verdolaga",
        vine: "Videira",
        cassavaFood: "Mandioca",
        carrot: "Cenoura",
        sapodilla: "Sapodilla",
        blackberry: "Amora",
        zempoalxochitl: "Zempoalxochitl",
        fallow: "Terreno em pousio",
        "pecan nut": "Noz-pecã",
        roses: "Rosas",
        "faba bean": "Fava",
        chestnut: "Castanha",
        other: "Outro",
      },
      select_land_use: "Selecione um uso do solo",
      select_irrigation_system: "Selecione um sistema de irrigação",
      fill_up_fields: "Preencha todos os campos",
      agronomic_managment_edit:
        "Tem certeza de que deseja editar o Manejo Agronômico?",
      feacture_no_offline: "Este recurso não está disponível offline",
      select_landuse: "Selecione o uso do solo",
      select_crop_name: "Selecione o nome da cultura",
      search: "Buscar...",
      irrigation_system_label: "Sistema de Irrigação",
      management_label: "Manejo",
      organic_label: "Orgânico",
      conventional_label: "Convencional",
      crop_cycle_label: "Ciclo da Cultura",
      variety_label: "Variedade",
      land_use_title_main: "Uso do solo:",
      crop_name_title_main: "Nome da cultura:",
      sampler_title: "Amostradores",
      profile_title: "Perfil",
      reviews_title: "Visita técnica",
      title_territory_cordinators: "Território:",
      info_table_areas_sampler: "Informações de cada área atribuída",
      header_table_area: "Área",
      header_table_status_area: "Estado",
      header_table_city: "Cidade",
      not_technical_visit: "Não há visitas técnicas",
      detail_technical_visit: "Detalhes da visita técnica",
      areas_pendings_label: "Pendentes",
      areas_completed_label: "Concluídas",
      assign_areas_completed_label: "Concluídas",
      not_areas_pending: "Não há áreas pendentes",
      areas_completed: "Concluídas",
      areas_pending: "Pendentes",
      update_areas: "Atualizar áreas",
      label_not_technical_visits: "Não há visitas técnicas para mostrar",
      label_last_update: "Última atualização",
      date_not_update: "Não atualizado",
      date_not_completed: "Sem data",
      detail_area_assign: "Detalhe da atribuição de área",
      nav_subtitle_area: "Todas as informações das áreas atribuídas",
      title_dialog_area_status: "Estado da Área",
      upload_photo_pending: "Você tem fotos pendentes para enviar",
      detail_technical_visits: "Detalhes das visitas técnicas",
      success_sync_areas: "Áreas sincronizadas com sucesso",
      error_sync_areas: "Erro ao sincronizar áreas",
      user_not_found: "Usuário não encontrado",
      label_pending_visits: "Visitas pendentes",
      areas_information: "Informação",
      areas_completed_user: "Áreas concluídas pelo usuário",
      error_area_upload: "Erro ao enviar informações da área",
      error_area_connection: "Erro de conexão, tente novamente",
      sampling_label: "Amostragem",
      assign_label: "Atribuição",
      users_label: "Usuários",
      nav_completed_visits: "Visitas Concluídas",
      nav_assign_areas: "Atribuir Áreas",
      areas_assign: "Áreas Atribuídas",
      total_areas: "Total de Áreas",
      completed_assignments: "Concluídas",
      pendings_assignments: "Pendentes",
      assigned: "Atribuído",
      not_assigned: "Não Atribuído",
      sampling_list: "Lista de Amostras",
      upload_list: "Lista de Envio",
      uploading: "Enviando",
      offline_mode: "Modo Offline",
      online_mode: "Modo Online",
      error_upload_area: "Erro ao enviar informações da área",
      error_connection: "Erro de conexão, tente novamente",
      sync_completed: "Sincronização Concluída",
      sync_error: "Erro de Sincronização",
      uploading_data: "Enviando dados...",
      updating_data: "Atualizando dados...",
      success_upload: "Envio Bem-sucedido",
      success_update: "Atualização Bem-sucedida",
      error_upload: "Erro de Envio",
      error_update: "Erro de Atualização",
      no_pending_photos: "Não há fotos pendentes",
      pending_photos: "Fotos pendentes",
      no_upload_errors: "Não há erros de envio",
      upload_errors: "Erros de Envio",
      no_pending_areas: "Não há áreas pendentes",
      pending_areas: "Áreas pendentes",
      areas_to_sync: "Áreas para sincronizar",
      sync_areas: "Sincronizar Áreas",
      areas_synced: "Áreas Sincronizadas",
      no_sync_errors: "Não há erros de sincronização",
      sync_errors: "Erros de Sincronização",
      not_assigned_areas: "Áreas não atribuídas",
      assigned_areas: "Áreas atribuídas",
      assigned_areas_list: "Lista de áreas atribuídas",
      assigned_area_detail: "Detalhes da área atribuída",
      area_assignments: "Atribuições de Áreas",
      assign_areas_title: "Atribuir Áreas",
      nav_sync_areas: "Sincronizar Áreas",
      area_assignments_list: "Lista de Atribuições de Áreas",
      area_assignment_detail: "Detalhes da Atribuição de Área",
      nav_profile: "Perfil",
      profile_information: "Informações do Perfil",
      profile_details: "Detalhes do Perfil",
      profile_update: "Atualizar Perfil",
      nav_logout: "Sair",
      logout_message: "Tem certeza de que deseja sair?",
      logout: "Sair",
      cancel: "Cancelar",
      nav_assign_areas: "Atribuir Áreas",
      nav_completed_visits: "Visitas Concluídas",
      nav_area_assignments: "Atribuições de Áreas",
      sync_area_title: "Sincronizar Área",
      no_sync_area: "Não há área para sincronizar",
      sync_area: "Sincronizar Área",
      sync_area_detail: "Detalhes da Área Sincronizada",
      sync_area_list: "Lista de Áreas Sincronizadas",
      nav_sync: "Sincronizar",
      nav_completed_assignments: "Atribuições Concluídas",
      nav_pending_assignments: "Atribuições Pendentes",
      nav_total_assignments: "Total de Atribuições",
      nav_assignments: "Atribuições",
      nav_sync_areas: "Sincronizar Áreas",
      sync_area_list: "Lista de Áreas Sincronizadas",
      sync_area_detail: "Detalhes da Área Sincronizada",
      nav_profile_information: "Informações do Perfil",
      profile_details: "Detalhes do Perfil",
      profile_update: "Atualizar Perfil",
      profile_edit: "Editar Perfil",
      profile_save: "Salvar Perfil",
      profile_cancel: "Cancelar",
      profile_success: "Perfil Atualizado com Sucesso",
      profile_error: "Erro ao Atualizar Perfil",
      nav_logout: "Sair",
      logout_message: "Tem certeza de que deseja sair?",
      logout: "Sair",
      cancel: "Cancelar",
    },
    "es-pr": {
      cultivableArea: "Superficie cultibable total (ha)",
      other: "Otro",
      confirmation_wihout_qr:
        "¿Está seguro de que desea finalizar sin un código QR? Las submuestras no se tendrán en cuenta; solo se registrarán los problemas.",
      finish_sampling_without_qr: "Finalizar sin QR",
      advice_not_project:
        "Es necesario crear un proyecto para acceder a territorio",
      created_project: "Creado",
      no_project: "Sin proyecto",
      click_map_add_item: "Da click en el mapa para agregar un item",
      add_problems: "Añadir problemas",
      no_problem_info_defined: "No se ha definido información del problema",
      define_problem: "Definir problema",
      edit_problem: "Editar problema",
      not_defined: "No definido",
      problem: "Problema",
      avocado_plague_list: {
        unknown: "Desconocido",
        oligonychus_yothersi: "Ácaro tostador (Oligonychus yothersi)",
        oligonychus_perseae: "Araña cristalina (Oligonychus perseae)",
        oligonychus_punicae: "Araña roja, del aguacate (Oligonychus punicae)",
        oligonychus_mexicanus: "Araña roja, mexicana (Oligonychus mexicanus)",
        copturus_aguacatae: "Barrenador de ramas (Copturus aguacatae)",
        heilipus_lauri: "Barrenador grande del hueso (Heilipus lauri)",
        conotrachelus_aguacatae:
          "Barrenador pequeño del hueso (Conotrachelus aguacatae)",
        idona_minuenda: "Chicharrita, del aguacate (Idona minuenda)",
        empoasca_abrupta: "Chicharrita, verde (Empoasca abrupta)",
        hemiberlesia_lataniae: "Escama, latania (Hemiberlesia lataniae)",
        pyrrhopyge_chalybea: "Gusano confeti (Pyrrhopyge chalybea)",
        gonodonta_pyrgo: "Gusano de la hoja/fruto (Gonodonta pyrgo)",
        sabulodes_aegrotata: "Gusano falso medidor (Sabulodes aegrotata)",
        copaxa_multifenestrata: "Gusano quemador (Copaxa multifenestrata)",
        amorbia_cuneana: "Gusano telarañero (Amorbia cuneana)",
        gracillaria_spp: "Minador de la hoja (Gracillaria spp.)",
        aleurodes_sp: "Mosca blanca, común (Aleurodes sp.)",
        tetraleurodes_perseae:
          "Mosca blanca, de bandas rojas (Tetraleurodes perseae)",
        aleurodicus_dugesii: "Mosca blanca, gigante (Aleurodicus dugesii)",
        bemisia_argentifolii:
          "Mosca blanca, hoja plateada (Bemisia argentifolii)",
        paraleyrodes_perseae:
          "Mosca blanca, polvorienta (Paraleyrodes perseae)",
        aethalion_quadratum: "Mosca verde del aguacate (Aethalion quadratum)",
        stenoma_catenifer:
          "Palomilla barrenadora del hueso (Stenoma catenifer)",
        metcalfiella_monograma:
          "Periquito del aguacate (Metcalfiella monograma)",
        trioza_anceps: "Psílido de las agallas (Trioza anceps)",
        neohydatothrips_signifer:
          "Trips, de franjas (Neohydatothrips signifer)",
        pseudophilothrips_perseae:
          "Trips, de las agallas (Pseudophilothrips perseae)",
        heliothrips_haemorrhoidalis:
          "Trips, de los invernaderos (Heliothrips haemorrhoidalis)",
        scirtothrips_perseae: "Trips, del aguacate (Scirtothrips perseae)",
        frankliniella_bruneri: "Trips, negro (Frankliniella bruneri)",
        frankliniella_occidentalis:
          "Trips, occidental de las flores (Frankliniella occidentalis)",
        tetranychus_urticae: "Araña roja (Tetranychus urticae)",
        liriomyza_sp: "Minador de la hoja (Liriomyza sp.)",
        tuta_absoluta: "Polilla del tomate (Tuta absoluta)",
        aphis_sp_green: "Pulgón verde (Aphis sp.)",
        diaphorina_citri: "Chicharrita de los cítricos (Diaphorina citri)",
        spodoptera_frugiperda: "Gusano Cogollero (Spodoptera frugiperda)",
        keiferia_lycopersicella:
          "Gusano alfiler del tomate (Keiferia lycopersicella)",
        helicoverpa_zea: "Gusano elotero del maíz (Helicoverpa zea)",
        heliothis_virescens:
          "Gusano del Cogollo del Tabaco (Heliothis virescens)",
        trichoplusia_ni: "Gusano falso medidor (Trichoplusia ni)",
        manduca_quinquemaculata:
          "Gusano cuerno del tomate (Manduca quinquemaculata)",
        spodoptera_exigua: "Gusano soldado (Spodoptera exigua)",
        liriomyza_spp: "Mosca minadora (Liriomyza spp)",
        cydia_pomonella: "Gusano de la Manzana (Cydia pomonella)",
        phthorimaea_operculella:
          "Polilla de la patata (Phthorimaea operculella)",
        heliothis_zea: "Gusano elotero del maíz (Heliothis zea)",
        pectinophora_gossypiella: "Gusano Rosado (Pectinophora gossypiella)",
        bucculatrix_thurberiella:
          "Gusano perforador de la hoja del algodón (Buccolatrix thurberiella)",
        estigmene_acrea: "Gusano peludo (Estigmene acrea)",
        copitarsia_consueta:
          "Gusano del corazón de la col (Copitarsia consueta)",
        plutella_xylostella:
          "Palomilla dorso de diamante (Plutella xylostella)",
        liriomyza_munda: "Minador de la hoja (Liriomyza munda)",
        manduca_sexta: "Gusano Cuerno del Tabaco (Manduca sexta)",
        diatraea_grandiosella:
          "Barrenador del tallo del maíz (Diatraea grandiosella)",
        carpocapsa_pomonella: "Polilla del manzano (Carpocapsa pomonella)",
        aeneolamia_contigua: "Mosca pinta (Aeneolamia contigua)",
        other: "Otro",
      },
      avocado_disease_list: {
        unknown: "Desconocido",
        damping_off: "Ahogamiento / Damping-off (Pythium sp.)",
        anthracnose_classic:
          "Antracnosis, clásica (Colletotrichum gloeosporioides)",
        anthracnose_boninense:
          "Antracnosis, complejo boninense (Colletotrichum boninense)",
        bacterial_canker: "Cancro bacteriano (Xanthomonas sp.)",
        sooty_mold: "Fumagina / Negrilla (Capnodium sp.)",
        angular_leaf_spot: "Mancha angular de la hoja (Cercospora purpurea)",
        tar_spot: "Mancha de chapopote / Varicela (Phyllachora gratissima)",
        leaf_spot_septoria: "Mancha foliar por Septoria (Septoria sp.)",
        black_spot: "Mancha negra (Diplocarpon rosae)",
        fusarium_wilt: "Marchitez / Fusariosis (Fusarium sp.)",
        root_rot_rhizoctonia: "Pudrición de raíz (Rhizoctonia solani)",
        fruit_rot_diplodia: "Pudrición del fruto, Diplodia (Diplodia sp.)",
        fruit_rot_dothiorella:
          "Pudrición del fruto, Dothiorella (Dothiorella sp.)",
        scab: "Roña del aguacate (Sphaceloma perseae)",
        avocado_root_rot: "Tristeza del aguacatero (Phytophthora cinnamomi)",
        botrytis_cinerea: "Moho Gris / Botritis (Botrytis cinerea)",
        cladosporium_fulvum: "Moho de la hoja del tomate (Cladosporium fulvum)",
        colletotrichum_acutatum: "Antracnosis (Colletotrichum acutatum)",
        glomerella_cingulata: "Antracnosis (Glomerella cingulata)",
        monilia_spp: "Pudrición del fruto, Monilia spp. (Monilia spp.)",
        mycosphaerella_fragariae: "Mancha Púrpura (Mycosphaerella fragariae)",
        peronospora_rubi: "Mildiú Velloso de la Zarzamora (Peronospora rubi)",
        other: "Otra",
      },
      avocado_weeds_list: {
        chenopodium_album: "Quelite cenizo (Chenopodium album)",
        equisetum_spp: "Muela de caballo (Equisetum spp.)",
        eleusine_indica: "Pata de gallo (Eleusine indica)",
        convolvulus_arvensis: "Chayotillo o Correhuela (Convolvulus arvensis)",
        euphorbia_prostrata: "Golondrina (Euphorbia prostrata)",
        rumex_crispus: "Lengua de vaca (Rumex crispus)",
        sorghum_halepense: "Sacate Jhonson (Sorghum halepense)",
        setaria_verticillata: "Cola de zorra (Setaria verticillata)",
        cyperus_rotundus: "Coquillo (Cyperus rotundus)",
        other: "Otra",
      },
      avocado_nutrition: {
        nitrogen: "Nitrógeno (N)",
        zinc: "Zinc (Zn)",
        iron: "Hierro (Fe)",
        potassium: "Potasio (K)",
        boro: "Boro (B)",
        other: "Otro",
      },
      plague: "Plaga",
      disease: "Enfermedad",
      weed: "Maleza",
      nutrition: "Deficiencias nutricionales",
      specific_problem: "Problema específico",
      problem_type: "Tipo de problema",
      problem_info: "Información del problema",
      soil: "Suelo",
      longitudeRange: "Longitud debe estar entre -180 y 180",
      latitudeRange: "Latitud debe estar entre -90 y 90",
      bothFieldsRequired: "Ambos campos (latitud y longitud) son requeridos",
      additionalDetails: "Detalles complementarios",
      descriptionSaved: "Descripción guardada",
      projectEndDate: "Fecha fin de proyecto",
      tentativeFieldSamplingDate: "Fecha tentativa de muestreo en campo",
      commercialStartDate: "Fecha de arranque comercial",
      importantDates: "Fechas importantes",
      noCrop: "Sin cultivo",
      targetCrops: "Cultivo(s) objetivo",
      agriculturalDetails: "Detalles agrícola",
      responsible: "Responsable",
      notSpecified: "No especificado",
      projectType: "Tipo de proyecto",
      generalInformation: "Información general",
      enterCoordinates:
        "Ingresa las coordenadas de la imagen o ubica el punto dando click en el mapa",
      selectImage: "Selecciona imagen(es)",
      addMultipleSubsamples: "Agregar múltiples submuestras",
      imagePreview: "Vista previa de la imagen",
      deleteSubsample: "Eliminar submuestra",
      centerSubsample: "Centrar submuestra",
      relocate: "Reubicarse",
      images_without_metadata: "Imágenes sin metadatos (no se subirán)",
      subsample_outside_polygon: "Submuestra fuera del polígono",
      image_load_error: "Algo salió mal al cargar la imagen",
      add_multiple_subsamples: "Agregar múltiples submuestras",
      sampling_date: "Fecha de muestreo",
      updated_information: "Información actualizada",
      current_package: "Paquete actual",
      select_sampling_type: "Seleccione el tipo de muestreo",
      update_sample_data: "Actualizar datos de muestra",
      label_new_farm: "Nueva productora/empresa",
      general_description: "Descripción general",
      request_guide_dialog_content:
        "La solicitud de guia fue enviada, tu guia sera enviado a tu correo electronico.",
      request_guide_dialog_title: "Solicitud de guía",
      request_guide_label: "Solicitar guía de retorno",
      label_total_samples: "Total de muestras en kit",
      origin_zip_code_label: "Código postal de orígen",
      selectKitType: "Selecciona el tipo de kit",
      kitType: "Tipo de kit",
      send_label: "Enviar",
      request_guide_title: "Solicitar guía",
      selectIrrigationSystem: "Seleccione el sistema de riego",
      label_longitude: "Longitud",
      label_latitude: "Latitud",
      label_no_evidence: "Sin evidencia",
      label_evidence: "Evidencia",
      label_actions: "Acciones",
      label_image: "Imagen",
      label_sampling_date: "Fecha muestreo",
      label_coordinates: "Coordenadas",
      label_center: "Centrar",
      label_select_image: "Selecciona imagen",
      label_add_image: "Agregar imagen",
      label_add_version: "Agregar versión",
      label_name_or_code_profitability: "Nombre o Código rentabilización",
      label_no_profitability: "No hay rentabilizaciones",
      label_sample: "Muestra",
      label_origin_postal_code: "Código postal de origen",
      label_add_sample: "Agregar muestra",
      label_clear_list: "Limpiar lista",
      label_use: "Uso",
      label_active_ingredient: "Ingrediente activo",
      label_product_name_brand: "Nombre del producto (marca)",
      label_at_least_one_sample: "Debe de existir por lo menos una muestra",
      label_compost_type: "Tipo de composta",
      label_analysis_type: "Tipo de análisis",
      label_without_crop: "Sin cultivo",
      label_with_crop: "Con cultivo",
      label_relogin: "Vuelve a iniciar sesión",
      label_session_expired: "Sesión expirada",
      label_new_sample: "Nueva muestra",
      label_phone: "Teléfono",
      label_last_name: "Apellido",
      label_basic_information: "Información básica",
      label_profile: "Perfil",
      label_application_removed: "Aplicación removida",
      label_add_application: "Añadir aplicación",
      label_applications: "Aplicaciones",
      label_product: "Producto",
      label_sample_without_advisor: "Muestra sin asesor",
      label_substrate_sample: "Muestra de sustrato",
      label_product_sample: "Muestra de producto",
      label_compost_sample: "Muestra de composta",
      label_plant_sample_without_reference: "Muestra vegetal sin referencia",
      label_soil_sample: "Muestra de suelo",
      label_genomic_plant_sample: "Muestra vegetal genómica",
      label_genomic_sample: "Muestra genómica",
      label_project_detail: "Detalle proyecto",
      label_project_created: "Proyecto creado",
      label_project_updated: "Proyecto actualizado",
      label_add_at_least_one_item: "Agrega por lo menos 1 elemento",
      label_add_product: "Añadir producto",
      label_objective: "Objetivo",
      label_active_ingredient: "Ingrediente activo",
      label_add_application: "Añadir aplicación",
      label_application_added: "Aplicación añadida",
      label_dose: "Dósis",
      label_add_product: "Añadir producto",
      label_add_phenological_stage: "Añade etapa fenológica",
      label_select_irrigation_unit: "Seleccione zona(s) de muestreo",
      label_contrast_b: "Contraste B",
      label_contrast_a: "Contraste A",
      label_select_variant: "Selecciona variante",
      label_select_project_type: "Selecciona tipo de proyecto",
      label_agricultural_units: "Zonas de muestreo",
      label_project_information: "Información del proyecto",
      label_create_project: "Crear proyecto",
      label_update_project: "Actualizar proyecto",
      label_no_projects: "No hay proyectos",
      label_add_producer_company: "Añadir productora/empresa",
      label_search_folio: "Buscar folio",
      label_no_results: "No hay resultados",
      label_projects: "Proyectos",
      label_download_sampling_app: "Descarga app muestreo",
      label_no_georeference: "Sin georeferencia",
      label_profitability: "Rentabilización",
      label_fungi: "Hongos",
      label_bacteria: "Bacterias",
      label_cellulolytic_activity: "Actividad celulolítica",
      label_siderophores: "Sideróforos",
      label_potassium_solubilization: "Solubilización de potasio (K)",
      label_phosphorus_solubilization: "Solubilización de fósforo (P)",
      label_negative_control: "Control negativo",
      label_nutrition: "Nutrición",
      label_control: "Control",
      label_soil_disease_control: "Control de enfermedades de suelo",
      label_no_not_detected: "No hay no detectados",
      label_beneficial: "Benéfico",
      label_pathogen: "Patógeno",
      label_type: "Tipo",
      label_not_detected: "No detectados",
      label_no_pathogens: "No hay patógenos",
      label_soil_pathogen_detection: "Detección de patógenos en suelo",
      label_no_beneficials: "O hay benéficos",
      label_concentration: "Concentración",
      label_taxonomic_identification: "Identificación taxonómica",
      label_microorganism: "Microorganismo",
      label_soil_beneficials_of_interest: "Benéficos de interés en suelo",
      label_biological_capital_measurement: "Medición de Capital Biológico",
      label_soil_texture: "Textura de suelo",
      label_carbon_capture_pox: "Captura de carbono (POX)",
      label_organic_matter: "Materia orgánica",
      label_soil_health_parameters: "Parámetros de salud de suelo",
      label_irrigation_unit: "Zona de muestreo",
      label_analysis_detail: "Detalle de análisis",
      label_analysis_in_progress: "Análisis en progreso",
      label_not_available: "No disponible",
      label_next_result_date: "Fecha próximo resultado",
      label_analysis_results: "Resultados de análisis",
      label_close: "Cerrar",
      label_subsample_photos: "Fotos de submuestras",
      label_polygon_not_available: "Polígono no disponible",
      label_sample_detail: "Detalle de muestra",
      label_measurement: "Medición",
      label_valuation: "Valuación",
      label_valuated: "Valuado",
      label_valuating: "Valuando",
      label_measured: "Medido",
      label_measuring: "Midiendo",
      label_sent: "Enviado",
      label_received: "Recibido",
      label_sampling_finished: "Muestreo finalizado",
      label_detail: "Detalle",
      label_analysis_folio: "Folio análisis",
      label_status: "Estatus",
      label_apply: "Aplicar",
      label_advanced_filters: "Filtros avanzados",
      label_no_samples: "No hay muestras",
      label_samples_list: "Lista de muestras",
      label_at_least_one_sample_required:
        "Debe de existir por lo menos una muestra",
      label_sample_already_completed: "La muestra ya estaba finalizada",
      label_enter_a_valid_folio: "Ingrese un folio válido",
      label_enter_an_unregistered_folio: "Ingrese un folio sin registrar",
      label_sample_successfully_registered: "Muestra registrada exitosamente",
      label_browser_lacks_features: "El navegador parece carecer de funciones",
      label_requested_front_camera_although_none_available:
        "¿Pediste la cámara frontal aunque no hay ninguna?",
      label_camera_may_be_in_use: "Tal vez la cámara ya está en uso",
      label_page_not_served_over_https_or_localhost:
        "La página no se sirve a través de HTTPS (o localhost)",
      label_no_suitable_camera_device_installed:
        "No hay ningún dispositivo de cámara adecuado instalado",
      label_user_denied_camera_access_permission:
        "Usuario denegado permiso de acceso a la cámara",
      label_finish_sampling: "Finalizar muestreo",
      label_finish_with_scanner: "Finalizar con scanner",
      label_qr_not_found: "QR no encontrado",
      label_search_qr: "Buscar QR...",
      label_sick_plot: "Parcela enferma",
      label_sample_description: "Descripción de muestra",
      label_plant_sample_type: "Tipo de muestra vegetal",
      label_sampling_type: "Tipo de muestreo",
      label_select_package: "Selecciona paquete",
      label_sample_type: "Tipo de muestra",
      label_phonological_stage: "Etapa fenológica",
      label_number_of_subsamples: "Número de sub-muestras",
      label_delete_subsamples: "Eliminar sub-muestras",
      label_add_subsamples: "Agregar submuestras",
      label_finish_sampling: "Finalizar muestreo",
      label_not_applicable: "No aplica",
      label_no_areas: "No hay áreas",
      label_no_agronomic_management: "Sin manejo agronómico",
      label_territory_list: "Lista territorio",
      label_at_least_one_item_required:
        "Se debe de seleccionar al menos un elemento",
      label_agronomic_management_saved: "Manejo agronómico guardado",
      label_crop_cycle_ended:
        "El ciclo de cultivo ha terminado, ¿Quieres ingresar uno nuevo?",
      label_new_crop_cycle: "Nuevo ciclo de cultivo",
      label_add_area_with_highest_problem_severity:
        "Agregar área con mayor severidad de problemas",
      label_previous_cycle: "Ciclo anterior",
      label_problems_detected: "Problemas detectados",
      label_select_tonnage_unit: "Selecciona unidad de tonelaje",
      label_tonnage: "Tonelaje",
      label_average_yield_per_hectare_acre:
        "¿Cuál es el rendimiento promedio por hectárea/acre?",
      label_list_of_inputs_applied_during_crop_cycle:
        "Lista de insumos aplicados durante el ciclo del cultivo",
      label_cycle_end: "Fin de ciclo",
      label_cycle_start: "Inicio de ciclo",
      label_variety_optional: "Variedad (opcional)",
      label_select_crop: "Seleccione un cultivo",
      label_crop_cycle: "Ciclo de cultivo",
      label_description: "Descripción",
      label_crop_success_definition: "Definición de éxito del cultivo",
      label_what_is_your_agricultural_management_practice:
        "¿Cuál es su práctica de manejo agrícola?",
      label_select_shadow_type: "Seleccione tipo de sombra",
      label_confirm_delete_area: "¿Seguro que desea eliminar esta área?",
      label_delete_area: "Eliminar área",
      label_area_deleted: "Área eliminada",
      label_cannot_delete_area_with_samples:
        "No se puede eliminar una área con muestras",
      label_days: "Días",
      label_on_hold: "En pausa",
      label_soil_of: "Tierra de",
      label_crop_of: "Cultivo de",
      label_sterile: "Estéril",
      label_redraw: "Redibujar",
      label_qr_invalid: "QR no válido",
      label_qr_registered: "QR registrado",
      label_sampling_in_progress: "Muestreo en curso",
      label_sampling_not_started: "Muestreo no iniciado",
      label_add_crop: "Añadir cultivo",
      label_name: "Nombre",
      label_enter_agronomic_management_before_sampling:
        "Ingrese manejo agronómico antes de muestrear (Obligatorio)",
      label_rename: "Renombrar",
      label_add_area: "Agregar área",
      label_cultivation_area_name: "Nombre del área de cultivo",
      label_confirm_edit_agronomic_management:
        "¿Estás seguro que desea editar el Manejo agronómico del área?",
      label_agronomic_management: "Manejo agronómico",
      label_management: "Manejo",
      label_take_sample: "Tomar muestra",
      label_results: "Resultados",
      label_draw: "Dibujar",
      label_repeat: "Repetir",
      label_back: "Atrás",
      label_territory: "Territorio",
      label_prospect_created: "Prospecto creado",
      label_prospect_updated: "Prospecto actualizado",
      label_new_prospect: "Nuevo prospecto",
      label_update_prospect: "Actualizar prospecto",
      label_update_prospect: "Actualizar prospecto",
      label_no_zone_assigned_prospect:
        "No se asignó zona al prospecto, ¿quieres continuar?",
      label_contact_last_name: "Apellido contacto",
      label_removed_from_favorites: "Removido de favoritos",
      label_added_to_favorites: "Agregado a favoritos",
      label_make_client: "Hacer cliente",
      label_distributor_change_successful: "Cambio de distribuidor exitoso",
      label_client_created: "Productora/Empresa creada",
      label_client_updated: "Productora/Empresa actualizado",
      label_no_zone_assigned:
        "No se asignó zona al prospecto, ¿quieres continuar?",
      label_logout_confirmation: "¿Seguro que quiere cerrar sesión?",
      label_confirmation: "Confirmación",
      label_state: "Estado",
      label_city: "Ciudad",
      label_country: "País",
      label_neighborhood: "Colonia",
      label_interior_number: "Número interior",
      label_exterior_number: "Número exterior",
      label_postal_code: "Código postal",
      label_street: "Calle",
      label_update_client: "Actualizar Productor/Empresa",
      label_address: "Domicilio",
      label_rfc: "RFC",
      label_phone: "Teléfono",
      label_contact_name: "Nombre contacto",
      label_zone: "Zona",
      label_contact_information: "Información del contacto",
      label_company_name: "Razón social",
      label_client_created: "Productora/Empresa creada",
      advice_error: "Algo salio mal, intente de nuevo",
      label_update: "Actualizar",
      advice_not_prospects: "No hay prospectos",
      advice_no_clients: "No hay agricolas",
      label_clients: "Productora/Empresa",
      label_prospects: "Prospectos",
      valid_email_required: "Debes ingresar un correo electrónico válido",
      select_distributor: "Selecciona distribuidor",
      field_required: "El campo es obligatorio",
      email_label: "correo",
      label_continue: "Continuar",
      enter_email: "Ingrese su dirección de correo electrónico",
      forget_password_title: "Se te olvidó tu contraseña",
      send_email_password:
        "Se ha enviado un email a tu correo para cambiar tu contraseña",
      error_changing_password: "Error al intentar cambiar contraseña",
      login_error_check_info:
        "Error al iniciar sesión, verifica tu información",
      label_download_pdf: "Descargar PDF",
      label_client_accept: "Aceptado por el cliente",
      download_sampling_app: "Descargar app muestreo",
      home_menu_label_change_dis: "Cambiar distribuidor",
      change_language: "Cambiar idioma",
      download_app: "Descargar app muestreo solena explore",
      forgot_your_password: "¿No recuerdas tu contraseña?",
      app_name: "Solena Explore",
      navigation_drawer_open: "Menú de Navegación Abierto",
      navigation_drawer_close: "Cerrar Menú de Navegación",
      nav_header_title: "Android Studio",
      nav_header_desc: "Encabezado de Navegación",
      action_samples: "Muestras",
      menu_territory: "Territorio",
      menu_samples: "Muestras",
      menu_log_out: "Cerrar Sesión",
      app_name_splash: "Solena (Beta) 1.3.6",
      description_logo: "Logo de Solena",
      prompt_email: "Usuario",
      prompt_password: "Contraseña",
      action_sign_in: "Iniciar Sesión",
      action_sign_in_short: "Iniciar Sesión",
      welcome: "Bienvenido",
      invalid_username: "Correo electrónico inválido",
      invalid_password: "Contraseña incorrecta",
      login_failed: "Inicio de sesión fallido",
      fill_fields: "Llene ambos campos",
      user_not_saved: "Usuario no guardado en el dispositivo",
      user_wrong: "Intente acceder desde la aplicación web de Solena Explore",
      sample_photo_activity_title: "Foto de Muestra",
      detail_sample_activity_title: "Muestreo de Suelo",
      image_capture_failed: "Captura de imagen fallida",
      error_to_upload_photo: "Error al subir la foto, intente nuevamente",
      area_update_failure: "Actualización de área fallida",
      area_update_db_failure: "Error al guardar la foto, intente nuevamente",
      captured_image: "Submuestra",
      location_wrong: "Cargando ubicación, por favor espere",
      folio_wrong: "Error al guardar la muestra",
      wrong_folio_length: "El folio debe tener 14 dígitos",
      detecting_QR: "Finalizar Muestreo",
      area_name: "Nombre del Área",
      area_length: "Área: 100 ha",
      perimeter: "Perímetro: 3,544.91 m",
      repeat: "Repetir",
      accept: "Aceptar",
      photo_needed: "No hay muestras para registrar",
      connection_needed: "No hay conexión a internet",
      address_needed: "Complete su perfil e información de dirección.",
      area_updated_fail: "Actualización de área fallida",
      failed_sync: "Sincronización de área fallida:",
      area_server_update_fail: "Error al subir cambios del área",
      samples_taken: "Muestreo completo, puede finalizar ahora",
      areas_update_async_successful: "Datos sincronizados exitosamente",
      areas_update_async_successful_errors: "Datos sincronizados con errores",
      local_area_failure: "Error de actualización de área en el dispositivo",
      NOT_ASSIGNED: "NO ASIGNADO",
      NOT_STARTED: "Listo para muestrear",
      COMPLETED: "COMPLETADO",
      IN_PROGRESS: "Muestreo en progreso",
      INACCESSIBLE: "INACCESIBLE",
      NOT_VALID: "NO VÁLIDO",
      VALIDATED: "VALIDADO",
      VALIDATION_PENDING: "VALIDACIÓN PENDIENTE",
      area: "Área",
      perimeter_: "Perímetro:",
      started_sample: "Inicio de muestreo",
      enter_area: "¿Puede ingresar al área de muestreo?",
      not: "No",
      yes: "Sí",
      suggested_points: "PUNTOS DE DESTINO",
      sample_taken: "Muestras:",
      elapsed_time: "Tiempo de muestreo:",
      waiting_map: "Fijando posición...",
      photo_error: "Error al subir imagen, intente nuevamente",
      api_error: "Error del servidor:",
      conecction_error:
        "Error de conexión, esperando conexión para actualizar áreas",
      shipment_label: "Envío de muestra de suelo",
      shipment_question: "¿Generar guía para envío de muestra?",
      input_folio: "Ingrese el Folio de la muestra",
      folio: "Folio",
      cancel: "Cancelar",
      delete: "Eliminar",
      finish: "Finalizar",
      title_dialog_finish: "Enviar muestra",
      warning_qr: "QR inválido, ingrese manualmente",
      not_permissions_qr: "No hay permisos de cámara",
      qr_foto_error: "Error al finalizar el muestreo, intente nuevamente",
      offline: "Sin internet, modo fuera de línea",
      online: "Conexión a internet restaurada",
      syncing_area: "Sincronizando datos, por favor espere...",
      no_internet: "Asegúrese de estar conectado a internet",
      connection_lost: "Conexión a internet perdida",
      acept: "Aceptar",
      porcentage_photo: "/100",
      areas: "Áreas: ",
      photoCountAsync: "Fotos:",
      landUse: "Uso de Suelo",
      landUse_list: {
        sterile: "Estéril",
        cropLand: "Terreno Agrícola",
      },
      irrigations_list: {
        drip: "Goteo",
        pivot: "Pivote",
        wheeled: "Inundación",
        microspray: "Microaspersión",
        "without irrigation": "Sin riego",
      },
      shadow_type: {
        "Shade cloth": "Malla sombra",
        Greenhouse: "Invernadero",
        "Open field": "Campo abierto",
        Macrotunnel: "Macrotúnel",
      },
      management_practices: {
        TILLAGE: "Labranza reducida",
        CROP_ROTATION: "Rotación de cultivo",
        COMPOST_APPLY: "Aplicación de compostas",
        CROP_COVER: "Cultivos de cobertura",
        PEST_MANAGEMENT: "Manejo integrado de plagas",
        OTHER: "Otro",
        NONE: "Ninguna",
      },
      propagation_method: {
        graft: "Injerto",
        frank: "Franco",
      },
      agroinputs: {
        inputWeed: "Control de malezas",
        inputPest: "Control de plagas (insectos)",
        inputPhytopathogen: "Control de Fitopatógenos",
        inputConditioner: "Mejorador de suelo",
        inputFungi: "Inoculantes fungicos",
        inputBacteria: "Inoculantes bacterianos",
        inputAlgae: "Inoculantes basados en algas",
      },
      agroinputs_descriptions: {
        inputWeed: "Control de malezas - Nombre del producto (opcional)",
        inputPest:
          "Control de plagas (insectos) - Nombre del producto (opcional)",
        inputPhytopathogen:
          "Control de Fitopatógenos - Nombre del producto (opcional)",
        inputConditioner:
          "Mejorador de suelo ejemplo: ácidos fulvicos humicos, cal agricola etc",
        inputFungi: "Inoculantes fungicos - ejemplo: Trichoderma, etc.",
        inputBacteria: "Inoculantes bacterianos - ejemplo: Pseudomonas, etc.",
        inputAlgae: "Inoculantes basados en algas - ejemplo: Ascophyllum, etc.",
      },
      tonnageUnits: {
        HECTARE: "Hectárea",
        ACRE: "Acre",
      },
      issueList: {
        salinity: "Salinidad",
        soilCompaction: "Compactación del suelo",
        alkalinity: "Suelo alcalino (pH > 7.0)",
        acidity: "Suelo ácido (pH < 6)",
        heavyMetals: "Metales pesados en suelo",
        recurrentDiseases: "Enfermedades recurrentes",
        percentageOrganicMatter: "Baja materia orgánica en suelo ( < 1 %)",
        other: "Otro",
      },
      phenologicalStages: {
        Transplanting: "Trasplante",
        "Vegetative growth": "Desarrollo Vegetativo",
        Bloom: "Floración",
        Harvest: "Cosecha",
        "Pre-planting": "Presiembra",
        Sowing: "Siembra",
        Sprout: "Emergencia",
        Tuberization: "Tuberización",
        "Tuber filling": "Llenado de tuberculos",
        "Foliage development": "Desarrollo foliar",
        "Foliar expansion": "Expansión foliar",
        "First leaf": "Primera hoja",
        "Third leaf": "Tercer hoja",
        "Fifth leaf": "Quinta hoja",
        "Start of bulbing": "Inicio de bulbificación",
        "Bulb growth": "Desarrollo del bulbo",
        "Fruit maturity": "Maduración de fruto",
        Sprouting: "Brotación",
      },
      analysisTypes: {
        INITIAL: "Inicial",
        MONITORING: "Seguimiento",
      },
      samplingType: {
        CLASSIC: "Muestreo de suelo",
        MAS_VEGETABLE: "Muestreo vegetal",
      },
      kitTypes: {
        CLASSIC: "Tradicional",
        HYBRID: "Híbrido",
        QPCR: "QPCR",
      },
      vegetalSampleTypes: {
        Seedling: "Plántula",
        Root: "Raíz",
        Seed: "Semilla",
        Stem: "Tallo",
        Leaf: "Hoja",
        Fruit: "Fruto",
        Flower: "Flor",
      },
      status_samples: {
        ALL: "Todos",
        IN_PROGRESS: "En progreso",
        VALIDATED: "Finalizado",
        RECEIVED: "Recibido",
        MEASURING: "Midiendo",
        MEASURED: "Medido",
        VALUATING: "Valuando",
        VALUATED: "Valuado",
      },
      symp: {
        Clorosis: "Chlorosis",
        "Leaf spots": "Manchas en las hojas",
        Necrosis: "Necrosis",
        Wilting: "Marchitamiento",
        Dwarfism: "Enanismo",
        "Early wilting": "Marchitamiento precoz",
        "Root rot": "Pudrición de raíz",
        "Performance reduction": "Reducción del rendimiento",
        "Plant Chlorosis": "Planta clorosis",
        "Plant with spots on the leaves": "Planta con manchas en las hojas",
        "Plant with necrosis": "Planta con necrosis",
        "Healthy plant": "Planta sana",
        "Leaf top with chlorosis": "Hoja parte alta con clorosis",
        "Leaf top with spots": "Hoja parte alta con manchas",
        "Leaf top with necrosis": "Hoja parte alta con necrosis",
        "Leaf top with wilting": "Hoja parte alta con marchitamiento",
        "Leaf top healthy": "Hoja parte alta sana",
        "Leaf middle with chlorosis": "Hoja parte media con clorosis",
        "Leaf middle with spots": "Hoja parte media con manchas",
        "Leaf middle with necrosis": "Hoja parte media con necrosis",
        "Leaf middle with wilting": "Hoja parte media con marchitamiento",
        "Leaf middle healthy": "Hoja parte media sana",
        "Leaf lower with chlorosis": "Hoja parte baja con clorosis",
        "Leaf lower with spots": "Hoja parte baja con manchas",
        "Leaf lower with necrosis": "Hoja parte baja con necrosis",
        "Leaf lower with wilting": "Hoja parte baja con marchitamiento",
        "Leaf lower healthy": "Hoja parte baja sana",
        "Stem with dwarfism": "Tallo con enanismo",
        "Early wilting stem": "Tallo con marchitamiento precoz",
        "Stem with necrosis": "Tallo con necrosis",
        "Healthy stem": "Tallo sano",
        "Root rot": "Raíz con pudrición",
        "Root with necrosis": "Raíz con necrosis",
        "Healthy root": "Raíz sana",
        "Fruit with reduced yield": "Fruta con reducción del rendimiento",
        "Fruit with necrosis": "Fruta con necrosis",
        "Healthy fruit": "Fruta sana",
      },
      symp_avocado: {
        "Regressive death": "Muerte regresiva (Descendente)",
        Defoliation: "Defoliacion (Caida prematura de hojas)",
        Cancer: "Cáncer",
        Chlorosis: "Clorosis (amarillamiento)",
        "Limb drying": "Secado de extremidades (ramas)",
        "Sooty mold": "Fumagina",
        "Drying with attached leaves": "Secado con hojas adheridas",
        Galling: "Agallamiento (tumoraciones)",
        "Leaf Spots": "Manchas foliares",
        "Trunk Canker": "Cancro de tronco",
        "Peduncle Ringing (Fruit)": "Anillamiento de pedunculo (Fruto)",
        "Root Rot": "Pudricion radicular",
        Healthy: "Sana",
      },
      symp_blackberry_raspberry: {
        Chlorosis: "Clorosis (amarillamiento)",
        Wilting: "Marchitez / flacides de tallo u hojas",
        "Leaf spots": "Manchas foliares",
        "Stem streaking": "Rayado de tallo",
        Defoliation: "Defoliacion (Caida prematura de hojas)",
        Blight: "Tizon (Clorosis y/o secado de brotes)",
        Galling: "Agalla o tumor de cuello",
        "Growth delay": "Retraso de crecimiento",
        "Base Stem Girdling": "Ahorcamiento de base del tallo",
        "Root Rot": "Pudricion radicular",
        Healthy: "Sana",
      },
      symp_strawberry: {
        Wilting: "Marchitez / flacides de tallo u hojas",
        "Leaf spots": "Manchas foliares",
        "Crown rot": "Pudricion de corona",
        Defoliation: "Defoliacion (Caida prematura de hojas)",
        Chlorosis: "Clorosis (amarillamiento)",
        "Growth delay": "Retraso de crecimiento",
        "Base Stem Girdling": "Ahorcamiento de base del tallo",
        "Reddish Spots on Leaf Edges":
          "Manchas avermelhadas nas bordas de las hojas",
        "Root Rot": "Pudricion radicular",
        Healthy: "Sana",
      },
      symp_blueberry: {
        Wilting: "Marchitez / flacides de tallo u hojas",
        "Basal rot": "Pudrición basal",
        "Leaf spots": "Manchas foliares",
        Blight: "Tizon (Clorosis y/o secado de brotes)",
        Chlorosis: "Clorosis (amarillamiento)",
        "Growth delay": "Retraso de crecimiento",
        "Crown Gall or Tumor": "Agalla o tumor de cuello",
        "Base Stem Girdling": "Ahorcamiento de base del tallo",
        "Root Rot": "Pudricion radicular",
        Healthy: "Sana",
      },
      symp_orange: {
        "Chlorosis (Yellowing)": "Clorosis (Amarillamiento)",
        "Dieback (Downward)": "Muerte regresiva (Descendente)",
        "Defoliation (Premature leaf drop)":
          "Defoliacion (Caida prematura de hojas)",
        "Root Rot": "Pudricion radicular",
        Healthy: "Sana",
      },
      symp_chili_peppers_cucumber_tomato: {
        "Chlorosis (Yellowing)": "Clorosis (Amarillamiento)",
        "Leaf Spots": "Manchas foliares",
        "Dieback (Downward)": "Muerte regresiva (Descendente)",
        "Wilting / Stem or Leaf Flaccidity":
          "Marchitez / flacides de tallo u hojas",
        "Root Gall (Nematodes)": "Raiz con agallas (Nemátodos)",
        "Base Stem Girdling": "Ahorcamiento de base del tallo",
        "Blight (Chlorosis and/or Shoot Drying)":
          "Tizon (Clorosis y/o secado de brotes)",
        "Growth Retardation": "Retraso de Crecimiento",
        "Root Rot": "Pudricion radicular",
        "Stem Spots": "Manchas en el tallo",
        Healthy: "Sana",
      },
      symp_potato: {
        "Chlorosis (Yellowing)": "Clorosis (Amarillamiento)",
        "Leaf Spots": "Manchas foliares",
        "Wilting / Stem or Leaf Flaccidity":
          "Marchitez / flacides de tallo u hojas",
        "Root Gall (Nematodes)": "Raiz con agallas (Nemátodos)",
        "Base Stem Girdling": "Ahorcamiento de base del tallo",
        "Blight (Chlorosis and/or Shoot Drying)":
          "Tizon (Clorosis y/o secado de brotes)",
        "Growth Retardation": "Retraso de Crecimiento",
        "Root Rot": "Pudricion radicular",
        "Tuber Necrosis / Rot": "Necrocis / Pudricion de tuberculo",
        "Scab / Tuber Scab": "Roña / Sarna Tuberculo",
        "Black Scab Tuber": "Costra Negra tuberculo",
        "Stem Spots": "Manchas en el tallo",
        Healthy: "Sana",
      },
      symp_asparagus: {
        "Chlorosis (Yellowing)": "Clorosis (Amarillamiento)",
        "Dieback (Downward)": "Muerte regresiva (Descendente)",
        "Root Gall (Nematodes)": "Raiz con agallas (Nemátodos)",
        "Blight (Chlorosis and/or Shoot Drying)":
          "Tizon (Clorosis y/o secado de brotes)",
        "Growth Retardation": "Retraso de Crecimiento",
        "Crown Rot": "Pudricion de Corona",
        "Root Rot": "Pudricion radicular",
        "Stem Spots": "Manchas en el tallo",
        "Bud Scaling": "Escamacion de yemas",
        "Purple/Pink Spear Discoloration":
          "Turiones con coloracion morada/rosas",
        Healthy: "Sana",
      },
      moTypes: {
        bacteria: "Bacteria",
        fungi: "Hongo",
        nematode: "Nematodo",
      },
      status_projects: {
        NEW: "Nuevo",
        PROCESSING: "En proceso",
        IN_REVIEW: "En revisión",
        IN_PROGRESS: "En progreso",
        FINISHED: "Finalizado",
        ACCEPTED: "Aceptado",
      },
      miss_test_variants: {
        CONTRAST: "Contraste",
        UNCONTRASTED: "Sin contraste",
        RASTER: "Raster",
      },
      miss_test_variants_setup: {
        CONTRAST: "Control",
        UNCONTRASTED: "Sin control",
      },
      compotition_types: {
        LIQUID: "Líquido",
        SOLID: "Sólido",
      },
      sampleTypeNotGeo: {
        COMPOST: "Composta",
        PRODUCT: "Producto",
        SUBSTRATUM: "Sustrato",
        VEGETABLE: "Vegetal sin georeferencia",
      },
      sampleTypeNotGeoAll: {
        COMPOST: "Composta",
        PRODUCT: "Producto",
        SUBSTRATUM: "Sustrato",
        VEGETABLE: "Vegetal sin georeferencia",
        SOLENA_NO_ADVISOR: "Cliente sin asesor",
      },
      status_profits: {
        ALL: "Todos",
        NEW: "Nuevo",
        PROPOSAL: "Propuesta",
        ACCEPTED: "Aprobada",
        FINISHED: "Finalizada",
      },
      agronomic_managment_title: "Manejo Agronómico",
      crop_name: "Nombre del Cultivo",
      start_cycle: "Inicio del Ciclo",
      end_cycle: "Fin del Ciclo",
      is_organic: "Manejo Orgánico",
      seed_brand: "Marca de la Semilla",
      save: "Guardar",
      hint_date: "Fecha",
      crop_name_list: {
        olive: "Aceituna",
        chard: "Acelga",
        achiote: "Achiote",
        agave: "Agave",
        avocado: "Palta",
        garlic: "Ajo",
        sesame: "Ajonjolí",
        basil: "Albahaca",
        artichoke: "Alcachofa",
        alcatraz: "Alcatraz",
        shrunkenAlfalfa: "Alfalfa achicalada",
        greenAlfalfa: "Alfalfa verde",
        cotton: "Algodón",
        almond: "Almendro",
        birdseed: "Alpiste",
        amaranth: "Amaranto",
        anise: "Anís",
        celery: "Apio",
        blueberry: "Arándano",
        myrtle: "Arrayán",
        rice: "Arroz",
        greenForageOats: "Avena forrajera en verde",
        oatGrain: "Avena grano",
        bamboo: "Bambú",
        eggplant: "Berenjena",
        beetroot: "Betabel",
        broccoli: "Brocoli",
        peanut: "Cacahuate",
        cocoa: "Cacao",
        cherryCoffee: "Café cereza",
        pumpkin: "Calabaza",
        sweetPotato: "Camote",
        sugarCane: "Caña de azúcar",
        canola: "Canola",
        carambolo: "Carambolo",
        safflower: "Cártamo",
        barley: "Cebada",
        greenForageBarley: "Cebada forrajera en verde",
        onion: "Cebolla",
        chives: "Cebollín",
        ryeGrain: "Centeno grano",
        cherry: "Cereza",
        chabacano: "Chabacano",
        pea: "Chícharo",
        squash: "Chayote",
        chia: "Chía",
        chilacayote: "Chilacayote",
        chillyPepper: "Chile / Pimiento",
        custardApple: "Chirimoya",
        coriander: "Cilantro",
        plum: "Ciruela",
        coconutFruit: "Coco fruta",
        cabbage: "Col (repollo)",
        brusselsSprouts: "Col de Bruselas",
        cauliflower: "Coliflor",
        cumin: "Comino",
        chrysanthemum: "Crisantemo (planta)",
        peach: "Durazno",
        date: "Dátil",
        greenBean: "Ejote",
        cornCob: "Elote",
        dill: "Eneldo",
        epazote: "Epazote",
        asparagus: "Espárrago",
        spicesAndMedicinals: "Especias y medicinales",
        spinach: "Espinaca",
        raspberry: "Frambuesa",
        strawberry: "Fresa",
        bean: "Frijol",
        chickpea: "Garbanzo",
        sunflower: "Girasol",
        pomegranate: "Granada",
        soursop: "Guanábana",
        guava: "Guayaba",
        henequen: "Henequén",
        peppermint: "Hierbabuena",
        aromaticHerbs: "Hierbas aromáticas",
        fig: "Higo",
        jamaica: "Jamaica",
        ginger: "Jenjibre",
        jicama: "Jícama",
        lettuce: "Lechuga",
        lentil: "Lenteja",
        lime: "Lima",
        lemon: "Limón",
        linseed: "Linaza",
        litchi: "Litchi",
        corn: "Maíz",
        macadamia: "Macadamia",
        maguey: "Maguey",
        mamey: "Mamey",
        tangerine: "Mandarina",
        mango: "Mango",
        mangosteen: "Mangostán",
        chamomile: "Manzanilla",
        appleTree: "Manzano",
        passionFruit: "Maracuyá",
        daisyFlower: "Margarita",
        marjoram: "Mejorana",
        melon: "Melón",
        quince: "Membrillo",
        mint: "Menta",
        moringa: "Moringa",
        turnip: "Nabo",
        nanche: "Nanche",
        napa: "Napa",
        orange: "Naranja",
        medlar: "Níspero",
        nochebuena: "Nochebuena (planta)",
        walnut: "Nogal",
        noni: "Noni",
        nopal: "Nopal",
        oregano: "Orégano",
        ornamental: "Ornamentales",
        orchid: "Orquídea (planta)",
        oilPalm: "Palma africana o de aceite",
        potato: "Papa",
        papaya: "Papaya",
        grasslands: "Pastizales",
        matGrass: "Pasto tapete (m2)",
        pasturesAndMeadows: "Pastos y praderas",
        cucumber: "Pepino",
        pearTree: "Peral",
        parsley: "Perejil",
        peron: "Perón",
        persimony: "Persimonio",
        pepper: "Pimienta",
        pineapple: "Piña",
        pinion: "Piñón",
        pistache: "Pistache",
        pitaya: "Pitaya",
        banana: "Plátano",
        pore: "Poro",
        radish: "Rábano",
        rambutan: "Rambután",
        romerito: "Romerito",
        rosemary: "Romero",
        aloe: "Sábila",
        watermelon: "Sandía",
        sorghum: "Sorgo",
        soy: "Soya",
        stevia: "Stevia",
        tobacco: "Tabaco",
        tamarind: "Tamarindo",
        tejocote: "Tejocote",
        tomato: "Tomate Rojo (jitomate)",
        greenTomato: "Tomate Verde",
        thyme: "Tomillo",
        grapefruit: "Toronja (pomelo)",
        clover: "Trébol",
        wheat: "Trigo",
        dutchTulip: "Tulipán holandés",
        tuna: "Tuna",
        grape: "Uva",
        vanilla: "Vainilla",
        purslane: "Verdolaga",
        vine: "Vid",
        cassavaFood: "Yuca alimenticia",
        carrot: "Zanahoria",
        sapodilla: "Zapote",
        blackberry: "Zarzamora",
        zempoalxochitl: "Zempoalxochitl",
        fallow: "Barbecho",
        "pecan nut": "Nuez pecana",
        roses: "Rosas",
        "faba bean": "Haba",
        chestnut: "Castaña",
        other: "Otro",
      },
      select_land_use: "Seleccione un uso de suelo",
      select_irrigation_system: "Seleccione un sistema de riego",
      fill_up_fields: "Llene todos los campos",
      agronomic_managment_edit:
        "¿Está seguro de que desea editar el Manejo Agronómico?",
      feacture_no_offline:
        "Esta característica no está disponible sin conexión",
      select_landuse: "Seleccione el uso de suelo",
      select_crop_name: "Seleccione el nombre del cultivo",
      search: "Buscar...",
      irrigation_system_label: "Sistema de Riego",
      management_label: "Manejo",
      organic_label: "Orgánico",
      conventional_label: "Convencional",
      crop_cycle_label: "Ciclo del Cultivo",
      variety_label: "Variedad",
      land_use_title_main: "Uso de suelo:",
      crop_name_title_main: "Nombre del cultivo:",
      sampler_title: "Muestreadores",
      profile_title: "Perfil",
      reviews_title: "Visita técnica",
      title_territory_cordinators: "Territorio:",
      info_table_areas_sampler: "Información de cada área asignada",
      header_table_area: "Área",
      header_table_status_area: "Estado",
      header_table_city: "Ciudad",
      not_technical_visit: "No hay visitas técnicas",
      detail_technical_visit: "Detalle de visita técnica",
      areas_pendings_label: "Pendientes",
      areas_completed_label: "Completadas",
      assign_areas_completed_label: "Completadas",
      not_areas_pending: "No hay áreas pendientes",
      areas_completed: "Completadas",
      areas_pending: "Pendientes",
      update_areas: "Actualizar áreas",
      label_not_technical_visits: "No hay visitas técnicas para mostrar",
      label_last_update: "Última actualización",
      date_not_update: "No actualizado",
      date_not_completed: "Sin fecha",
      detail_area_assign: "Detalle de asignación de área",
      nav_subtitle_area: "Toda la información de las áreas asignadas",
      title_dialog_area_status: "Estado del Área",
      upload_photo_pending: "Tiene fotos pendientes por subir",
      detail_technical_visits: "Detalle de visitas técnicas",
      success_sync_areas: "Áreas sincronizadas exitosamente",
      error_sync_areas: "Error al sincronizar áreas",
      user_not_found: "Usuario no encontrado",
      label_pending_visits: "Visitas pendientes",
      areas_information: "Información",
      areas_completed_user: "Áreas completadas por usuario",
      error_area_upload: "Error al subir información del área",
      error_area_connection: "Error de conexión, intente nuevamente",
      sampling_label: "Muestreo",
      assign_label: "Asignación",
      users_label: "Usuarios",
      nav_completed_visits: "Visitas Completadas",
      nav_assign_areas: "Asignar Áreas",
      areas_assign: "Áreas Asignadas",
      total_areas: "Total de Áreas",
      completed_assignments: "Completadas",
      pendings_assignments: "Pendientes",
      assigned: "Asignado",
      not_assigned: "No Asignado",
      sampling_list: "Lista de Muestreo",
      upload_list: "Lista de Subida",
      uploading: "Subiendo",
      offline_mode: "Modo Sin Conexión",
      online_mode: "Modo Conexión",
      error_upload_area: "Error al subir información del área",
      error_connection: "Error de conexión, intente nuevamente",
      sync_completed: "Sincronización Completada",
      sync_error: "Error de Sincronización",
      uploading_data: "Subiendo datos...",
      updating_data: "Actualizando datos...",
      success_upload: "Subida Exitosa",
      success_update: "Actualización Exitosa",
      error_upload: "Error de Subida",
      error_update: "Error de Actualización",
      no_pending_photos: "No hay fotos pendientes",
      pending_photos: "Fotos pendientes",
      no_upload_errors: "No hay errores de subida",
      upload_errors: "Errores de Subida",
      no_pending_areas: "No hay áreas pendientes",
      pending_areas: "Áreas pendientes",
      areas_to_sync: "Áreas para sincronizar",
      sync_areas: "Sincronizar Áreas",
      areas_synced: "Áreas Sincronizadas",
      no_sync_errors: "No hay errores de sincronización",
      sync_errors: "Errores de Sincronización",
      not_assigned_areas: "Áreas no asignadas",
      assigned_areas: "Áreas asignadas",
      assigned_areas_list: "Lista de áreas asignadas",
      assigned_area_detail: "Detalle del área asignada",
      area_assignments: "Asignaciones de Áreas",
      assign_areas_title: "Asignar Áreas",
      nav_sync_areas: "Sincronizar Áreas",
      area_assignments_list: "Lista de Asignaciones de Áreas",
      area_assignment_detail: "Detalle de Asignación de Área",
      nav_profile: "Perfil",
      profile_information: "Información del Perfil",
      profile_details: "Detalles del Perfil",
      profile_update: "Actualizar Perfil",
      nav_logout: "Cerrar Sesión",
      logout_message: "¿Está seguro que desea cerrar sesión?",
      logout: "Cerrar Sesión",
      cancel: "Cancelar",
      nav_assign_areas: "Asignar Áreas",
      nav_completed_visits: "Visitas Completadas",
      nav_area_assignments: "Asignaciones de Áreas",
      sync_area_title: "Sincronizar Área",
      no_sync_area: "No hay área para sincronizar",
      sync_area: "Sincronizar Área",
      sync_area_detail: "Detalle de Área Sincronizada",
      sync_area_list: "Lista de Áreas Sincronizadas",
      nav_sync: "Sincronizar",
      nav_completed_assignments: "Asignaciones Completadas",
      nav_pending_assignments: "Asignaciones Pendientes",
      nav_total_assignments: "Total de Asignaciones",
      nav_assignments: "Asignaciones",
      nav_sync_areas: "Sincronizar Áreas",
      sync_area_list: "Lista de Áreas Sincronizadas",
      sync_area_detail: "Detalle de Área Sincronizada",
      nav_profile_information: "Información del Perfil",
      profile_details: "Detalles del Perfil",
      profile_update: "Actualizar Perfil",
      profile_edit: "Editar Perfil",
      profile_save: "Guardar Perfil",
      profile_cancel: "Cancelar",
      profile_success: "Perfil Actualizado Exitosamente",
      profile_error: "Error al Actualizar Perfil",
      nav_logout: "Cerrar Sesión",
      logout_message: "¿Está seguro que desea cerrar sesión?",
      logout: "Cerrar Sesión",
      cancel: "Cancelar",
    },
  },
};
